import React, { Fragment, useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  Alert,
  Button,
  Input,
  Radio,
  Modal,
  Form,
  Select,
  Tabs,
  Divider,
  DatePicker,
  Switch,
  Drawer,
  Checkbox,
  InputNumber,
  Spin,
  message,
  notification,
  AutoComplete,
} from "antd";
import {
  SearchOutlined,
  TagOutlined,
  ArrowLeftOutlined,
  UserAddOutlined,
  EditOutlined,
  PhoneOutlined,
  TagsOutlined,
  MailOutlined,
  CaretDownOutlined,
  UserOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  BankOutlined,
  EnvironmentOutlined,
  CreditCardOutlined,
  FolderOpenOutlined,
  ConsoleSqlOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { htmlPrint } from "../../../lib/printer/htmlPrinter";
import { xmlPrint } from "../../../lib/printer/xmlPrinter";
import { Scrollbars } from "react-custom-scrollbars";
import Delete from "../../../assets/images/delete.png";
import CashLogo from "../../../assets/images/cash.png";
import CashLogoWhite from "../../../assets/images/cashWhite.svg";
import closeIcon from "../../../assets/images/closeicon.png";
import closeX from "../../../assets/images/close-x.svg";
import Backspace from "../../../assets/images/backspac.png";
import DropdownCircle from "../../../assets/images/DropdownCircle.png";
import UserSearch from "../../../assets/images/mdi_user-search.svg";
import CircleCloseIcon from "../../../assets/images/remove.svg";
import View from "../../../assets/images/view.svg";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import CustomerIcon from "../../../assets/images/customerIcon.png";
import AspectRatio from "react-aspect-ratio";
import "react-aspect-ratio/aspect-ratio.css";
import { v4 as uuidv4 } from "uuid";
import { useWindowDimensions } from "../../../lib/useViewport";
import "../../style.css";
import "../../globalStyles.css";
import data from "../../../constants/retailPos.json";
import Tick from "../../../assets/images/tick-small.svg";
import _ from "lodash";
import db from "../../../database";
import EditIcon from "../../../assets/images/ri_edit-line.svg";
import removeBg from "../../../assets/images/removebg.png";
import rest from "../../../constants/restaurantPos.json";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import PointOfSuperMarketModals from "../Retail/SuperMarket/SuperMarketModal";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { debounce } from "lodash";
import { getB2BCustomers, validateGSTNumber, validatePANNo, getLoyaltyInfo } from "../../../services/index";
// import { getStates, getCountries } from "../../../services/generic";
import { createCustomer, getCustomer, updateCustomer } from "./customer";
import { triggerFocus } from "antd/lib/input/Input";
const { Option } = Select;
const TabPane = Tabs.TabPane;

const PointOfSaleCoreModals = (props) => {
  const { width } = useWindowDimensions();
  const {
    currentInput,
    setCurrentInput,
    inputValues,
    setInputValues,
    refs,
    paymentModalInputRef,
    customerSearchInputRef,
    displayCustomerSearch,
    closeCustomerSearch,
    setCustomerSearchType,
    customerSearchType,
    handleCustomerSearch,
    customerSearchInput,
    setCustomerSearchResults,
    setCustomerSearchInput,
    customerSearchResults,
    selectCustomer,
    showEditOldCustomerFields,
    showAddNewCustomerFields,
    showAddNewUAECustomerFields,
    setDisplayCustomerSearch,
    displayUAECustomerSearch,
    setDisplayUAECustomerSearch,
    setDisplayAddNewCustomer,
    displayAddNewCustomer,
    form,
    UAECustomerForm,
    addNewCustomer,
    setDisplayEditOldCustomer,
    displayEditOldCustomer,
    editOldCustomer,
    paymentModal,
    tillDataPaymentMethods,
    setSelectedPaymentMethod,
    openPaymentModalByCustomer,
    selectedPaymentMethod,
    cart,
    requestPayment,
    setCouponModalVisible,
    closePaymentModal,
    paymentModalLoyalityMessages,
    amount,
    onChangeAmount,
    processOrder,
    handleAmount,
    currencyType,
    editFlag,
    setEditFlag,
    // Order History Modal //
    displayOrderHistory,
    setDisplayOrderHistory,
    searchOrderHistory,
    showOrderHistory,
    setOrderHistoryInput,
    orderHistoryDetails,
    showOrderHistoryLine,
    selectedOrderHistoryLine,
    isPrintModeXML,
    syncOrders,
    changeOrderHistorySearchType,
    orderHistoryInput,
    paymentModalByCustomerState,
    posConfig,
    // Parked Bill Modal //
    filterdParkedList,
    displayParkedBillModal,
    searchParkedBill,
    handleParkedBillSearchInput,
    parkedBillSearchInput,
    selectParkedBill,
    closeParkedBillModal,
    cashManagementForm,
    handleChangeCurrency,
    roundOffValue,
    orderFlag,
    selectedEditOldCustomer,
    setIsInputFocused,
    displayUAECustomer,
    setDisplayUAECustomer,
    // product addon data
    selectedProduct,
    displayAddOnSelection,
    setDisplayAddOnSelection,
    handleAddOnModalClose,
    handleQty,
    addOnsList,
    handleAddOnValue,
    selectedAddons,
    handleAdd,
    isUpdatingAddon,
    setIsUpdatingAddon,
    handleAddOnModal,
    selectedProductInCart,
    setSelectedProductInCart,
    addDefinedProductWithAddons,
    dynamicForm,
    setDynamicForm,
    dynamicModalForm,
    submitCustomAttributs,
    setKeyboardType,
    keyboardType,
    setOpen,
    open,
    layoutName,
    setLayoutName,
    inputName,
    setInputName,
    keyboardInputFields,
    setKeyboardInputFields,
    keyboard,
    setOpenSalesRep,
    verifyStock,
    searchInputRef,
    customersData,
    setCustomersData,
    showPayments,
    setShowPayments,
    currenciesData,
    setCurrenciesData,
    denaminationsKeyboard,
    setDenaminationsKeyboard,
    handleCashPayment,
    onChangeTotalQuantity,
    selectedCustomer,
    setSelectedCustomer,
    isWalletFlag,
    setIswalletFlag,
    isRefundWalletOpen,
    setIsRefundWalletOpen,
    realPrice,
    setRealPrice,
    setCustomerLoading,
    customerLoading,
    setSelectedAddons,
    customerForm,
    customerConfig,
    customerConfigData,
    retailCustomerTabs,
    retailCustomerFields,
    retailCustomerGroups,
    retailCustomerRules,
    retailCustomerb2bSettings,
    retailCustomerApiDataSources,
    activeTab,
    setActiveTab,
    activeTabName,
    setActiveTabName,
    isB2BEnabled,
    setIsB2BEnabled,
    formDataCache,
    setFormDataCache,
    expandedGroups,
    setExpandedGroups,
    setSelectedEditOldCustomer,
    switchToggle,
    setSwitchToggle,
    isViewMode,
    setIsViewMode,
    toCamelCaseMetaData,
    convertMetaDataToKeyValue,
    viewCustomerValues,
    setViewCustomerValues,
    isSubmittingCustomer,
    setIsSubmittingCustomer,
    lastSearchedValue,
    setLastSearchedValue,
    selectedB2BCustomer,
    setSelectedB2BCustomer,
    customerSearchTrigger,
    setCustomerSearchTrigger,
    setKioskUI,
    kioskLogin,
    loading,
    setLoading,
    isPanCustomer,
    setIsPanCustomer,
    panCustomerInfo,
    setPanCustomerInfo,
    documents,
    setDocuments,
    pendingRefundCustomer,
    setPendingRefundCustomer,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
  } = props;

  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const registrationTypes = JSON.parse(localStorage.getItem("registrationTypes"));
  const [toggleCustomer, setToggleCustomer] = useState(false);
  const [loyalityType, setLoyalityType] = useState([]);
  const [enableLoyality, setEnableLoyality] = useState(true);
  const [addonQty, setAddonQty] = useState({});
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;

  const [optionsMap, setOptionsMap] = useState({});
  // 🟢 Step 3: States
  const [b2bSearchResults, setB2bSearchResults] = useState([]);
  const [b2bLoading, setB2bLoading] = useState(false);
  const [selectedInvoiceAddress, setSelectedInvoiceAddress] = useState(null);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
  const [invoiceAddressList, setInvoiceAddressList] = useState([]);
  const [deliveryAddressList, setDeliveryAddressList] = useState([]);
  const isLocked = useRef(false);
  const latestSearch = useRef("");
  const abortController = useRef(null);
  const [searchByName, setSearchByName] = useState(false);
  const [noB2BResults, setNoB2BResults] = useState(false);
  const [showB2BDropdown, setShowB2BDropdown] = useState(false);
  const searchContainerRef = useRef(null);
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  const [isPanUpdateMode, setIsPanUpdateMode] = useState(false);
  const isRefundEdit = localStorage.getItem("refundCustomerEdit") === "Y";
  const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const layout = userAccessController.layout;
  const iconMap = {
    user: <UserOutlined />,
    info: <InfoCircleOutlined />,
    building: <BankOutlined />,
    location: <EnvironmentOutlined />,
    payment: <CreditCardOutlined />,
    folder: <FolderOpenOutlined />,
  };

  useEffect(() => {
    const getvalues = customerForm.getFieldsValue();
  }, [displayAddNewCustomer, displayEditOldCustomer]);

  useEffect(() => {
    form.setFieldsValue(inputValues);
  }, [inputValues]);

  useEffect(() => {
    UAECustomerForm.setFieldsValue(inputValues);
  }, [inputValues]);

  useEffect(() => {
    if (displayCustomerSearch || displayUAECustomerSearch) {
      setTimeout(() => {
        customerSearchInputRef.current.focus();
      }, 100);
    }
  }, [displayCustomerSearch, displayUAECustomerSearch]);

  const orderHistorySearchInputRef = useRef();
  useEffect(() => {
    if (displayOrderHistory) {
      setTimeout(() => {
        orderHistorySearchInputRef?.current?.focus();
      }, 100);
    }
  }, [displayOrderHistory, changeOrderHistorySearchType]);

  const paymentCardRef = useRef();

  useEffect(() => {
    if (paymentModal) {
      setTimeout(() => {
        paymentModalInputRef?.current?.focus();
      }, 100);
    }
  }, [paymentModal, selectedPaymentMethod]);

  const handleKey = (e) => {
    const { keyCode } = e;
    if (keyCode === 37) {
      paymentCardRef?.current?.focus();
    }
    if (keyCode === 46) {
      if (paymentModalActiveRef.current) {
        deleteAmountOnCart();
      }
    }
  };

  useEffect(async () => {
    let loyaliryData = await db.loyalityData.toArray();
    loyaliryData.map((item) => {
      if (item.isDefault === "Y") {
        setLoyalityType([item]);
      }
    });
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  const deleteAmountOnCart = () => {
    const pmName = document.activeElement.firstChild.firstChild.firstChild.firstChild.firstChild.firstChild.firstChild.children[1].innerHTML;
    const iN = cartForPaymentRef.current.payments.findIndex((paymentMade) => paymentMade.name === pmName);
    requestPayment(cartForPaymentRef.current.payments[iN], -cartForPaymentRef.current.payments[iN].amount, "allow");
  };

  const cartForPaymentRef = useRef();
  useEffect(() => {
    cartForPaymentRef.current = cart;
  }, [cart]);

  const paymentModalActiveRef = useRef();
  useEffect(() => {
    paymentModalActiveRef.current = paymentModal;
  }, [paymentModal]);

  useEffect(() => {
    if (selectedAddons.length > 0) {
      handleAdd();
    }
  }, [selectedAddons]);

  useEffect(() => {
    if (displayAddOnSelection && addOnsList?.optionsList?.length) {
      // init all qtys to 0 (only when modal opens)
      const init = Object.fromEntries(addOnsList.optionsList.map((a) => [a.mProductAddOnId, 0]));
      setAddonQty(init);
    }
  }, [displayAddOnSelection, addOnsList]);

  const getGroupItems = (groupName) => {
    if (!addOnsList?.optionsList) return [];
    return addOnsList.optionsList.filter((addon) => (addon.mAddonGroup && addon.mAddonGroup.name) === groupName);
  };

  const getGroupTotalQty = (groupName) => {
    const items = getGroupItems(groupName);
    return items.reduce((t, item) => t + (Number(addonQty[item.mProductAddOnId]) || 0), 0);
  };

  const validateAddonSelection = async () => {
    // 1. If no addons at all → ADD PRODUCT IMMEDIATELY
    if (!addOnsList?.optionsList?.length) {
      setSelectedAddons([]);
      await handleAdd();
      return;
    }

    // 2. Group add-ons by group name
    const groups = _.groupBy(addOnsList.optionsList, (item) => item?.mAddonGroup?.name);

    // 3. Check: Are ALL groups minQty = 0?
    const allGroupsHaveMinQtyZero = Object.values(groups).every((groupItems) => {
      const min = Number(groupItems[0].mAddonGroup?.minqty || 0);
      return min === 0;
    });

    // 4. Build selected addons FIRST (for ALL cases)
    const selected = [];
    Object.entries(addonQty).forEach(([id, qty]) => {
      if (qty > 0) {
        const addonData = addOnsList.optionsList.find((a) => a.mProductAddOnId === id);
        if (addonData) {
          selected.push({ ...addonData, qty });
        }
      }
    });

    // 5. WHEN minQty = 0 FOR ALL GROUPS → ADD PRODUCT IMMEDIATELY
    if (allGroupsHaveMinQtyZero) {
      setSelectedAddons(selected); // ✅ Set selected addons
      // ✅ CALL handleAdd WITHOUT clearing inside validateAddonSelection
      await addDefinedProductWithAddons(
        {
          ...selectedProduct,
          sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
          selectedAddons: selected, // ✅ PASS selected DIRECTLY
        },
        selectedProduct.upc,
        null,
        null,
        selectedProduct.sunitprice,
        false
      );

      // ✅ Clean up AFTER adding
      setDisplayAddOnSelection(false);
      setSelectedAddons([]);
      //setFilterDrawer(false);
      return;
    }

    // 6. VALIDATE REQUIRED GROUPS ONLY (minQty > 0)
    for (const groupName in groups) {
      const groupItems = groups[groupName];
      const groupInfo = groupItems[0].mAddonGroup;
      const min = Number(groupInfo.minqty || 0);

      if (min === 0) continue; // Skip optional groups

      const max = Number(groupInfo.maxqty || Infinity);
      const allowQty = groupInfo.allowQtySelection === "Y";
      const total = groupItems.reduce((sum, item) => sum + (Number(addonQty[item.mProductAddOnId]) || 0), 0);

      if (total < min) {
        return message.error(allowQty ? `Please select total quantity of at least ${min} for ${groupName}` : `Please select at least ${min} options in ${groupName}`);
      }

      if (total > max) {
        return message.error(allowQty ? `You can select only total quantity of ${max} for ${groupName}` : `You can select only ${max} options in ${groupName}`);
      }
    }

    // 7. All validations passed → Use ORIGINAL FLOW
    setSelectedAddons(selected); // ✅ Set state
    // Let user click button → handleAdd() will use selectedAddons
  };

  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      backgroundColor: "#c1c1c1",
      borderRadius: "5px",
      width: "8px",
    };
    // setLoading(false);
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const renderThumbHorizontalScroll = ({ style, ...props }) => {
    const thumbStyle = {
      // backgroundColor: "#c1c1c1",
      // borderRadius: "5px",
      width: "0px",
    };
    // setLoading(false);
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const renderView = ({ style, ...props }) => {
    const viewStyle = {
      color: "#00000",
    };
    return <div className="box" style={{ ...style, ...viewStyle }} {...props} />;
  };

  const addCustomer = () => {
    customerForm
      .validateFields()
      .then((values) => {
        if (values.name !== undefined) addNewCustomer(values);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const editCustomer = () => {
    form
      .validateFields()
      .then((values) => {
        // Validation passed, proceed with updating the customer
        editOldCustomer(values);
        if (searchInputRef?.current) {
          searchInputRef.current.focus();
        }
      })
      .catch((errorInfo) => {
        // Validation failed, show error message
        console.log("Validation Failed:", errorInfo);
      });
  };
  const onSwitchChange = (checked) => {
    form.setFieldsValue({ loyality: checked });
    setKeyboardInputFields({ ...keyboardInputFields, loyalty: checked });
    setEnableLoyality(checked);
  };

  const cancelDynamicModal = () => {
    setDynamicForm(false);
    setSelectedProductInCart({});
    dynamicModalForm.resetFields();
  };

  const handleSubmit = () => {
    dynamicModalForm
      .validateFields()
      .then((values) => {
        const formattedValues = Object.entries(values).reduce((acc, [key, value]) => {
          // Check if the value is a moment object (date)
          if (value && value._isAMomentObject) {
            // Format the date as DD-MM-YYYY
            acc[key] = value.format("DD-MM-YYYY");
          } else {
            acc[key] = value;
          }
          return acc;
        }, {});

        if (selectedProductInCart.customAttributes) {
          selectedProductInCart.customAttributes.map((item) => {
            if (item.type === "TXT") {
              selectedProductInCart.customText = formattedValues[item.name];
            }
          });
        }
        setDynamicForm(false);
        selectedProductInCart.newCustomAttributes = [formattedValues];
        selectedProductInCart.qty = 1;
        submitCustomAttributs(selectedProductInCart);
        dynamicModalForm.resetFields();
      })
      .catch((errorInfo) => {
        console.log("Validate Failed:", errorInfo);
      });
  };

  const increaseAddonQty = (id, groupName) => {
    // guard
    if (!addOnsList?.optionsList) return;
    const groupItems = getGroupItems(groupName);
    if (!groupItems.length) {
      console.warn("increaseAddonQty: groupItems empty for", groupName);
    }

    const maxqty = Number(groupItems[0]?.mAddonGroup?.maxqty) || Infinity;
    const total = getGroupTotalQty(groupName);

    if (total >= maxqty) {
      message.error(`You can select only ${maxqty} items for ${groupName}`);
      return;
    }

    setAddonQty((prev) => {
      const next = { ...prev, [id]: (Number(prev[id]) || 0) + 1 };
      return next;
    });
  };

  const decreaseAddonQty = (id) => {
    setAddonQty((prev) => {
      const current = Number(prev[id]) || 0;
      const nextVal = Math.max(current - 1, 0);
      const next = { ...prev, [id]: nextVal };
      return next;
    });
  };

  // Render form items based on field type
  const renderFormItem = (field) => {
    const { name, type, defaultValue, values } = field;

    switch (type) {
      case "STR":
        return <Input defaultValue={defaultValue} style={{ width: "30vw" }} />;
      case "TXT":
        return <TextArea defaultValue={defaultValue} style={{ width: "30vw" }} />;
      case "DAT":
        return <DatePicker format={"DD-MM-YYYY"} />;
      case "NUM":
        return <InputNumber defaultValue={defaultValue} />;
      case "LST":
        return (
          <Select defaultValue={defaultValue} className="attribute" style={{ width: "30vw", border: "1px solid #d9d9d9" }}>
            {values?.split(",").map((item) => (
              <Select.Option key={item} value={item}>
                {item}
              </Select.Option>
            ))}
          </Select>
        );
      case "YEN":
        return (
          <Radio.Group defaultValue={defaultValue}>
            <Radio value="Y">Yes</Radio>
            <Radio value="N">No</Radio>
          </Radio.Group>
        );
      default:
        return null;
    }
  };

  const onFocusInput = (fieldName) => {
    setInputName(fieldName);
    setOpen(true);

    setTimeout(() => {
      const currentInputValue = keyboardInputFields[fieldName] || "";
      keyboard?.current?.setInput(currentInputValue);
    }, 300);
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setKeyboardInputFields({
      ...keyboardInputFields,
      [inputName]: inputVal,
    });

    keyboard?.current?.setInput(inputVal);
  };

  const getInputValue = (inputName) => {
    return keyboardInputFields[inputName] || "";
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && displayCustomerSearch) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      document.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [displayCustomerSearch]);

  const groupedFields = (() => {
    const grouped = retailCustomerGroups
      .filter((group) => group.tabId === activeTab && group.visible)
      .sort((a, b) => a.order - b.order)
      .map((group) => {
        const fieldsInGroup = retailCustomerFields
          .filter((field) => {
            const isVisible = field.visible;
            const isCurrentTab = field.tabId === activeTab;
            const isBusinessTab = activeTabName.toLowerCase() === "business";
            const allowBusinessFields = !isBusinessTab || (isBusinessTab && isB2BEnabled);
            const isInGroup = field.groupId === group.id;

            return isVisible && isCurrentTab && allowBusinessFields && isInGroup;
          })
          .sort((a, b) => a.order - b.order);

        return {
          groupId: group.id,
          groupName: group.name || "",
          fields: fieldsInGroup,
          collapsible: group.collapsible,
          defaultExpanded: group.defaultExpanded,
          description: group.description,
        };
      });

    // Handle ungrouped fields
    const ungroupedFields = retailCustomerFields
      .filter((field) => {
        const isVisible = field.visible;
        const isCurrentTab = field.tabId === activeTab;
        const isBusinessTab = activeTabName.toLowerCase() === "business";
        const allowBusinessFields = !isBusinessTab || (isBusinessTab && isB2BEnabled);
        const isUngrouped = !field.groupId;

        return isVisible && isCurrentTab && allowBusinessFields && isUngrouped;
      })
      .sort((a, b) => a.order - b.order);

    if (ungroupedFields.length > 0) {
      grouped.unshift({
        groupId: "",
        groupName: "",
        fields: ungroupedFields,
        collapsible: false,
        defaultExpanded: true,
        description: "",
      });
    }

    // if (ungroupedFields.length > 0) {
    //   grouped.unshift({
    //     groupId: "__ungrouped__", // 👈 important (stable id)
    //     groupName: "", // no heading
    //     fields: ungroupedFields,
    //     collapsible: false,
    //     defaultExpanded: true,
    //     description: "",
    //   });
    // }

    return grouped.filter((group) => group.fields.length > 0);
  })();

  const originalConfirm = Modal.confirm;
  Modal.confirm = function (config) {
    return originalConfirm({
      ...config,
      okButtonProps: config.okButtonProps || { style: { display: "none" } },
    });
  };

  const renderConditionalRule = () => {
    const panRule = customerConfigData?.conditionalRules?.find((rule) => rule.action === "Request PAN");

    if (panRule && cart?.total > parseFloat(panRule.value)) {
      return (
        <Alert
          message={
            <span>
              <p
                style={{
                  color: "#B45309",
                  fontSize: "14px",
                  fontWeight: 300,
                  marginBottom: 0,
                  marginLeft: "0.8vw",
                }}
              >
                • {panRule.description}
              </p>
            </span>
          }
          type="warning"
          showIcon
          icon={<WarningOutlined style={{ color: "#0F0718" }} />}
          style={{
            backgroundColor: "#fff8f0",
            borderColor: "#ffecb5",
            color: "#b26a00",
            fontWeight: 500,
            width: "100%",
            borderRadius: "5px",
            height: "7vh",
            marginTop: "1.5vh",
            marginBottom: "1.5vh",
          }}
        />
      );
    }

    return null;
  };

  const renderScrollHeight = () => {
    return cart?.total > parseFloat(customerConfigData?.conditionalRules[0]?.value);
  };

  const searchB2BCustomers = useMemo(
    () =>
      debounce(async (value) => {
        latestSearch.current = value;

        // Empty input — clear results
        if (!value.trim()) {
          if (abortController.current) abortController.current.abort();
          setB2bSearchResults([]);
          setB2bLoading(false);
          return;
        }

        // Abort previous search
        if (abortController.current) abortController.current.abort();
        const controller = new AbortController();
        abortController.current = controller;

        setB2bLoading(true);
        setB2bSearchResults([]); // clear previous results

        try {
          const queryValue = searchByName
            ? value.trim() // name search
            : value.trim().toUpperCase();
          const resp = await getB2BCustomers({ q: queryValue, startRow: "0", endRow: "20" }, { signal: controller.signal });

          // const customers = resp?.data?.getB2BCustomers?.customers || [];

          // if (latestSearch.current !== value) {
          //   return;
          // }

          // setB2bSearchResults(customers);

          const customers = resp?.data?.getB2BCustomers?.customers || [];

          if (latestSearch.current !== value) return;

          setB2bSearchResults(customers);
          setNoB2BResults(customers.length === 0);
          if (customers.length === 0) {
            const trimmedValue = value.trim();
            if (!trimmedValue) return;

            const autoFillValues = {};

            groupedFields.forEach((group) => {
              group.fields.forEach((field) => {
                const fieldName = field.name.toLowerCase();

                // Search by NAME → fill Company Name
                if (searchByName && fieldName === "company name") {
                  if (group.groupId) {
                    autoFillValues[group.groupId] = {
                      ...(autoFillValues[group.groupId] || {}),
                      [field.name]: trimmedValue,
                    };
                  } else {
                    autoFillValues[field.name] = trimmedValue;
                  }
                }

                // Search by GST → fill GST No
                if (!searchByName && fieldName.includes("gst")) {
                  if (group.groupId) {
                    autoFillValues[group.groupId] = {
                      ...(autoFillValues[group.groupId] || {}),
                      [field.name]: trimmedValue.toUpperCase(),
                    };
                  } else {
                    autoFillValues[field.name] = trimmedValue.toUpperCase();
                  }
                }
              });
            });
            customerForm.setFieldsValue(autoFillValues);
            setFormDataCache((prev) => ({
              ...prev,
              [activeTab]: {
                ...(prev[activeTab] || {}),
                ...autoFillValues,
              },
            }));
          }
        } catch (err) {
          if (err.name === "AbortError") {
          } else {
            console.error("SEARCH ERROR →", err);
          }
        } finally {
          setB2bLoading(false);
        }
      }, 300),
    [searchByName]
  );

  const flattenObject = (obj, prefix = "", res = {}) => {
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        flattenObject(obj[key], `${prefix}${key}.`, res);
      } else {
        res[`${prefix}${key}`] = obj[key];
      }
    }
    return res;
  };
  const mapB2BDataDynamic = (customer, groupedFields, isAddMode = false) => {
    const flatCustomer = flattenObject(customer);

    const formValues = {};

    const safeJoin = (...parts) => parts.filter(Boolean).join(", ").trim();

    const toCamelCase = (str) =>
      str
        .trim()
        .replace(/[^a-zA-Z0-9 ]/g, " ")
        .split(" ")
        .map((word, index) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
        .join("");

    groupedFields.forEach((group) => {
      const groupId = group.groupId ? String(group.groupId) : null;
      const groupNameLower = group.groupName?.toLowerCase() || "";

      const isInvoiceGroup = groupNameLower.includes("invoice") || groupNameLower.includes("invoicing");
      const isDeliveryGroup = groupNameLower.includes("delivery");

      const address = isInvoiceGroup ? customer.invoiceAddresses?.[0] : isDeliveryGroup ? customer.deliveryAddresses?.[0] : null;

      const matchingLoc = address ? customer.localisation?.find((l) => l.addressId === address.s_customer_address_id) : customer.localisation?.[0] || null;

      group.fields.forEach((field) => {
        if (!field.visible || !field.tabId) return;

        const rawLabel = field.name || "";
        const labelTrimmed = rawLabel.trim();
        const key = labelTrimmed.toLowerCase();
        const fieldKey = toCamelCase(labelTrimmed);

        let value = null;

        if (address && (isInvoiceGroup || isDeliveryGroup)) {
          if (key.includes("street")) {
            value = safeJoin(address.line1, address.line2);
          } else if (key.includes("city")) {
            value = address.city || "";
          } else if (key.includes("state") || key.includes("region")) {
            value = address.regionName || "";
          } else if (key.includes("country")) {
            value = address.countryName || "";
          } else if (key.includes("pincode") || key.includes("zip") || key.includes("postal")) {
            value = address.pincode || "";
          } else if (key.includes("gst") && matchingLoc) {
            value = matchingLoc.gstType || "";
          } else if (key.includes("company type") || (key.includes("company") && key.includes("type"))) {
            value = matchingLoc?.companyType || "";
          }
        } else {
          if (key.includes("customer code")) {
            value = customer.customerCode || "";
          } else if (key.includes("customer name")) {
            value = customer.customerName || "";
          } else if (key.includes("tax") && key.includes("id")) {
            value = customer.taxId || "";
          } else if (key === "company name" || key.includes("company name")) {
            value = customer.companyName || "";
          } else if (key === "gst no" || key.includes("gst no")) {
            value = customer.gstNo || customer.localisation?.[0]?.gstNo || "";
          } else if (key.includes("company name") || (key.includes("company") && !key.includes("type"))) {
            value = matchingLoc?.companyType || customer.localisation?.[0]?.companyType || "";
          }
        }

        if (value !== null && value !== undefined && value !== "") {
          if (groupId) {
            formValues[groupId] = formValues[groupId] || {};
            // 🧠 Set both exact and trimmed keys for reliability
            formValues[groupId][rawLabel] = value;
            if (rawLabel !== labelTrimmed) {
              formValues[groupId][labelTrimmed] = value;
            }
            formValues[groupId][fieldKey] = value;
          } else {
            formValues[rawLabel] = value;
            if (rawLabel !== labelTrimmed) {
              formValues[labelTrimmed] = value;
            }
            formValues[fieldKey] = value;
          }
        }
      });
    });

    // 🧩 ADD MODE flattening
    if (isAddMode) {
      const flattened = {};
      Object.entries(formValues).forEach(([groupId, fields]) => {
        if (typeof fields === "object" && fields !== null) {
          Object.entries(fields).forEach(([label, val]) => {
            flattened[[groupId, label]] = val;
          });
        } else {
          flattened[groupId] = fields;
        }
      });
      return flattened;
    }
    return formValues;
  };

  const fillAddressFields = (address, groupOrId, type, customer) => {
    // Guard
    if (!address || !groupOrId) return;

    // Normalize groupId: accept either group object or groupId primitive
    const groupId = typeof groupOrId === "object" ? groupOrId.groupId : groupOrId;
    if (!groupId && groupId !== 0) return;

    // Helpers
    const safe = (v) => (v === undefined || v === null ? "" : v);
    const toCamel = (str) =>
      String(str || "")
        .replace(/[^a-zA-Z0-9 ]/g, " ")
        .trim()
        .split(/\s+/)
        .map((w, i) => (i === 0 ? w.toLowerCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
        .join("");

    const trimLabel = (s) => String(s || "").trim();

    // Find localisation entry for this address if available
    const loc = customer?.localisation?.find((l) => l.addressId === address.s_customer_address_id) || {};

    // Raw values (labels used in Add Customer mode in your code)
    const rawToValue = {
      "Street Address": `${safe(address.line1)}${address.line2 ? ", " + safe(address.line2) : ""}`,
      City: safe(address.city),
      State: safe(address.regionName),
      Country: safe(address.countryName),
      Pincode: safe(address.pincode),
      "GST Type": safe(loc.gstType),
      "Company Type": safe(loc.companyType),
      "GST Number": safe(loc.gstNo),
      "Pan Number": safe(loc.panNo),
    };

    // Build variant keys for group and field names
    const groupVariants = new Set();
    groupVariants.add(groupId);
    groupVariants.add(String(groupId));
    groupVariants.add(String(groupId).toLowerCase());
    // if groupId looks numeric, also add Number(groupId)
    if (!Number.isNaN(Number(groupId))) groupVariants.add(Number(groupId));

    // Build the fields object for each group variant
    const fieldsPayload = {}; // shape for setFieldsValue

    // We'll also construct a canonical object to update cache under canonicalGroupKey (string)
    const canonicalGroupKey = String(groupId);

    // Build combined object used for cache (use camelCase + raw both for safety)
    const canonicalForCache = {};

    Object.entries(rawToValue).forEach(([rawLabel, val]) => {
      const trimmed = trimLabel(rawLabel);
      const camel = toCamel(trimmed);

      // Add to canonical cache object using both raw and camel (so the rest of your logic can read either)
      canonicalForCache[rawLabel] = val;
      if (trimmed !== rawLabel) canonicalForCache[trimmed] = val;
      canonicalForCache[camel] = val;

      // For each group variant, set a nested object with both field variants
      groupVariants.forEach((gKey) => {
        const gKeyStr = gKey; // could be number or string - setFieldsValue accepts either

        // ensure object exists
        if (!fieldsPayload[gKeyStr]) fieldsPayload[gKeyStr] = {};

        // set multiple field keys so whichever Form.Item name exists will pick it up
        fieldsPayload[gKeyStr][rawLabel] = val; // raw label
        fieldsPayload[gKeyStr][trimmed] = val; // trimmed label
        fieldsPayload[gKeyStr][camel] = val; // camelCase label
      });
    });

    // Finally call setFieldsValue once with the whole payload
    // Note: this updates all group variants (string/number/lowercase) so all Form.Item name shapes are covered
    try {
      customerForm.setFieldsValue(fieldsPayload);
    } catch (err) {
      // defensive: if setFieldsValue throws for some reason, fallback to per-key set
      Object.entries(fieldsPayload).forEach(([gKey, obj]) => {
        customerForm.setFieldsValue({ [gKey]: { ...(customerForm.getFieldValue(gKey) || {}), ...obj } });
      });
    }

    // Update cached form data under canonicalGroupKey (string)
    setFormDataCache((prev) => ({
      ...prev,
      [activeTab]: {
        ...(prev[activeTab] || {}),
        [canonicalGroupKey]: {
          ...(prev[activeTab]?.[canonicalGroupKey] || {}),
          ...canonicalForCache,
        },
      },
    }));
  };

  const toCamelCaseb2b = (str) => str.replace(/[^a-zA-Z0-9 ]/g, "").replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => (index === 0 ? match.toLowerCase() : match.toUpperCase()));

  useEffect(() => {
    const initState = {};
    groupedFields.forEach((group) => {
      if (group.collapsible) {
        // initState[group.groupId] = group.defaultExpanded;
        initState[group.groupId] = false;
      }
    });
    setExpandedGroups(initState);
  }, [activeTab]);

  const getStaticDisplayValue = (field, savedKey) => {
    if (!field || !field.defaultValue || !savedKey) return "";

    try {
      const parsed = JSON.parse(field.defaultValue);
      return parsed[savedKey] || savedKey;
    } catch {
      return savedKey;
    }
  };

  // const handleChange = (e, field, groupId) => {
  //   const value = e?.target?.value ?? e;

  //   setFormDataCache((prev) => {
  //     const tabData = prev[activeTab] || {};

  //     let newTabData;

  //     if (!groupId) {
  //       newTabData = {
  //         ...tabData,
  //         [field.name]: value,
  //       };
  //     } else {
  //       newTabData = {
  //         ...tabData,
  //         [groupId]: {
  //           ...(tabData[groupId] || {}),
  //           [field.name]: value,
  //         },
  //       };
  //     }
  //     const currentNameValue = newTabData.Name ?? customerForm.getFieldValue("Name") ?? "";
  //     const firstName = newTabData["First Name"] || "";
  //     const middleName = newTabData["Middle Name"] || "";
  //     const lastName = newTabData["Last Name"] || "";

  //     if ((field.name === "First Name" || field.name === "Middle Name" || field.name === "Last Name") && !currentNameValue.trim()) {
  //       const fullName = [firstName, middleName, lastName].filter(Boolean).join(" ");
  //       customerForm.setFieldsValue({ Name: fullName });
  //       setKeyboardInputFields((prevKeys) => ({
  //         ...prevKeys,
  //         Name: fullName,
  //       }));
  //       newTabData = {
  //         ...newTabData,
  //         Name: fullName,
  //       };
  //     }

  //     return {
  //       ...prev,
  //       [activeTab]: newTabData,
  //     };
  //   });
  // };

  const handleChange = (e, field, groupId) => {
    const value = e?.target?.value ?? e;
    const fieldKey = toCamelCase(field.name);
    const groupKey = groupId ? String(groupId).toLowerCase() : null;

    setFormDataCache((prev) => {
      const tabData = prev[activeTab] || {};

      let newTabData;

      // 🔹 Update current field
      if (!groupKey) {
        newTabData = {
          ...tabData,
          [fieldKey]: value,
        };
      } else {
        newTabData = {
          ...tabData,
          [groupKey]: {
            ...(tabData[groupKey] || {}),
            [fieldKey]: value,
          },
        };
      }

      // 🔹 Get first/middle/last safely (respect group structure)
      const groupData = groupKey ? newTabData[groupKey] || {} : newTabData;

      const firstName = groupData[toCamelCase("First Name")] || "";
      const middleName = groupData[toCamelCase("Middle Name")] || "";
      const lastName = groupData[toCamelCase("Last Name")] || "";
      const currentNameValue = groupData[toCamelCase("Name")] || "";

      // 🔹 Auto-build full name only if Name is empty
      if (field.name === "First Name" || field.name === "Middle Name" || field.name === "Last Name") {
        const fullName = [firstName, middleName, lastName].filter(Boolean).join(" ");

        if (groupKey) {
          // Update AntD form
          customerForm.setFieldsValue({
            [groupKey]: {
              ...customerForm.getFieldValue(groupKey),
              [toCamelCase("Name")]: fullName,
            },
          });

          // Update cache (important for re-render)
          newTabData = {
            ...newTabData,
            [groupKey]: {
              ...(newTabData[groupKey] || {}),
              [toCamelCase("Name")]: fullName,
            },
          };
        } else {
          customerForm.setFieldsValue({
            [toCamelCase("Name")]: fullName,
          });

          newTabData = {
            ...newTabData,
            [toCamelCase("Name")]: fullName,
          };
        }

        setKeyboardInputFields((prevKeys) => ({
          ...prevKeys,
          [toCamelCase("Name")]: fullName,
        }));
      }

      return {
        ...prev,
        [activeTab]: newTabData,
      };
    });
  };

  const normalizeKey = (str = "") => str.toLowerCase().replace(/[^a-z0-9]/g, ""); // remove spaces & symbols

  // const mapApiResponseToFormFields = (apiResponse, groupedFields, activeTab) => {
  //   const mappedValues = {};

  //   if (!apiResponse) return mappedValues;

  //   // Build normalized lookup from API response
  //   const apiLookup = {};
  //   Object.keys(apiResponse).forEach((key) => {
  //     apiLookup[normalizeKey(key)] = apiResponse[key];
  //   });

  //   groupedFields.forEach((group) => {
  //     group.fields.forEach((field) => {
  //       // if (field.tabId !== activeTab) return;

  //       const fieldName = field.name?.trim();
  //       if (!fieldName) return;

  //       const normalizedFieldKey = normalizeKey(fieldName);

  //       const matchedValue = apiLookup[normalizedFieldKey];

  //       if (matchedValue === undefined || matchedValue === null) return;

  //       if (group.groupId) {
  //         mappedValues[group.groupId] = mappedValues[group.groupId] || {};
  //         mappedValues[group.groupId][field.name] = matchedValue;
  //       } else {
  //         mappedValues[field.name] = matchedValue;
  //       }
  //     });
  //   });

  //   return mappedValues;
  // };

  const mapApiResponseToFormFields = (apiData, groupedFields) => {
    const mappedValues = {};
    if (!apiData) return mappedValues;

    const lookup = {};

    const addToLookup = (obj) => {
      Object.keys(obj || {}).forEach((key) => {
        const value = obj[key];
        if (value === null || value === undefined) return;
        lookup[normalizeKey(key)] = value;
      });
    };

    addToLookup(apiData);

    Object.keys(apiData).forEach((key) => {
      if (/^group_\d+$/.test(key) && typeof apiData[key] === "object") {
        addToLookup(apiData[key]);
      }
    });

    groupedFields.forEach((group) => {
      group.fields.forEach((field) => {
        const normalizedField = normalizeKey(field.name);
        const value = lookup[normalizedField];

        if (value === undefined) return;

        const fieldKey = toCamelCase(field.name);

        if (field.type === "select" && field.dataSource?.type === "static" && field.defaultValue) {
          value = normalizeStaticSelectValue(value, field.defaultValue);
        }

        if (group.groupId) {
          mappedValues[group.groupId] = mappedValues[group.groupId] || {};
          mappedValues[group.groupId][fieldKey] = value;
        } else {
          mappedValues[fieldKey] = value;
        }
      });
    });

    return mappedValues;
  };

  const handleApiEnterValidation = async (e, field) => {
    if (e.key !== "Enter") return;
    if (field?.dataSource?.type !== "api") return;

    const apiConfig = retailCustomerApiDataSources.find((api) => api.id === field.dataSource.apiSourceId);

    if (!apiConfig || apiConfig.endpoint !== "validatePANNumber") {
      return;
    }

    const pan = e.target.value?.trim();
    if (!pan) return;

    setLoading(true);

    try {
      /** 1️⃣ Search existing customer */
      const searchResponse = await getCustomer(
        form,
        tillLayout,
        pan,
        setKioskUI,
        setCustomerSearchResults,
        kioskLogin,
        tillData,
        pendingRefundCustomer,
        setPendingRefundCustomer,
        isRefundCustomerEdit,
        setIsRefundCustomerEdit
      );
      const existingCustomers = searchResponse?.data?.data?.customerSearch || [];
      const isExistingCustomer = existingCustomers.length > 0;

      /** 2️⃣ Validate PAN */
      // const panValidation = await validatePANNo(pan);

      // const isPanActuallyValid = panValidation?.valid === true && panValidation?.isValid === true && panValidation?.aadhaarSeedingStatusCode !== null;
      // const realStatus =
      //   panValidation?.isBusiness === true
      //     ? "OPERATIVE"
      //     : panValidation?.valid === true && panValidation?.isValid === true
      //       ? panValidation?.aadhaarSeedingStatusCode === "Y"
      //         ? "OPERATIVE"
      //         : "INOPERATIVE"
      //       : "INVALID PAN";

      // setPanCustomerInfo({
      //   panNo: panValidation.panNo,
      //   panStatus: panValidation.panStatus,
      //   aadhaarSeedingStatusCode: panValidation.aadhaarSeedingStatusCode,
      //   isValid: panValidation.isValid,
      //   realStatus,
      // });
      const panValidation = await validatePANNo(pan);

      // Map for PAN statuses where billing must be disabled
      const disabledPanStatusMap = {
        N: "INVALID PAN",
        I: "PAN INOPERATIVE",
        X: "PAN DEACTIVATED",
        F: "FAKE PAN",
        D: "PAN DELETED",
        EA: "PAN AMALGAMATION",
        EC: "PAN ACQUISITION",
        ED: "DEATH OF PAN HOLDER",
        EI: "PAN DISSOLVED",
        EL: "PAN LIQUIDATED",
        EM: "PAN MERGER",
        EP: "PAN PARTITION",
        ES: "PAN SPLIT",
        EU: "PAN UNDER LIQUIDATION",
      };

      let realStatus = "INVALID PAN";
      let isPanActuallyValid = false;

      // ❌ Disabled PAN cases
      if (disabledPanStatusMap[panValidation?.panStatusCode]) {
        realStatus = disabledPanStatusMap[panValidation.panStatusCode];
        isPanActuallyValid = false;
      }

      // ✅ Valid PAN (Status Code = E)
      else if (panValidation?.panStatusCode === "E") {
        // Aadhaar Successful
        if (panValidation?.aadhaarSeedingStatusCode === "Y") {
          realStatus = "VALID & OPERATIVE";
          isPanActuallyValid = true; // TCS 1%
        }
        // Aadhaar Not Applicable
        else if (panValidation?.aadhaarSeedingStatusCode === "NA" || panValidation?.aadhaarSeedingStatusCode == null) {
          realStatus = "VALID & OPERATIVE";
          isPanActuallyValid = true; // TCS 1%
        }
        // Aadhaar Not Successful
        else {
          realStatus = "VALID & INOPERATIVE";
          isPanActuallyValid = true; // TCS 5%
        }
      }

      setPanCustomerInfo({
        panNo: panValidation.panNo,
        panStatus: panValidation.panStatus,
        aadhaarSeedingStatusCode: panValidation.aadhaarSeedingStatusCode,
        isValid: isPanActuallyValid,
        realStatus,
      });

      if (!isPanActuallyValid) {
        customerForm.setFields([
          {
            name: field.groupId ? [field.groupId, field.name] : field.name,
            errors: ["Invalid PAN number"],
          },
        ]);

        setIsPanUpdateMode(false);
        return;
      }

      message.success("PAN validated successfully");

      /** 3️⃣ Update mode */
      if (isExistingCustomer) {
        setIsPanUpdateMode(true);
        setSelectedEditOldCustomer(existingCustomers[0]);
      } else {
        setIsPanUpdateMode(false);
      }

      let sourceData = isExistingCustomer ? existingCustomers[0] : panValidation;
      /** 5️⃣ Map to form */
      if (isExistingCustomer) {
        sourceData = await convertMetaDataToKeyValue(sourceData);
      }
      const mappedFormValues = await mapApiResponseToFormFields(sourceData, groupedFields, activeTab);
      // customerForm.setFieldsValue(sourceData);
      customerForm.setFieldsValue({
        ...sourceData,
        mobileno: sourceData?.mobileNo,
        lastname: sourceData?.lastName,
        lastvisitdate: sourceData?.lastVisitDate,
        cardnumber: sourceData?.cardNumber,
        city: sourceData?.customerAddress?.city,
        taxID: sourceData?.taxId,
        anniversaryDate: sourceData?.anniversaryDate?.split(" ")[0],
        birthday: sourceData?.birthday?.split(" ")[0],
        validity: sourceData?.validity?.split(" ")[0],
      });
      const isPanMobileNo = sourceData?.mobileNo;
      setPanCustomerInfo((prev) => ({
        ...prev,
        panHasMobile: Boolean(isPanMobileNo),
      }));
      setIsB2BEnabled(true);
      setFormDataCache((prev) => ({
        ...prev,
        [activeTab]: {
          ...(prev[activeTab] || {}),
          ...mappedFormValues,
        },
      }));
    } catch (err) {
      console.error("PAN validation flow failed:", err);
      setIsPanUpdateMode(false);
    } finally {
      setLoading(false);
    }
  };

  const clearPanFields = () => {
    const allValues = customerForm.getFieldsValue(true);
    const clearedValues = {};

    Object.entries(allValues).forEach(([key, value]) => {
      if (typeof value === "object" && value !== null) {
        clearedValues[key] = { ...value };
        Object.keys(value).forEach((innerKey) => {
          if (innerKey.toLowerCase().includes("pan")) {
            clearedValues[key][innerKey] = "";
          }
        });
      } else if (key.toLowerCase().includes("pan")) {
        clearedValues[key] = "";
      }
    });

    customerForm.setFieldsValue(clearedValues);
  };

  const compressImage = (file, maxWidth = 1920, quality = 0.75) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (e) => {
        image.src = e.target.result;
      };

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = image.width;
        let height = image.height;

        // Maintain aspect ratio
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(image, 0, 0, width, height);

        // Convert canvas to blob
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Image compression failed"));
              return;
            }

            // Create new compressed file
            const compressedFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });

            resolve(compressedFile);
          },
          file.type,
          quality
        );
      };

      image.onerror = (err) => {
        reject(err);
      };

      reader.onerror = (err) => {
        reject(err);
      };
    });
  };

  const handleFileUpload = async (e, docName) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // setUploadingDocs(true);

    try {
      const fileToUpload = file.size > 4 * 1024 * 1024 && file.type.startsWith("image/") ? await compressImage(file, 1920, 0.75) : file;

      const buffer = await fileToUpload.arrayBuffer();
      const fileData = Array.from(new Uint8Array(buffer));

      const response = await fetch("https://apps2.test.kwc.h02.cwcloud.in/api/uploadImages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fileName: fileToUpload.name,
          fileType: fileToUpload.type,
          fileData,
        }),
      });

      const result = await response.json();
      console.log("Upload response:", result);

      if (!response.ok) throw new Error(result?.error || "Upload failed");

      const { url } = result;
      setDocuments((prev) => [
        ...prev,
        {
          docID: "",
          docName,
          docUrl: url,
          fileName: file.name,
        },
      ]);

      message.success("Attachment has been uploaded succesfully.");
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Failed to upload document");
    } finally {
      // setUploadingDocs(false);
    }
  };

  const toCamelCase = (str) =>
    str
      .trim()
      .replace(/[^a-zA-Z0-9 ]/g, " ")
      .split(" ")
      .map((w, i) => (i === 0 ? w.toLowerCase() : w.charAt(0).toUpperCase() + w.slice(1)))
      .join("");

  useEffect(() => {
    const countries = JSON.parse(localStorage.getItem("countriesData")) || [];
    const states = JSON.parse(localStorage.getItem("statesData")) || [];
    const loyaltyData = JSON.parse(localStorage.getItem("loyaltyData")) || {};

    const defaultCountryId = countries.find((c) => c.Name === "India")?.RecordID;
    const defaultStateId = tillData?.tillAccess?.csBunit?.csRegionId;
    const loyaltyLevels = loyaltyData?.loyaltyLevels || [];
    const mappedLoyaltyOptions =
      loyaltyLevels.map((item) => ({
        RecordID: item.cwr_loyalty_level_id,
        Name: item.name,
      })) || [];
    const defaultLoyaltyId = loyaltyLevels.length > 0 ? loyaltyLevels[0]?.cwr_loyalty_level_id : undefined;

    const currentValues = customerForm.getFieldsValue(true);
    const updatedValues = { ...currentValues };

    // 🔍 Find all Country fields
    const countryFields = retailCustomerFields.filter((field) => field?.name?.toLowerCase() === "country");
    const stateFields = retailCustomerFields.filter((field) => field?.name?.toLowerCase() === "state");
    const loyaltyFields = retailCustomerFields.filter((field) => field?.name?.toLowerCase() === "loyalty level");

    countryFields.forEach((field) => {
      const fieldKey = toCamelCase(field.name);
      const groupId = field.groupId ? String(field.groupId).toLowerCase() : null;

      if (groupId) {
        // Group field
        updatedValues[groupId] = updatedValues[groupId] || {};

        if (!updatedValues[groupId][fieldKey]) {
          updatedValues[groupId][fieldKey] = defaultCountryId;
        }
      } else {
        // Root field
        if (!updatedValues[fieldKey]) {
          updatedValues[fieldKey] = defaultCountryId;
        }
      }
    });

    stateFields.forEach((field) => {
      const fieldKey = toCamelCase(field.name);
      const groupId = field.groupId ? String(field.groupId).toLowerCase() : null;

      if (!defaultStateId) return; // no region id in till data

      if (groupId) {
        updatedValues[groupId] = updatedValues[groupId] || {};
        if (!updatedValues[groupId][fieldKey]) {
          updatedValues[groupId][fieldKey] = defaultStateId;
        }
      } else {
        if (!updatedValues[fieldKey]) {
          updatedValues[fieldKey] = defaultStateId;
        }
      }
    });

    loyaltyFields.forEach((field) => {
      const fieldKey = toCamelCase(field.name);
      const groupId = field.groupId ? String(field.groupId).toLowerCase() : null;

      if (!defaultLoyaltyId) return; // no loyalty data

      if (groupId) {
        updatedValues[groupId] = updatedValues[groupId] || {};
        if (!updatedValues[groupId][fieldKey]) {
          updatedValues[groupId][fieldKey] = defaultLoyaltyId;
        }
      } else {
        if (!updatedValues[fieldKey]) {
          updatedValues[fieldKey] = defaultLoyaltyId;
        }
      }
    });

    customerForm.setFieldsValue(updatedValues);

    setOptionsMap((prev) => {
      const newMap = { ...prev };
      countryFields.forEach((field) => {
        newMap[field.id] = countries;
      });
      stateFields.forEach((field) => {
        newMap[field.id] = states;
      });
      loyaltyFields.forEach((field) => {
        newMap[field.id] = mappedLoyaltyOptions;
      });
      return newMap;
    });
  }, [displayAddNewCustomer, displayEditOldCustomer]);

  const fetchOptions = async (field) => {
    if (field.dataSource?.type === "api") {
      const apiConfig = retailCustomerApiDataSources.find((api) => api.id === field.dataSource.apiSourceId);
      if (apiConfig?.name === "getStates") {
        const states = JSON.parse(localStorage.getItem("statesData")) || [];
        setOptionsMap((prev) => ({
          ...prev,
          [field.id]: states,
        }));
      } else if (apiConfig?.name === "getCountries") {
        const countries = JSON.parse(localStorage.getItem("countriesData")) || [];
        setOptionsMap((prev) => ({
          ...prev,
          [field.id]: countries,
        }));
      } else if (apiConfig?.name === "getLoyaltyData") {
        const loyaltyData = JSON.parse(localStorage.getItem("loyaltyData")) || {};
        if (loyaltyData?.loyaltyLevels) {
          const mappedOptions =
            loyaltyData?.loyaltyLevels?.map((item) => ({
              RecordID: item.cwr_loyalty_level_id,
              Name: item.name,
            })) || [];
          setOptionsMap((prev) => ({
            ...prev,
            [field.id]: mappedOptions,
          }));
        } else {
          try {
            const params = {
              startRow: 0,
              endRow: 10,
            };

            const data = await getLoyaltyInfo({
              endpoint: apiConfig.endpoint,
              params,
            });
            const mappedOptions =
              data?.loyaltyLevels?.map((item) => ({
                RecordID: item.cwr_loyalty_level_id,
                Name: item.name,
              })) || [];
            setOptionsMap((prev) => ({
              ...prev,
              [field.id]: mappedOptions,
            }));
          } catch (err) {
            console.error("Failed to load loyalty data", err);
          }
        }
      }
    } else if (field.dataSource?.type === "static") {
      const staticOptions = field.dataSource.staticOptions || [];
      setOptionsMap((prev) => ({
        ...prev,
        [field.id]: staticOptions,
      }));
    }
  };

  useEffect(() => {
    if (!isB2BEnabled) return;
    if (!noB2BResults) return;
    if (!lastSearchedValue?.trim()) return;

    const updatedValues = {};

    groupedFields.forEach((group) => {
      group.fields.forEach((field) => {
        const fieldName = field.name.toLowerCase();

        if (searchByName && fieldName === "company name") {
          if (group.groupId) {
            updatedValues[group.groupId] = {
              ...(updatedValues[group.groupId] || {}),
              [field.name]: lastSearchedValue,
            };
          } else {
            updatedValues[field.name] = lastSearchedValue;
          }
        }

        if (!searchByName && fieldName.includes("gst")) {
          if (group.groupId) {
            updatedValues[group.groupId] = {
              ...(updatedValues[group.groupId] || {}),
              [field.name]: lastSearchedValue,
            };
          } else {
            updatedValues[field.name] = lastSearchedValue;
          }
        }
      });
    });

    customerForm.setFieldsValue(updatedValues);

    // Sync cache so tab switching doesn’t wipe it
    setFormDataCache((prev) => ({
      ...prev,
      [activeTab]: {
        ...(prev[activeTab] || {}),
        ...updatedValues,
      },
    }));
  }, [lastSearchedValue, noB2BResults, searchByName]);

  useEffect(() => {
    if (b2bSearchResults.length > 0) {
      setNoB2BResults(false);
    }
  }, [b2bSearchResults]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setShowB2BDropdown(false); // ✅ THIS WAS MISSING
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const normalizeGSTResponse = (gst) => {
    if (!gst || !gst.valid) return null;

    const flat = {};

    const normalizeKey = (key) =>
      key.includes("_") || key.includes(" ")
        ? key
            .replace(/[^a-zA-Z0-9 ]/g, " ")
            .split(" ")
            .map((w, i) => (i === 0 ? w.toLowerCase() : w.charAt(0).toUpperCase() + w.slice(1)))
            .join("")
        : key; // already camelCase → keep as-is

    Object.entries(gst).forEach(([k, v]) => {
      if (typeof v !== "object" || v === null) {
        flat[normalizeKey(k)] = v;
      }
    });

    if (gst.gstDetails) {
      Object.entries(gst.gstDetails).forEach(([k, v]) => {
        flat[normalizeKey(k)] = v;
      });
    }
    if (gst.address) {
      Object.entries(gst.address).forEach(([k, v]) => {
        flat[normalizeKey(k)] = v;
      });
    }

    return flat;
  };

  const normalizeStaticSelectValue = (value, staticJson) => {
    if (!value || !staticJson) return value;

    try {
      const parsed = JSON.parse(staticJson);

      if (parsed[value]) return value;

      const reverseMap = Object.fromEntries(Object.entries(parsed).map(([k, v]) => [v, k]));

      return reverseMap[value] || value;
    } catch {
      return value;
    }
  };

  const mapGSTToFormValuesDynamic = (gstApiResponse, groupedFields) => {
    const flatGST = normalizeGSTResponse(gstApiResponse);
    if (!flatGST) return {};

    const formValues = {};

    const isInvoiceGroup = (name) => name?.toLowerCase().includes("invoic");
    const isDeliveryGroup = (name) => name?.toLowerCase().includes("deliver");

    const toCamelCase = (str) =>
      str
        .trim()
        .replace(/[^a-zA-Z0-9 ]/g, " ")
        .split(" ")
        .map((w, i) => (i === 0 ? w.toLowerCase() : w.charAt(0).toUpperCase() + w.slice(1)))
        .join("");

    groupedFields.forEach((group) => {
      const groupId = group.groupId ? String(group.groupId).toLowerCase() : null;
      const groupName = group.groupName || "";

      const isAddressGroup = isInvoiceGroup(groupName) || isDeliveryGroup(groupName);

      group.fields.forEach((field) => {
        if (!field.visible) return;

        const fieldKey = toCamelCase(field.name);
        let value = null;

        // ✅ Root fields
        if (fieldKey === "companyName") value = flatGST.legalName;
        if (fieldKey === "gstNo") value = flatGST.gstNo;

        // ✅ Address group fields
        if (isAddressGroup) {
          if (fieldKey === "state") value = flatGST.state;
          if (fieldKey === "pincode") value = flatGST.pincode;
          if (fieldKey === "fullAddress") value = flatGST.fullAddress;
          // if (fieldKey === "companyType") value = flatGST.constitutionOfBusiness;
          if (fieldKey === "companyType") {
            const rawValue = flatGST.constitutionOfBusiness;
            value = normalizeStaticSelectValue(rawValue, field.defaultValue);
          }
          if (fieldKey === "country") value = flatGST.country || "India";
        }

        // ✅ Generic fallback
        if (value === null && flatGST[fieldKey] !== undefined) {
          value = flatGST[fieldKey];
        }

        if (value !== null && value !== undefined && value !== "") {
          if (groupId) {
            if (!formValues[groupId]) formValues[groupId] = {};
            formValues[groupId][fieldKey] = value; // group path
          } else {
            formValues[fieldKey] = value; // root path
          }
        }
      });
    });

    return formValues;
  };

  return (
    <Fragment>
      {/* CUSTOMER SEARCH MODAL BEGIN*/}
      <Modal
        // visible={displayCustomerSearch}
        onCancel={closeCustomerSearch}
        closable={false}
        footer={null}
        centered
        keyboard={false}
        bodyStyle={{ padding: 15, backgroundColor: "#F3F4F9" }}
      >
        <div style={{ height: "60vh" }}>
          <Row>
            <Col span={24} style={{ paddingBottom: "2vh", textAlign: "center" }}>
              <span style={data.posScreenStyles.addEditCustomerModal.addSearchCustLabel}>Search For Customer</span>
            </Col>
            <Col span={24}>
              <Input
                ref={customerSearchInputRef}
                placeholder="Search"
                id="sm-product-search"
                size="large"
                style={data.posScreenStyles.customerModal.customerSearchInput}
                className="customerSearchInput"
                prefix={
                  loading ? <Spin size="small" style={{ marginRight: "8px", color: "#black" }} /> : <img src={UserSearch} style={data.posScreenStyles.customerModal.searchIcon} />
                }
                suffix={
                  <img
                    src={CircleCloseIcon}
                    alt=""
                    style={data.posScreenStyles.customerModal.searchIcon}
                    onClick={() => {
                      setCustomerSearchInput("");
                      setCustomerSearchResults([]);
                      setLoading(false); // Reset loading when clearing input
                    }}
                    className="remove_btn"
                  />
                }
                value={customerSearchInput}
                onFocus={() => {
                  setTimeout(() => {
                    customerSearchInputRef.current?.focus();
                    setInputName("customerSearch");
                    setOpen(true);
                    const currentInputValue = customerSearchInput || "";
                    keyboard?.current?.setInput(currentInputValue);
                  }, 300);
                }}
                onPressEnter={() => {
                  if (!loading) {
                    if (customerSearchResults?.length === 1) {
                      selectCustomer(0);
                    } else if (customerSearchResults?.length === 0 && customerSearchInput.trim() !== "" && !customerSearchInput.startsWith(" ")) {
                      showAddNewCustomerFields();
                    }
                  }
                }}
                onChange={(e) => {
                  if (navigator.onLine) {
                    onChangeInput(e);
                    if (e.target.value === "") {
                      setCustomerSearchResults([]);
                      setCustomerSearchInput(e.target.value);
                      setLoading(false); // Reset loading when input is cleared
                    } else {
                      setCustomerSearchInput(e.target.value);
                      setLoading(true); // Set loading to true when input changes
                      // Assuming handleCustomerSearch is an async function that fetches customers
                      handleCustomerSearch(e.target.value)
                        .then((results) => {
                          setCustomerSearchResults(results);
                          setLoading(false); // Reset loading when search completes
                        })
                        .catch(() => {
                          setLoading(false);
                        });
                    }
                  } else {
                    setLoading(false);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col span={24}>
              {customerSearchResults === undefined ? (
                <div style={data.posScreenStyles.header.left}>
                  <div bordered style={data.posScreenStyles.customerModal.customerSearchListEmpty} />
                </div>
              ) : customerSearchResults !== undefined && customerSearchResults.length > 0 ? (
                <div style={data.posScreenStyles.header.left}>
                  <div style={data.posScreenStyles.customerModal.customerSearchList}>
                    <p
                      style={{
                        textAlign: "left",
                        fontSize: "1.8vh",
                        padding: "1vh 0 1vh 1vw",
                        fontWeight: "500",
                        color: "#2F3856",
                        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                        margin: "0 1vw",
                      }}
                    >
                      Customers
                    </p>
                    <Scrollbars className="customerCardScroll">
                      {customerSearchResults.map((customerSearchResult, index) => (
                        <div
                          tabIndex={0}
                          onKeyPress={(e) => (e.charCode === 13 ? selectCustomer(index) : null)}
                          key={`${index}`}
                          style={data.posScreenStyles.customerModal.customerDetailsCard}
                        >
                          {/* <Row>
                          <Col span={19} offset={3} onClick={() => selectCustomer(index)}>
                          </Col>

                        </Row> */}
                          <Row style={{ display: "flex", alignItems: "center", justifyContent: "center", borderBottom: "1px solid #0000001F" }}>
                            <Col span={2} offset={1}>
                              <span
                                style={{
                                  padding: "0.8vw 1.2vw",
                                  backgroundColor: "#D9D9D9",
                                  color: "rgba(0, 0, 0, 0.59)",
                                  textAlign: "center",
                                  borderRadius: "4px",
                                  fontWeight: "600",
                                }}
                              >
                                {customerSearchResult.name.substring(0, 1)}
                              </span>
                            </Col>
                            <Col span={17} offset={1} onClick={() => selectCustomer(index)}>
                              <p style={data.posScreenStyles.customerModal.customerName}>{customerSearchResult.name}</p>
                              <p style={data.posScreenStyles.customerModal.customerStatus}>{customerSearchResult.mobileNo}</p>
                            </Col>

                            <Col span={3} style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}>
                              <img onClick={() => showEditOldCustomerFields(customerSearchResult)} src={View} style={{ height: "3vh" }} />
                              <EditOutlined
                                style={data.posScreenStyles.customerModal.dropdownCircleIcon}
                                onClick={() => {
                                  showEditOldCustomerFields(customerSearchResult);
                                  setEditFlag(true);
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </Scrollbars>
                  </div>
                </div>
              ) : (
                <div style={data.posScreenStyles.header.left}>
                  <div bordered style={data.posScreenStyles.customerModal.customerSearchListEmpty}>
                    <Row>
                      <p style={data.posScreenStyles.customerModal.noResultsText}>No results found</p>
                    </Row>
                    <Row justify="center" align="center">
                      <img src={CustomerIcon} alt="CustomerIcon" style={{ height: "1.7vh", alignSelf: "center", paddingRight: "0.5vw" }} />{" "}
                      <span style={data.posScreenStyles.customerModal.addNewCustomer} onClick={showAddNewCustomerFields}>
                        {getMultilingualText("Add Customer")}
                      </span>
                    </Row>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Modal>
      <Drawer
        visible={displayCustomerSearch}
        width="62%"
        title={null}
        closeIcon={null}
        headerStyle={{ height: 0 }}
        bodyStyle={{
          paddingTop: 0,
          backgroundColor: "#ffffff",
        }}
        placement="right"
        closable={false}
      >
        <Row style={{ display: "flex", alignItems: "center", fontSize: "1vw" }}>
          <p style={{ fontSize: "1.5em", fontWeight: "500", color: "#0F0718", flex: 1, marginBottom: 0, marginTop: "2.5vh" }}>
            {/* <img
              src={SearchIcon}
              alt=""
              style={{
                width: 20,
                height: 20,
                filter: "brightness(0) saturate(100%)",
              }}
            /> */}
            {getMultilingualText("Search for Customer")}
          </p>
          <img
            src={closeX}
            onClick={() => {
              Modal.destroyAll();

              const isPreOrderPage = window.location.pathname.includes("/preorder");
              const fromTotalClick = customerSearchTrigger === "verifyStock";

              // === PAN RULE CHECK ===
              const panRule = retailCustomerRules?.find((r) => r.action === "Request PAN");
              const panRuleActive = panRule && Number(cart.total) > Number(panRule.value);

              // 1. PAN RULE VIOLATED → TRAP (Close only)
              if (panRuleActive) {
                Modal.confirm({
                  title: "Action Required",
                  content: "You cannot proceed without selecting a customer.",
                  width: 420,
                  centered: true,
                  closable: false,
                  keyboard: false,
                  maskClosable: false,
                  // okButtonProps: { style: { display: "none" } },
                  cancelText: "Close",
                  cancelButtonProps: {
                    type: "primary",
                    size: "middle",
                  },
                  onCancel: () => {},
                });
                setLayoutName("default");
                return;
              }

              // 2. FROM TOTAL CLICK OR NORMAL CLICK → SHOW "Yes, Proceed"
              // This covers BOTH cases when safe
              Modal.confirm({
                title: "Customer not selected",
                content: "Would you like to proceed for payment without adding Customer?",
                width: 420,
                centered: true,
                okButtonProps: isPreOrderPage ? { style: { display: "none" } } : {},
                okText: isPreOrderPage ? null : "Yes, Proceed",
                okButtonProps: { style: { display: "inline-block" } },
                cancelText: "Cancel",
                onOk: () => {
                  closeCustomerSearch();
                  verifyStock();
                },
                onCancel: () => {},
              });

              setLayoutName("default");
            }}
            style={{
              marginLeft: "auto",
              cursor: "pointer",
              width: "1.5vw",
              marginTop: "1.5vh",
            }}
          />
        </Row>
        <Row style={{ marginTop: "1.5%", overflow: "hidden" }}>
          <Col span={24} style={{ fontSize: "1vw" }}>
            <Input
              ref={customerSearchInputRef}
              placeholder="Search"
              id="sm-product-search"
              size="large"
              style={data.posScreenStyles.customerModal.customerSearchInput}
              className="customerSearchInput"
              prefix={
                loading ? <Spin size="small" style={{ marginRight: "8px", color: "#black" }} /> : <img src={UserSearch} style={data.posScreenStyles.customerModal.searchIcon} />
              }
              suffix={
                <img
                  src={CircleCloseIcon}
                  alt=""
                  style={data.posScreenStyles.customerModal.searchIcon}
                  onClick={() => {
                    setCustomerSearchInput("");
                    setCustomerSearchResults([]);
                    setLoading(false); // Reset loading when clearing input
                  }}
                  className="remove_btn"
                />
              }
              value={customerSearchInput}
              onFocus={() => {
                setTimeout(() => {
                  customerSearchInputRef.current?.focus();
                  setInputName("customerSearch");
                  setOpen(true);
                  const currentInputValue = customerSearchInput || "";
                  keyboard?.current?.setInput(currentInputValue);
                }, 300);
              }}
              onPressEnter={() => {
                if (!loading) {
                  if (customerSearchResults?.length === 1) {
                    selectCustomer(0);
                  } else if (customerSearchResults?.length === 0 && customerSearchInput.trim() !== "" && !customerSearchInput.startsWith(" ")) {
                    showAddNewCustomerFields();
                  }
                }
              }}
              onChange={(e) => {
                if (navigator.onLine) {
                  onChangeInput(e);
                  if (e.target.value === "") {
                    setCustomerSearchResults([]);
                    setCustomerSearchInput(e.target.value);
                    setLoading(false); // Reset loading when input is cleared
                  } else {
                    setCustomerSearchInput(e.target.value);
                    setLoading(true); // Set loading to true when input changes
                    // Assuming handleCustomerSearch is an async function that fetches customers
                    // handleCustomerSearch(e.target.value)
                    //   .then((results) => {
                    //     setCustomerSearchResults(results);
                    //     setLoading(false); // Reset loading when search completes
                    //   })
                    //   .catch(() => {
                    //     setLoading(false);
                    //   });
                  }
                } else {
                  setLoading(false);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "2%" }}>
          <Col span={20} style={{ fontSize: "1vw" }}>
            {!customerSearchInput || customerSearchInput.trim() === "" ? (
              // 🔹 If search input is empty
              <div style={data.posScreenStyles.header.left}>
                <div bordered style={data.posScreenStyles.customerModal.customerSearchListEmpty}>
                  <Row justify="center" align="middle">
                    <p style={data.posScreenStyles.customerModal.addNewCustomer}>Start typing to search for customers</p>
                  </Row>
                </div>
              </div>
            ) : customerSearchResults && customerSearchResults.length > 0 ? (
              // 🔹 If input has value and results found
              <div style={data.posScreenStyles.header.left}>
                <div style={data.posScreenStyles.customerModal.customerSearchList}>
                  <Scrollbars style={{ height: "77vh" }}>
                    {customerSearchResults.map((customerSearchResult, index) => (
                      <div
                        tabIndex={0}
                        onKeyPress={(e) => (e.charCode === 13 ? selectCustomer(index) : null)}
                        key={`${index}`}
                        style={data.posScreenStyles.customerModal.customerDropDownDetailsCard}
                      >
                        <Row
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            paddingBottom: "0.1%",
                          }}
                        >
                          <Col span={20} onClick={() => selectCustomer(index)} style={{ cursor: "pointer", padding: "10px" }}>
                            <p style={data.posScreenStyles.customerModal.customerName}>
                              {customerSearchResult.name}
                              {/* <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  backgroundColor: "#F1F1F1",
                                  color: "#000",
                                  padding: "2px 8px",
                                  borderRadius: "12px",
                                  marginLeft: "1vw",
                                }}
                              >
                                B2C
                              </span> */}
                            </p>

                            {customerSearchResult?.b2cCustomerSegment?.name && (
                              <p
                                style={{
                                  fontSize: "1em",
                                  color: "#4A4A4A",
                                  textAlign: "left",
                                  marginBottom: 0,
                                  fontWeight: 400,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <TagOutlined style={{ marginRight: 4, fontSize: "12px" }} />
                                {customerSearchResult.b2cCustomerSegment.name}
                              </p>
                            )}

                            {(customerSearchResult.mobileNo || customerSearchResult.email) && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "16px",
                                  alignItems: "center",
                                  marginTop: "0.3vh",
                                }}
                              >
                                {customerSearchResult.mobileNo && (
                                  <span
                                    style={{
                                      fontSize: "1em",
                                      color: "#4A4A4A",
                                      fontWeight: 400,
                                    }}
                                  >
                                    <PhoneOutlined style={{ marginRight: 4 }} />
                                    {customerSearchResult.mobileNo}
                                  </span>
                                )}

                                {customerSearchResult.email && (
                                  <span
                                    style={{
                                      fontSize: "1em",
                                      color: "#4A4A4A",
                                      fontWeight: 400,
                                      display: "flex",
                                      alignItems: "center",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <MailOutlined style={{ marginRight: 4 }} />
                                    {customerSearchResult.email}
                                  </span>
                                )}
                              </div>
                            )}
                          </Col>

                          <Col
                            span={4}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              padding: "10px",
                            }}
                          >
                            <img
                              onClick={async () => {
                                if (retailCustomerFields && retailCustomerFields.length > 0) {
                                  const mappedCustomer = convertMetaDataToKeyValue(customerSearchResult);
                                  // await customerForm.setFieldsValue(mappedCustomer);
                                  await customerForm.setFieldsValue({
                                    ...mappedCustomer,
                                    mobileno: mappedCustomer?.mobileNo,
                                    lastname: mappedCustomer?.lastName,
                                    lastvisitdate: mappedCustomer?.lastVisitDate,
                                    cardnumber: mappedCustomer?.cardNumber,
                                    city: mappedCustomer?.customerAddress?.city,
                                    taxID: mappedCustomer?.taxId,
                                    anniversaryDate: mappedCustomer?.anniversaryDate?.split(" ")[0],
                                    birthday: mappedCustomer?.birthday?.split(" ")[0],
                                    validity: mappedCustomer?.validity?.split(" ")[0],
                                  });
                                  setViewCustomerValues(mappedCustomer);
                                  setDisplayEditOldCustomer(true);
                                  setDisplayAddNewCustomer(false);
                                  setIsViewMode(true);
                                } else {
                                  setEditFlag(false);
                                  showEditOldCustomerFields(customerSearchResult);
                                }
                              }}
                              src={View}
                              style={{ height: "3vh", marginRight: "5px" }}
                            />

                            <img
                              onClick={async () => {
                                if (retailCustomerFields && retailCustomerFields.length > 0) {
                                  const mappedCustomer = convertMetaDataToKeyValue(customerSearchResult);
                                  // customerForm.setFieldsValue(mappedCustomer);
                                  await customerForm.setFieldsValue({
                                    ...mappedCustomer,
                                    mobileno: mappedCustomer?.mobileNo,
                                    lastname: mappedCustomer?.lastName,
                                    taxID: mappedCustomer?.taxId,
                                    lastvisitdate: mappedCustomer?.lastVisitDate,
                                    cardnumber: mappedCustomer?.cardNumber,
                                    city: mappedCustomer?.customerAddress?.city,
                                    taxID: mappedCustomer?.taxId,
                                    anniversaryDate: mappedCustomer?.anniversaryDate?.split(" ")[0],
                                    birthday: mappedCustomer?.birthday?.split(" ")[0],
                                    validity: mappedCustomer?.validity?.split(" ")[0],
                                  });
                                  setViewCustomerValues(mappedCustomer);
                                  setSelectedEditOldCustomer(customerSearchResult);
                                  setDisplayEditOldCustomer(true);
                                  setDisplayAddNewCustomer(false);
                                  setEditFlag(true);
                                  setIsViewMode(false);
                                } else {
                                  showEditOldCustomerFields(customerSearchResult);
                                  setEditFlag(true);
                                }
                              }}
                              src={EditIcon}
                              style={{
                                height: "3vh",
                                marginRight: "5px",
                                marginLeft: "0.5vw",
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </Scrollbars>
                </div>
              </div>
            ) : (
              // 🔹 If search input has value but no results
              <div style={data.posScreenStyles.header.left}>
                <div bordered style={data.posScreenStyles.customerModal.customerSearchListEmpty}>
                  <Row justify="center" align="middle">
                    <p style={data.posScreenStyles.customerModal.addNewCustomer}>No customers found</p>
                  </Row>
                </div>
              </div>
            )}
          </Col>
        </Row>

        {(!customerSearchInput || customerSearchInput.trim() === "" || customerSearchResults?.length === 0) && (
          <>
            <hr style={{ border: "none", borderTop: "1px solid #d1d5db", marginBottom: "16px" }} />

            <Row style={{ fontSize: "1vw", marginTop: "2.7vh" }}>
              <Col span={8}>
                <button
                  style={{
                    height: "6vh",
                    backgroundColor: "#2F3856",
                    color: "#fff",
                    fontSize: "1em",
                    border: "none",
                    borderRadius: "5px",
                    width: "90%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setActiveTabName("contact");
                    showAddNewCustomerFields();
                  }}
                >
                  <UserAddOutlined style={{ fontSize: "1.2em", color: "#fff", marginRight: "0.5vw" }} />
                  Add New Customer
                </button>
              </Col>
            </Row>
          </>
        )}
      </Drawer>
      {/* CUSTOMER SEARCH MODAL END*/}

      {/* ADD NEW CUSTOMER MODAL BEGIN*/}
      <Modal
        onCancel={() => {
          setDisplayCustomerSearch(true);
          setDisplayAddNewCustomer(false);
          setCustomerSearchInput("");
          setIsB2BEnabled(false);
          setIsPanUpdateMode(false);
          setFormDataCache({});
          setPanCustomerInfo(null);
          setCustomerSearchResults();
          customerForm.resetFields();
        }}
        footer={null}
        width="53%"
        closable={false}
        bodyStyle={{ padding: 20, paddingTop: 0, backgroundColor: "#F3F4F9" }}
      >
        <div>
          <div style={data.posScreenStyles.customerModal.customerDetailsCard}>
            <Row>
              <Col span={24}>
                <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>{getMultilingualText("Add Customer")}</span>
                <Button.Group>
                  <Button
                    style={{
                      backgroundColor: !toggleCustomer ? "#2F3856" : "#fff",
                      color: toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(false)}
                  >
                    Contact
                  </Button>
                  <Button
                    style={{
                      backgroundColor: toggleCustomer ? "#2F3856" : "#fff",
                      color: !toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(true)}
                  >
                    Details
                  </Button>
                </Button.Group>
                <img
                  onClick={() => {
                    setDisplayCustomerSearch(true);
                    setDisplayAddNewCustomer(false);
                    setCustomerSearchInput("");
                    setCustomerSearchResults();
                  }}
                  style={{ float: "right", cursor: "pointer" }}
                  src={closeX}
                  alt=""
                />
              </Col>
            </Row>
          </div>

          <Form key={"addCustomer"} form={form} name="addCustomer" onFinish={addNewCustomer}>
            <Scrollbars thumbSize={100} renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: "40vh" }}>
              <div style={{ display: toggleCustomer ? "block" : "none" }}>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>{getMultilingualText("MAILING ADDRESS")}</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                    <Form.Item name="street" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Street" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                    <Form.Item name="city" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="City" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("State")}</label>
                    <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter State" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Country")}</label>
                    <Form.Item name="country" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Country" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Pincode")}</label>
                    <Form.Item
                      name="pincode"
                      rules={[
                        {
                          required: false,
                          pattern: new RegExp(/\d+/g),
                          message: "Please Input Pincode",
                        },
                      ]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>SETTINGS</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                    <Form.Item name="loyality" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Switch onChange={onSwitchChange} defaultChecked />
                      &nbsp; <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500 }}>Enable loyalty for this customer</span>
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                    {enableLoyality && (
                      <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                        <Select disabled={true}>
                          <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                            {loyalityType[0]?.name}
                          </Option>
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                </Row>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>ADDITIONAL INFORMATION</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
                    <Form.Item name="AnniversaryDate" style={{ border: "0" }}>
                      <DatePicker placeholder="DD/MM/YYYY" className="cutomerAniversaryDate" format="DD/MM/YYYY" />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                    <Form.Item name="taxID" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Tax ID" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Birthday Date</label>
                    <Form.Item name="BirthdayDate" style={{ border: "0" }}>
                      <DatePicker placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                    <Form.Item name="gender" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Select>
                        <Option key={"MAL"} value="MAL">
                          Male
                        </Option>
                        <Option key={"FEM"} value="FEM">
                          Female
                        </Option>
                        <Option key={"TRANS"} value="TRANS">
                          Transgender
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div style={{ display: toggleCustomer ? "none" : "block" }}>
                <Row style={{}}>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15, fontSize: "1vw" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                    <Form.Item name="name" rules={[{ required: true, message: "Please Input First Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="First Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15, fontSize: "1vw" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                    <Form.Item name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Last Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15, fontSize: "1vw" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                    <Form.Item name="email" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Email" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15, fontSize: "1vw" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>
                    <Form.Item
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          validator: (_, value) => {
                            const lengthRaw = posConfig?.customerMobileNumberLength;
                            const lengthRequired = Number(lengthRaw);
                            const isLengthValidNumber = !isNaN(lengthRequired) && Number.isInteger(lengthRequired) && lengthRequired > 0;

                            if (!value) {
                              return Promise.reject("Please Input Contact Number");
                            }

                            const digitsOnly = /^[0-9]+$/.test(value);
                            if (!digitsOnly) {
                              return Promise.reject("Only digits are allowed");
                            }

                            if (isLengthValidNumber && value.length !== lengthRequired) {
                              return Promise.reject(`Mobile number must be exactly ${lengthRequired} digits`);
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input
                        ref={refs.mobile}
                        value={getInputValue("mobile")}
                        onChange={(event) => {
                          const inputVal = event.target.value.replace(/\D/g, "");
                          const lengthRaw = posConfig?.customerMobileNumberLength;
                          const maxLen = Number(lengthRaw);
                          const isLengthValidNumber = !isNaN(maxLen) && Number.isInteger(maxLen) && maxLen > 0;

                          if (!isLengthValidNumber || inputVal.length <= maxLen) {
                            setKeyboardInputFields({
                              ...keyboardInputFields,
                              mobile: inputVal,
                            });
                            form.setFieldsValue({ mobile: inputVal });
                            keyboard?.current?.setInput(inputVal);
                          }
                        }}
                        onFocus={() => onFocusInput("mobile")}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        id="sm-product-search"
                        className="customerDetailsInput"
                        placeholder="Enter Contact Number"
                        style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                        maxLength={posConfig?.customerMobileNumberLength || 15}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15, fontSize: "1vw" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                    <Form.Item name="pincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Scrollbars>
            <Row>
              <Col xs={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                <Form.Item style={{ paddingTop: "3vh" }}>
                  <Button className="customerDetailsSubmitBtnBtn" style={data.posScreenStyles.addEditCustomerModal.customerDetailsSubmitBtn} htmlType="submit">
                    Create New Customer
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <Drawer
        visible={displayAddNewCustomer}
        placement="right"
        footer={null}
        closable={false}
        bodyStyle={{
          paddingTop: 0,
          backgroundColor: "#ffffff",
        }}
        width="62%"
      >
        <Spin spinning={loading}>
          <div
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          >
            <Form key={"addCustomer"} form={customerForm} name="addCustomer">
              <Row style={{ display: "flex", alignItems: "center", marginTop: "2.5vh", justifyContent: "center" }}>
                <Col span={16} style={{ display: "flex", alignItems: "center" }}>
                  <UserOutlined style={{ fontSize: "20px", marginRight: "0.3em" }} />
                  <p style={{ marginBottom: 0, fontSize: "1.5em", fontWeight: 500, color: "#0F0718" }}> Customer Registration</p>
                </Col>
                {cart?.total > 0 ? (
                  <Col style={{ display: "flex", alignItems: "center", justifyContent: "right", marginTop: "0.7vh" }} span={6}>
                    <p style={{ border: "1px solid #D9D9D9", borderRadius: "15px", marginBottom: 0, color: "#0F0718", padding: "1.5px 10px", fontSize: "1em", fontWeight: 600 }}>
                      Bill Value: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      {cart?.total}
                      {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </p>
                  </Col>
                ) : (
                  <Col span={6}></Col>
                )}
                <Col span={2} style={{ textAlign: "right", marginTop: "0.7vh" }}>
                  <img
                    src={closeX}
                    style={{ cursor: "pointer", width: "1.5vw" }}
                    onClick={() => {
                      if (cart?.customer?.b2cRegisteredstoreId === null) {
                        setDisplayCustomerSearch(true);
                      }
                      if (cart?.customer?.b2cRegisteredstoreId && cart?.salesRepId === null && posConfig?.requireSalesRepresentative === "Y") {
                        setOpenSalesRep({ flag: true, level: "order" });
                      }
                      setDisplayAddNewCustomer(false);
                      setCustomerSearchInput("");
                      setIsB2BEnabled(false);
                      setIsPanUpdateMode(false);
                      setFormDataCache({});
                      setActiveTab(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.id || ""); // Reset to first visible tab
                      setActiveTabName(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.name || "");
                      setCustomerSearchResults();
                      customerForm.resetFields();
                      setLastSearchedValue("");
                      setSelectedB2BCustomer(null);
                      setB2bSearchResults([]);
                      setIsPanCustomer(false);
                      setPanCustomerInfo(null);
                    }}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "1vh" }}>
                <p style={{ marginBottom: 0, color: "#6B7280", fontSize: "14px", fontWeight: 100 }}>Register a new customer with complete details</p>
              </Row>
              <Row>{renderConditionalRule()}</Row>

              {retailCustomerFields && retailCustomerFields.length > 0 ? (
                <>
                  <Row
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "6px",
                      borderRadius: "8px",
                      marginTop: "2vh",
                      height: "8vh",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {retailCustomerTabs
                      .filter((tab) => tab.visible)
                      .sort((a, b) => a.order - b.order)
                      .map((tab) => {
                        const isActive = tab.id === activeTab;
                        const isDisabled = tab.name.toLowerCase() === "business" && !customerConfigData?.b2bSettings?.enableB2BBilling;

                        return (
                          <Col
                            key={tab.id}
                            onClick={async () => {
                              if (isDisabled) return;
                              const currentValues = await customerForm.getFieldsValue();
                              setFormDataCache((prev) => ({
                                ...prev,
                                [activeTab]: currentValues,
                              }));
                              if (formDataCache[tab.id]) {
                                customerForm.setFieldsValue(formDataCache[tab.id]);
                              }
                              setActiveTab(tab.id);
                              setActiveTabName(tab.name);
                            }}
                            style={{
                              flex: 1,
                              padding: "6px 0",
                              borderRadius: "6px",
                              backgroundColor: isActive ? "#fff" : "transparent",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: isActive ? "#000" : "#8c8c8c",
                              // color: isDisabled ? "red" : isActive ? "#000" : "#8c8c8c",
                              fontWeight: isActive ? 600 : 500,
                              boxShadow: isActive ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                              transition: "all 0.2s ease",
                            }}
                          >
                            <span style={{ marginRight: 6 }}>{iconMap[tab.icon]}</span>
                            {tab.name}
                          </Col>
                        );
                      })}
                  </Row>

                  <Scrollbars style={{ height: renderScrollHeight() ? "55vh" : "65vh", paddingRight: "12px" }} autoHide>
                    {activeTabName === "Business" && customerConfigData?.b2bSettings?.enableB2BBilling && (
                      <div
                        style={{
                          paddingLeft: "1px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "25px",
                          marginBottom: "16px",
                        }}
                        ref={searchContainerRef}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "1.5vw" }}>
                          <div style={{ fontWeight: 600, fontSize: "16px" }}>Business Customer (B2B)</div>
                          {/* <Switch checked={isB2BEnabled} onChange={(checked) => setIsB2BEnabled(checked)} /> */}
                          <Switch
                            checked={panCustomerInfo?.isValid === true ? true : isB2BEnabled}
                            disabled={panCustomerInfo?.isValid === true}
                            onChange={(checked) => {
                              if (panCustomerInfo?.isValid === true) return;
                              setIsB2BEnabled(checked);
                            }}
                          />
                        </div>

                        {isB2BEnabled && (
                          <div style={{ position: "relative", width: "60%" }}>
                            <Input
                              // placeholder="Search B2B Customers..."
                              placeholder={searchByName ? "Search B2B Customers by Name..." : "Search B2B Customers by GST No..."}
                              allowClear
                              value={lastSearchedValue}
                              disabled={isViewMode || !customerConfigData?.b2bSettings?.enableB2BCustomerRegistration}
                              onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (!searchByName && lastSearchedValue.trim()) {
                                    try {
                                      setLoading(true);
                                      const gstResponse = await validateGSTNumber(lastSearchedValue.trim());
                                      if (gstResponse?.valid) {
                                        const mappedValues = mapGSTToFormValuesDynamic(gstResponse, groupedFields);
                                        customerForm.setFieldsValue(mappedValues);
                                        setFormDataCache((prev) => ({
                                          ...prev,
                                          [activeTab]: {
                                            ...(prev[activeTab] || {}),
                                            ...mappedValues,
                                          },
                                        }));
                                        setB2bSearchResults([]);
                                        setShowB2BDropdown(false);
                                      }
                                    } catch (err) {
                                      console.error("GST validation failed", err);
                                    } finally {
                                      setLoading(false);
                                    }
                                  }
                                }
                              }}
                              onChange={(e) => {
                                const v = e.target.value;
                                setLastSearchedValue(v);
                                setSelectedB2BCustomer(null);

                                if (v.trim() !== "") {
                                  setShowB2BDropdown(true);
                                  searchB2BCustomers(v);
                                } else {
                                  // 🧹 if input cleared, clean everything
                                  setB2bSearchResults([]);
                                  setShowB2BDropdown(false);
                                  customerForm.resetFields(); // clear form
                                  setFormDataCache((prev) => ({
                                    ...prev,
                                    [activeTab]: {},
                                  }));
                                }
                              }}
                              onClear={() => {
                                // 🧼 full reset on clear
                                setLastSearchedValue("");
                                setB2bSearchResults([]);
                                setSelectedB2BCustomer(null);

                                // Clear form values
                                customerForm.resetFields();

                                // Reset cache for this tab
                                setFormDataCache((prev) => ({
                                  ...prev,
                                  [activeTab]: {},
                                }));
                              }}
                              loading={b2bLoading}
                              prefix={<SearchOutlined style={{ color: "#a0a0a0" }} />}
                              style={{
                                height: "30px",
                                borderRadius: "6px",
                                fontSize: "14px",
                                width: "65%",
                                backgroundColor: !customerConfigData?.b2bSettings?.enableB2BCustomerRegistration ? "#f5f5f5" : "#fff",
                                cursor: !customerConfigData?.b2bSettings?.enableB2BCustomerRegistration ? "not-allowed" : "text",
                              }}
                            />
                            <Checkbox
                              checked={searchByName}
                              style={{ marginLeft: "1vw" }}
                              onChange={(e) => {
                                setSearchByName(e.target.checked);
                                // setLastSearchedValue("");
                                setB2bSearchResults([]);
                                setSelectedB2BCustomer(null);
                                customerForm.resetFields();
                                setFormDataCache((prev) => ({
                                  ...prev,
                                  [activeTab]: {},
                                }));
                              }}
                              disabled={isViewMode}
                            >
                              Search by Name
                            </Checkbox>

                            {showB2BDropdown && lastSearchedValue?.trim() !== "" && !selectedB2BCustomer && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                  background: "#fff",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: "6px",
                                  marginTop: "4px",
                                  zIndex: 10,
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  padding: "8px 0",
                                  width: "65%",
                                }}
                              >
                                {b2bLoading && (
                                  <div style={{ textAlign: "center", padding: "12px" }}>
                                    <Spin size="small" /> Searching…
                                  </div>
                                )}

                                {!b2bLoading && b2bSearchResults.length > 0 && (
                                  <>
                                    {b2bSearchResults.map((customer) => (
                                      <div
                                        key={customer.customerId}
                                        style={{
                                          padding: "12px 16px",
                                          borderBottom: "1px solid #f0f0f0",
                                          cursor: "pointer",
                                          transition: "background 0.2s",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f9f9f9")}
                                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                                        onClick={async () => {
                                          setB2bSearchResults([]);
                                          setLastSearchedValue(customer.customerName);
                                          setSelectedB2BCustomer(customer);
                                          setInvoiceAddressList(customer.invoiceAddresses || []);
                                          setDeliveryAddressList(customer.deliveryAddresses || []);
                                          setSelectedInvoiceAddress(null);
                                          setSelectedDeliveryAddress(null);
                                          const mappedValues = mapB2BDataDynamic(customer, groupedFields);
                                          const currentValues = customerForm.getFieldsValue();
                                          customerForm.setFieldsValue({
                                            ...currentValues,
                                            ...mappedValues,
                                            b2bCustomerId: customer.customerId,
                                            b2bCustomerName: customer.customerName,
                                            b2bCustomerCode: customer.customerCode,
                                          });
                                          setFormDataCache((prev) => ({
                                            ...prev,
                                            [activeTab]: {
                                              ...(prev[activeTab] || {}),
                                              ...mappedValues,
                                              b2bCustomerId: customer.customerId,
                                              b2bCustomerName: customer.customerName,
                                              b2bCustomerCode: customer.customerCode,
                                            },
                                          }));
                                        }}
                                      >
                                        <div style={{ fontWeight: 600, fontSize: "15px", color: "#1a1a1a" }}>{customer.customerName}</div>
                                        <div style={{ fontSize: "13px", color: "#666", marginTop: "2px" }}>
                                          <strong>Code:</strong> {customer.customerCode}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}

                                {!b2bLoading && lastSearchedValue?.trim() !== "" && b2bSearchResults.length === 0 && (
                                  <div style={{ textAlign: "center", padding: "12px", color: "#999" }}>No customers found</div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {activeTabName.toLowerCase() === "contact" && (
                      <div
                        style={{
                          paddingLeft: "1px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "1.5vw" }}>
                          <div style={{ fontWeight: 600, fontSize: "16px" }}>PAN Customer</div>

                          <Switch
                            checked={isPanCustomer}
                            onChange={(checked) => {
                              setIsPanCustomer(checked);
                              if (!checked) {
                                // customerForm.setFieldsValue({
                                //   contact: {
                                //     panNo: "",
                                //   },
                                // });
                                clearPanFields();
                                setPanCustomerInfo(null);
                                setIsPanUpdateMode(false);
                              }
                            }}
                          />
                          {panCustomerInfo?.realStatus && (
                            <div
                              style={{
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: 600,
                                background:
                                  panCustomerInfo.realStatus === "VALID & OPERATIVE" ? "#dcfce7" : panCustomerInfo.realStatus === "VALID & INOPERATIVE" ? "#fef3c7" : "#fee2e2",
                                color:
                                  panCustomerInfo.realStatus === "VALID & OPERATIVE" ? "#166534" : panCustomerInfo.realStatus === "VALID & INOPERATIVE" ? "#92400e" : "#991b1b",
                              }}
                            >
                              {panCustomerInfo.realStatus}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div style={{ overflowX: "hidden" }}>
                      {groupedFields.map((group) => {
                        // const isExpanded = group.collapsible ? true : true;
                        const isExpanded = group.collapsible ? !switchToggle : true;
                        const isUngrouped = group.groupId === "";
                        return (
                          <div key={group.groupId}>
                            {group.groupId !== "" && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginTop: "2vh",
                                  marginBottom: group.groupName ? "2vh" : "1vh",
                                }}
                              >
                                <div style={{ fontWeight: 600, fontSize: "18px", color: "#0F0718" }}>{group.groupName}</div>
                                {group.collapsible && (
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Switch
                                      checked={switchToggle}
                                      onChange={(checked) => {
                                        setSwitchToggle(checked);

                                        if (!checked) {
                                          const emptyValues = {};
                                          const currentGroupId = group.groupId;
                                          const currentGroupFields = group.fields || [];

                                          emptyValues[currentGroupId] = {};

                                          currentGroupFields.forEach((field) => {
                                            emptyValues[currentGroupId][field.name] = "";
                                          });

                                          setTimeout(() => {
                                            customerForm.setFieldsValue(copiedValues);
                                          }, 0);

                                          setFormDataCache((prev) => {
                                            const prevTabData = prev[activeTab] || {};
                                            const mergedTabData = {
                                              ...prevTabData,
                                              ...emptyValues, // this works since structure matches handleChange
                                            };
                                            return {
                                              ...prev,
                                              [activeTab]: mergedTabData,
                                            };
                                          });
                                          return;
                                        }

                                        const allFormValues = customerForm.getFieldsValue();
                                        const copiedValues = {};
                                        const currentGroupId = group.groupId;
                                        const currentGroupFields = group.fields || [];
                                        const otherGroupsInSameTab = groupedFields.filter((g) => g.groupId !== currentGroupId);

                                        currentGroupFields.forEach((field) => {
                                          const fieldName = field.name.trim();

                                          for (const otherGroup of otherGroupsInSameTab) {
                                            const otherGroupValues = allFormValues[otherGroup.groupId] || {};

                                            if (Object.prototype.hasOwnProperty.call(otherGroupValues, fieldName) && otherGroupValues[fieldName] !== "") {
                                              copiedValues[currentGroupId] = copiedValues[currentGroupId] || {};
                                              copiedValues[currentGroupId][field.name] = otherGroupValues[fieldName];

                                              break;
                                            }
                                          }
                                        });
                                        setTimeout(() => {
                                          customerForm.setFieldsValue(copiedValues);
                                        }, 0);

                                        setFormDataCache((prev) => {
                                          const prevTabData = prev[activeTab] || {};
                                          const mergedTabData = {
                                            ...prevTabData,
                                            ...copiedValues, // this works since structure matches handleChange
                                          };
                                          return {
                                            ...prev,
                                            [activeTab]: mergedTabData,
                                          };
                                        });
                                      }}
                                    />
                                    <span style={{ fontWeight: 500, fontSize: "14px", color: "#0F0718" }}>{group.description || "Toggle"}</span>
                                  </div>
                                )}
                              </div>
                            )}

                            {isExpanded && (
                              <>
                                {group.groupName?.toLowerCase().includes("address") && (
                                  <div style={{ marginBottom: "16px" }}>
                                    {(() => {
                                      const name = group.groupName?.toLowerCase() || "";
                                      const isInvoice = name.includes("invoice") || name.includes("invoic");
                                      const isAddressGroup = name.includes("address");
                                      const addressList = isInvoice ? selectedB2BCustomer?.invoiceAddresses || [] : selectedB2BCustomer?.deliveryAddresses || [];
                                      if (!isAddressGroup || addressList.length <= 1) {
                                        return null;
                                      }
                                      return (
                                        <>
                                          <label style={{ fontWeight: 600, fontSize: "1.05em", color: "#0F0718", display: "block", marginBottom: "8px" }}>
                                            Select {group.groupName}
                                          </label>

                                          <Select
                                            placeholder={`Select ${group.groupName}`}
                                            className="custom-select"
                                            style={{ width: "70%", height: "44px", lineHeight: "44px", borderRadius: "6px", border: "1px solid #92909880" }}
                                            value={isInvoice ? selectedInvoiceAddress : selectedDeliveryAddress}
                                            onChange={(value) => {
                                              if (isInvoice) {
                                                const selectedAddr = selectedB2BCustomer?.invoiceAddresses?.find((a) => a.s_customer_address_id === value);
                                                setSelectedInvoiceAddress(value);
                                                fillAddressFields(selectedAddr, group, "invoice", selectedB2BCustomer);
                                              } else {
                                                const selectedAddr = selectedB2BCustomer?.deliveryAddresses?.find((a) => a.s_customer_address_id === value);
                                                setSelectedDeliveryAddress(value);
                                                fillAddressFields(selectedAddr, group, "delivery", selectedB2BCustomer);
                                              }
                                            }}
                                          >
                                            {addressList.map((addr) => (
                                              <Option key={addr.s_customer_address_id} value={addr.s_customer_address_id}>
                                                {`${addr.line1 || ""}, ${addr.line2 || ""}, ${addr.city || ""} - ${addr.pincode || ""}`}
                                              </Option>
                                            ))}
                                          </Select>
                                        </>
                                      );
                                    })()}
                                  </div>
                                )}
                                <Row gutter={[16, 0]}>
                                  {group.fields
                                    .filter((field) => {
                                      const isCurrentTab = field.tabId === activeTab;
                                      const isVisible = field.visible;
                                      const isBusinessTab = activeTabName.toLocaleLowerCase() === "business";
                                      const isContactTab = activeTabName.toLocaleLowerCase() === "contact";
                                      const allowBusinessFields = !isBusinessTab || (isBusinessTab && isB2BEnabled);
                                      if (isContactTab && field.name.toLowerCase().includes("pan") && !isPanCustomer) {
                                        return false;
                                      }
                                      return isCurrentTab && isVisible && allowBusinessFields;
                                    })
                                    // .sort((a, b) => a.order - b.order)
                                    .sort((a, b) => {
                                      const isContactTab = activeTabName.toLowerCase() === "contact";
                                      const isPanField = (field) => field.name?.toLowerCase().includes("pan");
                                      if (isContactTab && isPanCustomer) {
                                        const aIsPan = isPanField(a);
                                        const bIsPan = isPanField(b);
                                        if (aIsPan && !bIsPan) return -1;
                                        if (!aIsPan && bIsPan) return 1;
                                      }
                                      return a.order - b.order;
                                    })
                                    .map((field) => (
                                      <Col span={12} key={field.id}>
                                        <div style={{ borderRadius: "6px", paddingRight: "0px" }}>
                                          <label style={{ fontWeight: 600, fontSize: "1.1em", color: "#0F0718" }}>
                                            {field.name} {field.mandatory && <span style={{ color: "red" }}>*</span>}
                                          </label>
                                          <Form.Item
                                            // name={field.name}
                                            // name={[group.groupId, field.name]}
                                            // name={group.groupId ? [group.groupId, field.name] : field.name}
                                            name={group.groupId ? [String(group.groupId).toLowerCase(), toCamelCase(field.name)] : toCamelCase(field.name)}
                                            key={field.id}
                                            rules={[
                                              { required: field.mandatory, message: `${field.name} is required` },
                                              ...(field.validation
                                                ? [
                                                    {
                                                      pattern: new RegExp(field.validation),
                                                      message: `Please enter a valid ${field.name}`,
                                                    },
                                                  ]
                                                : []),
                                            ]}
                                            initialValue={getStaticDisplayValue(field.defaultValue)}
                                          >
                                            {field.type === "text" || field.type === "textarea" || field.type === "email" || field.type === "number" || field.type === "phone" ? (
                                              (() => {
                                                const isGstField = field.name?.toLowerCase().includes("gst");
                                                // const isMobileField = field.type === "phone";
                                                const normalizedFieldName = field.name?.toLowerCase().replace(/\s+/g, "");
                                                const isMobileField = normalizedFieldName.startsWith("mobile") || normalizedFieldName.startsWith("phone");
                                                const isPanMobileReadonly = isPanCustomer === true && panCustomerInfo?.panHasMobile === true && isMobileField;
                                                const fieldPath = group.groupId ? [String(group.groupId).toLowerCase(), toCamelCase(field.name)] : toCamelCase(field.name);

                                                const gstValue = customerForm.getFieldValue(fieldPath);

                                                const isReadOnly = isGstField || isPanMobileReadonly;

                                                return (
                                                  <Input
                                                    type={field.type === "phone" ? "tel" : field.type}
                                                    placeholder={field.placeholder}
                                                    value={gstValue}
                                                    readOnly={isReadOnly}
                                                    disabled={isReadOnly}
                                                    required={field.mandatory}
                                                    pattern={field.validation || undefined}
                                                    onInput={
                                                      field.type === "phone" || field.type === "number"
                                                        ? (e) => {
                                                            if (!isReadOnly) {
                                                              e.target.value = e.target.value.replace(/\D/g, "");
                                                            }
                                                          }
                                                        : undefined
                                                    }
                                                    onChange={(e) => {
                                                      if (!isReadOnly) {
                                                        handleChange(e, field, group.groupId);
                                                      }
                                                    }}
                                                    onKeyDown={(e) => handleApiEnterValidation(e, field)}
                                                    style={{
                                                      width: "100%",
                                                      paddingLeft: "8px",
                                                      borderRadius: "4px",
                                                      height: "7vh",
                                                      border: "1px solid #d9d9d9",
                                                      marginTop: "10px",
                                                      backgroundColor: isReadOnly ? "#f5f5f5" : "#fff",
                                                      cursor: isReadOnly ? "not-allowed" : "text",
                                                    }}
                                                  />
                                                );
                                              })()
                                            ) : field.type === "select" ? (
                                              (() => {
                                                let staticOptions = [];
                                                if (field.dataSource?.type === "static" && field.defaultValue) {
                                                  try {
                                                    const parsed = JSON.parse(field.defaultValue);
                                                    staticOptions = Object.entries(parsed).map(([key, value]) => ({ key, value }));
                                                  } catch {}
                                                }
                                                const dynamicOptions = optionsMap[field.id] || [];
                                                // const selectValue = formDataCache?.[activeTab]?.[group.groupId]?.[field.name] ?? field.defaultValue ?? "";
                                                const selectValue =
                                                  formDataCache?.[activeTab]?.[group.groupId]?.[field.name] ??
                                                  customerForm.getFieldValue(group.groupId ? [group.groupId, field.name] : field.name) ??
                                                  "";
                                                let displayValue = selectValue;
                                                // if (field.dataSource?.type === "static" && field.defaultValue) {
                                                //   try {
                                                //     const parsed = JSON.parse(field.defaultValue);
                                                //     if (parsed[selectValue]) {
                                                //       displayValue = parsed[selectValue];
                                                //     }
                                                //   } catch {}
                                                // }

                                                if (field.dataSource?.type === "static" && field.defaultValue) {
                                                  try {
                                                    const parsed = JSON.parse(field.defaultValue);
                                                    const reverseMap = Object.fromEntries(Object.entries(parsed).map(([key, value]) => [value, key]));

                                                    if (reverseMap[selectValue]) {
                                                      selectValue = reverseMap[selectValue];
                                                    }
                                                  } catch {}
                                                }
                                                return (
                                                  <Select
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                                    value={selectValue}
                                                    className="custom-select"
                                                    dropdownStyle={{ maxHeight: 150, overflowY: "auto" }}
                                                    required={field.mandatory}
                                                    style={{
                                                      width: "100%",
                                                      paddingLeft: "8px",
                                                      borderRadius: "4px",
                                                      height: "7vh",
                                                      border: "1px solid #d9d9d9",
                                                      marginTop: "10px",
                                                    }}
                                                    onClick={() => {
                                                      if (field.dataSource?.type !== "static") {
                                                        fetchOptions(field);
                                                      }
                                                    }}
                                                    onChange={(e) => handleChange(e, field, group.groupId)}
                                                  >
                                                    <option value="">Select</option>
                                                    {staticOptions.length > 0 &&
                                                      staticOptions.map((opt) => (
                                                        <option key={opt.key} value={opt.key}>
                                                          {opt.value}
                                                        </option>
                                                      ))}
                                                    {staticOptions.length === 0 &&
                                                      dynamicOptions.map((opt) => (
                                                        <option key={opt.RecordID || opt.Name} value={opt.RecordID}>
                                                          {opt.Name}
                                                        </option>
                                                      ))}
                                                  </Select>
                                                );
                                              })()
                                            ) : field.type === "date" ? (
                                              <Input
                                                type="date"
                                                defaultValue={field.defaultValue}
                                                required={field.mandatory}
                                                onChange={(e) => handleChange(e, field, group.groupId)}
                                                style={{
                                                  width: "100%",
                                                  paddingLeft: "8px",
                                                  borderRadius: "4px",
                                                  height: "7vh",
                                                  border: "1px solid #d9d9d9",
                                                  marginTop: "10px",
                                                }}
                                              />
                                            ) : field.type === "yesno" ? (
                                              <Switch
                                                checked={
                                                  group.groupId
                                                    ? formDataCache?.[activeTab]?.[group.groupId]?.[field.name] === true
                                                    : formDataCache?.[activeTab]?.[field.name] === true
                                                }
                                                onChange={(checked) => handleChange({ target: { value: checked } }, field, group.groupId)}
                                              />
                                            ) : null}
                                          </Form.Item>
                                          {isPanCustomer && field.name.toLowerCase().startsWith("pan") && (
                                            <div
                                              style={{
                                                // marginTop: "5px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 500,
                                                  fontSize: "0.95em",
                                                  color: "#0F0718",
                                                  minWidth: "140px",
                                                }}
                                              >
                                                Upload PAN Card
                                              </label>

                                              <input
                                                type="file"
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                style={{
                                                  flex: 1,
                                                  height: "30px",
                                                  fontSize: "0.95em",
                                                }}
                                                onChange={async (e) => {
                                                  const file = e.target.files[0];

                                                  customerForm.setFieldsValue({
                                                    contact: {
                                                      panCardFile: file,
                                                    },
                                                  });
                                                  await handleFileUpload(e, "PAN Card");
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </Col>
                                    ))}
                                </Row>
                                {group?.groupName && <hr style={{ border: "none", borderTop: "1px solid #d1d5db", marginBottom: "16px" }} />}
                              </>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </Scrollbars>
                </>
              ) : (
                <>
                  <Row
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "6px",
                      borderRadius: "8px",
                      marginTop: "2vh",
                      height: "7vh",
                      display: "flex",
                    }}
                  >
                    <Col
                      onClick={() => setToggleCustomer(false)}
                      style={{
                        flex: 1,
                        padding: "6px 0",
                        borderRadius: "6px",
                        backgroundColor: !toggleCustomer ? "#fff" : "transparent",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        color: !toggleCustomer ? "#000" : "#8c8c8c",
                        fontWeight: !toggleCustomer ? 600 : 500,
                        boxShadow: !toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <UserOutlined /> {getMultilingualText("Contact")}
                    </Col>

                    <Col
                      onClick={() => setToggleCustomer(true)}
                      style={{
                        flex: 1,
                        padding: "6px 0",
                        borderRadius: "6px",
                        backgroundColor: toggleCustomer ? "#fff" : "transparent",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        color: toggleCustomer ? "#000" : "#8c8c8c",
                        fontWeight: toggleCustomer ? 600 : 500,
                        boxShadow: toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <InfoCircleOutlined /> {getMultilingualText("Details")}
                    </Col>
                  </Row>
                  <Scrollbars
                    renderThumbHorizontal={renderThumbHorizontalScroll}
                    renderThumbVertical={renderThumb}
                    style={{ height: open && showVirtualKeyboard ? "20vh" : "66vh" }}
                    // style={{ height: "58vh" }}
                  >
                    <div style={{ display: toggleCustomer ? "block" : "none", overflowX: "hidden" }}>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginTop: "1.5vh" }}>
                        <Col span={24} style={{ fontSize: "1vw" }}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", marginTop: "2vh", color: "#0F0718" }}>
                            {getMultilingualText("MAILING ADDRESS")}
                          </label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Street")}</label>
                          <Form.Item form={form} name="street" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              ref={refs.street}
                              onFocus={() => {
                                onFocusInput("street");
                              }}
                              value={getInputValue("street")}
                              onChange={onChangeInput}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Street"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("City")}</label>
                          <Form.Item form={form} name="city" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              ref={refs.city}
                              value={getInputValue("city")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("city");
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="City"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("State")}</label>
                          <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              readOnly
                              onFocus={() => {
                                onFocusInput("state");
                              }}
                              value={getInputValue("state")}
                              onChange={onChangeInput}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Enter State"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Country")}</label>
                          <Form.Item name="country" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              readOnly
                              onFocus={() => {
                                onFocusInput("country");
                              }}
                              value={getInputValue("country")}
                              onChange={onChangeInput}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Enter Country"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Pincode")}</label>
                          <Form.Item form={form} name="pincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              ref={refs.pincode}
                              value={getInputValue("pincode")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("pincode");
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Enter Pincode"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row
                        style={{
                          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "1.5vh",
                          width: "80.2vw",
                          fontSize: "1vw",
                        }}
                      >
                        <Col
                          span={24}
                          style={{
                            marginTop: "2.5vh",
                          }}
                        >
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>LOYALTY</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                          <Form.Item name="loyality" valuePropName="checked" style={data.posScreenStyles.addEditCustomerModal.formItem} initialValue={true}>
                            <Switch onChange={onSwitchChange} defaultChecked />
                            <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500, paddingTop: "0.5vh", color: "#0F0718" }}>Enable loyalty for this customer</span>
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                          {enableLoyality && (
                            <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                              <Select disabled={true} style={{ width: "27.5vw", height: "7vh" }}>
                                <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                                  {loyalityType[0]?.name}
                                </Option>
                              </Select>
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", marginBottom: "2vh", width: "80.2vw", fontSize: "1vw" }}>
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>GENERAL INFORMATION</label>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
                          <Form.Item name="anniversaryDate" style={{ border: "0", height: "3vh" }}>
                            <DatePicker
                              placeholder="DD/MM/YYYY"
                              className="cutomerDobInput"
                              format="DD/MM/YYYY"
                              style={{ height: "7.3vh", border: "none", marginTop: 10, width: "95%", border: "1px solid #d9d9d9" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                          <Form.Item form={form} name="taxID" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              ref={refs.taxID}
                              value={getInputValue("taxID")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("taxID");
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Tax ID"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Date of Birth</label>
                          <Form.Item name="BirthdayDate" style={{ border: "0" }}>
                            <DatePicker
                              placeholder="DD/MM/YYYY"
                              className="cutomerDobInput"
                              format="DD/MM/YYYY"
                              style={{ width: "95%", height: "7.3vh", margin: "10px 0", border: "1px solid #d9d9d9" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                          <Form.Item name="gender" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Select size="large" style={{ border: "1px solid #d9d9d9", width: "28vw" }} className="genderSelect">
                              <Option key={"MAL"} value="MAL">
                                Male
                              </Option>
                              <Option key={"FEM"} value="FEM">
                                Female
                              </Option>
                              <Option key={"TRA"} value="TRA">
                                Transgender
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>

                    <div style={{ display: toggleCustomer ? "none" : "block", fontSize: "1vw" }}>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("First Name")}</label>
                          <Form.Item
                            form={form}
                            name="name"
                            rules={[{ required: true, message: "Please Input First Name" }]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              ref={refs.name}
                              value={getInputValue("name")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("name");
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="First Name"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Last Name")}</label>
                          <Form.Item form={form} name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              ref={refs.lastName}
                              value={getInputValue("lastName")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("lastName");
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Last Name"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Email")}</label>
                          <Form.Item form={form} name="email" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              ref={refs.email}
                              value={getInputValue("email")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("email");
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Enter Email"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Contact Number")}</label>
                          <Form.Item
                            name="mobile"
                            form={form}
                            rules={[
                              {
                                required: true,
                                validator: (_, value) => {
                                  const lengthRaw = posConfig?.customerMobileNumberLength;
                                  const lengthRequired = Number(lengthRaw);
                                  const isLengthValidNumber = !isNaN(lengthRequired) && Number.isInteger(lengthRequired) && lengthRequired > 0;

                                  if (!value) {
                                    return Promise.reject("Please Input Contact Number");
                                  }

                                  const digitsOnly = /^[0-9]+$/.test(value);
                                  if (!digitsOnly) {
                                    return Promise.reject("Only digits are allowed");
                                  }

                                  if (isLengthValidNumber && value.length !== lengthRequired) {
                                    return Promise.reject(`Mobile number must be exactly ${lengthRequired} digits`);
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              ref={refs.mobile}
                              value={getInputValue("mobile")}
                              onChange={(event) => {
                                const inputVal = event.target.value.replace(/\D/g, "");
                                const lengthRaw = posConfig?.customerMobileNumberLength;
                                const maxLen = Number(lengthRaw);
                                const isLengthValidNumber = !isNaN(maxLen) && Number.isInteger(maxLen) && maxLen > 0;

                                if (!isLengthValidNumber || inputVal.length <= maxLen) {
                                  setKeyboardInputFields({
                                    ...keyboardInputFields,
                                    mobile: inputVal,
                                  });
                                  form.setFieldsValue({ mobile: inputVal });
                                  keyboard?.current?.setInput(inputVal);
                                }
                              }}
                              onFocus={() => onFocusInput("mobile")}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Enter Contact Number"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              maxLength={posConfig?.customerMobileNumberLength}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Pincode")}</label>
                          <Form.Item
                            name="pincode"
                            form={form}
                            rules={[
                              {
                                required: false,
                                pattern: new RegExp(/\d+/g),
                                message: "Please Input Pincode",
                              },
                            ]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              ref={refs.pincode}
                              value={getInputValue("pincode")}
                              onChange={onChangeInput}
                              onFocus={() => {
                                onFocusInput("pincode");
                              }}
                              id="sm-salesHistory-customer"
                              className="customerDetailsInput"
                              placeholder="Enter Pincode"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>

                    <div style={{ display: toggleCustomer ? "block" : "none", overflowX: "hidden" }}>
                      <Row>
                        <p style={{ fontSize: "1.1em", margin: 0, fontWeight: "600", color: "#0F0718" }}>Additional Information</p>
                        <div style={{ backgroundColor: "#fff", padding: "1vh 0", margin: "0 2vw 2vh 0", width: "80.6vw", fontSize: "1vw" }}>
                          <Col span={24}>
                            <Row style={{ padding: "3px 0" }}>
                              <Col span={12} className="addtInfo">
                                Last Visit Date
                              </Col>
                              <Col span={2}>:</Col>
                              <Col span={9} offset={1} className="addtInfo">
                                {cart?.customer?.lastVisitDate ? cart?.customer?.lastVisitDate || "0" : selectedEditOldCustomer?.lastVisitDate || "0"}
                              </Col>
                            </Row>
                            <Row style={{ padding: "3px 0" }}>
                              <Col span={12} className="addtInfo">
                                No Of Visits
                              </Col>
                              <Col span={2}>:</Col>
                              <Col span={9} offset={1} className="addtInfo">
                                {cart?.customer?.noOfVisits ? cart?.customer?.noOfVisits || "0" : selectedEditOldCustomer?.noOfVisits || "0"}
                              </Col>
                            </Row>
                            <Row style={{ padding: "3px 0" }}>
                              <Col span={12} className="addtInfo">
                                Last Billing Amount
                              </Col>
                              <Col span={2}>:</Col>
                              <Col span={9} offset={1} className="addtInfo">
                                {cart?.customer?.lastBillingAmount ? cart?.customer?.lastBillingAmount || "0" : selectedEditOldCustomer?.lastBillingAmount || "0"}
                              </Col>
                            </Row>
                            <Row style={{ padding: "3px 0" }}>
                              <Col span={12} className="addtInfo">
                                Average Basket Value
                              </Col>
                              <Col span={2}>:</Col>
                              <Col span={9} offset={1} className="addtInfo">
                                {cart?.customer?.averageBasketValue ? cart?.customer?.averageBasketValue || "0" : selectedEditOldCustomer?.averageBasketValue || "0"}
                              </Col>
                            </Row>
                            <Row style={{ padding: "3px 0" }}>
                              <Col span={12} className="addtInfo">
                                Loyalty Balance Points
                              </Col>
                              <Col span={2}>:</Col>
                              <Col span={9} offset={1} className="addtInfo">
                                {cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}
                              </Col>
                            </Row>
                            <Row style={{ padding: "3px 0" }}>
                              <Col span={12} className="addtInfo">
                                Credit Balance
                              </Col>
                              <Col span={2}>:</Col>
                              <Col span={9} offset={1} className="addtInfo">
                                {cart?.customer?.creditLimit ? cart?.customer?.creditLimit || " " : selectedEditOldCustomer?.creditLimit || " "}
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      </Row>
                    </div>
                  </Scrollbars>
                </>
              )}

              <hr style={{ border: "none", borderTop: "1px solid #d1d5db", marginBottom: "16px" }} />

              <Row justify="end" style={{ marginTop: "2vh" }}>
                <Col>
                  <button
                    style={{
                      padding: "6px 16px",
                      border: "1px solid #ccc",
                      height: "6vh",
                      background: "#fff",
                      borderRadius: "6px",
                      marginRight: "12px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setDisplayAddNewCustomer(false);
                    }}
                  >
                    Cancel
                  </button>
                </Col>
                <Col>
                  <button
                    style={{
                      padding: "6px 16px",
                      background: isSubmittingCustomer ? "#999" : "#2F3856",
                      height: "6vh",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "bold",
                      cursor: isSubmittingCustomer ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "160px",
                      gap: "10px",
                    }}
                    disabled={isSubmittingCustomer}
                    onClick={async () => {
                      if (retailCustomerFields && retailCustomerFields.length > 0) {
                        if (isLocked.current) return;

                        isLocked.current = true;
                        setIsSubmittingCustomer(true);

                        try {
                          const currentTabFormValues = customerForm.getFieldsValue(true);
                          if (currentTabFormValues?.panCard) {
                            if (!currentTabFormValues?.contact?.panCardFile) {
                              return new Promise((resolve) => {
                                Modal.warning({
                                  title: "PAN File Required",
                                  content: "Please upload PAN file to proceed.",
                                  okText: "OK",
                                  okButtonProps: { style: { display: "inline-block" } },
                                  cancelButtonProps: { style: { display: "none" } }, // No cancel button
                                  onOk: () => {
                                    resolve(false); // Stop further execution
                                  },
                                });
                              });
                            }
                          }

                          if (currentTabFormValues?.gstNo && currentTabFormValues?.panCard) {
                            const enteredPAN = currentTabFormValues?.panCard?.trim()?.toUpperCase();
                            const gstPAN = currentTabFormValues?.gstNo?.substring(2, 12)?.toUpperCase(); // PAN part inside GST

                            if (enteredPAN !== gstPAN) {
                              return new Promise((resolve) => {
                                Modal.warning({
                                  title: "PAN & GST Mismatch",
                                  content: "The GST number entered does not match the provided PAN number. Please verify the GST number and enter correct details.",
                                  okText: "OK",
                                  cancelButtonProps: { style: { display: "none" } },
                                  onOk: () => {
                                    resolve(false);
                                  },
                                });
                              });
                            }
                          }

                          setFormDataCache((prev) => ({
                            ...prev,
                            [activeTab]: {
                              ...(prev[activeTab] || {}),
                              ...currentTabFormValues,
                            },
                          }));
                          const toCamelCase = (str) =>
                            str.replace(/[^a-zA-Z0-9 ]/g, "").replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
                              if (+match === 0) return "";
                              return index === 0 ? match.toLowerCase() : match.toUpperCase();
                            });

                          if (retailCustomerFields && retailCustomerFields.length > 0) {
                            const failedTab = retailCustomerTabs
                              .filter((tab) => tab.visible)
                              .sort((a, b) => a.order - b.order)
                              .find((tab) => {
                                const tabCache = formDataCache[tab.id] || {};
                                const formValues = customerForm.getFieldsValue(true);
                                const mergedData = { ...tabCache, ...formValues };

                                const isBusinessTab = tab.name?.toLowerCase().includes("business");
                                if (isBusinessTab && !isB2BEnabled) return false;

                                const currentTabFields = retailCustomerFields.filter((field) => field.tabId === tab.id && field.visible && field.mandatory);

                                return currentTabFields.some((field) => {
                                  const fieldKey = toCamelCase(field.name);
                                  if (mergedData[fieldKey]?.toString().trim()) return false;
                                  // const foundInGroup = Object.values(mergedData).some(
                                  //   (groupData) => typeof groupData === "object" && groupData !== null && groupData[fieldKey]?.toString().trim()
                                  // );
                                  const foundInGroup = Object.entries(mergedData).some(([key, groupData]) => /^group_\d+$/.test(key) && groupData?.[fieldKey]?.toString().trim());
                                  return !foundInGroup;
                                });
                              });
                            if (failedTab) {
                              setActiveTab(failedTab.id);
                              setActiveTabName(failedTab.name);
                              // notification.error({
                              //   message: "Missing Information",
                              //   description: `Please fill all required fields in "${failedTab.name}" tab.`,
                              //   duration: 3,
                              // });
                              return;
                            }

                            // 🧩 FORM DATA MERGE BLOCK
                            const currentTabValues = formDataCache[activeTab];
                            const allFormValues = {
                              ...formDataCache,
                              [activeTab]: currentTabValues,
                            };
                            const formValues = customerForm.getFieldsValue(true);
                            let mergedData = {};
                            // const mergedData = Object.values(allFormValues).reduce((acc, tabValues) => ({ ...acc, ...tabValues }), {});
                            if (isPanUpdateMode || cart?.customer?.b2cRegisteredstoreId !== null) {
                              mergedData = {
                                // ...(cart?.customer || {}),
                                ...Object.values(allFormValues).reduce((acc, tabValues) => ({ ...acc, ...tabValues }), {}),
                                ...formValues,
                              };
                            } else {
                              mergedData = Object.values(allFormValues).reduce((acc, tabValues) => ({ ...acc, ...tabValues }), {});
                            }

                            const isGroupKey = (key) => /^group_\d+$/.test(key);
                            const convertKeysToCamelCase = (obj) => {
                              // if (obj === null || typeof obj !== "object") return obj;
                              if (Array.isArray(obj)) {
                                return obj.map(convertKeysToCamelCase);
                              } else if (obj && typeof obj === "object") {
                                return Object.entries(obj).reduce((acc, [key, value]) => {
                                  if (isGroupKey(key)) {
                                    acc[key] = convertKeysToCamelCase(value);
                                  } else {
                                    const camelKey = toCamelCase(key);
                                    acc[camelKey] = convertKeysToCamelCase(value);
                                  }
                                  return acc;
                                }, {});
                              }
                              return obj;
                            };
                            const camelCasedData = convertKeysToCamelCase(mergedData);
                            // 🔐 Final static select normalization before submit
                            groupedFields.forEach((group) => {
                              group.fields.forEach((field) => {
                                if (field.type === "select" && field.dataSource?.type === "static" && field.defaultValue) {
                                  const fieldKey = toCamelCase(field.name);

                                  // Root level
                                  if (camelCasedData[fieldKey]) {
                                    camelCasedData[fieldKey] = normalizeStaticSelectValue(camelCasedData[fieldKey], field.defaultValue);
                                  }

                                  // Group level
                                  if (group.groupId && camelCasedData[group.groupId]?.[fieldKey]) {
                                    camelCasedData[group.groupId][fieldKey] = normalizeStaticSelectValue(camelCasedData[group.groupId][fieldKey], field.defaultValue);
                                  }
                                }
                              });
                            });

                            // 🔥 check refund mode directly from localStorage
                            if (localStorage.getItem("refundCustomerEdit") === "Y") {
                              // await addNewCustomer(camelCasedData);
                              const success = await addNewCustomer(camelCasedData);
                              if (!success) return;
                              localStorage.removeItem("refundCustomerEdit"); // consume flag
                            } else if (isPanUpdateMode || (retailCustomerFields && retailCustomerFields.length > 0 && cart?.customer?.b2cRegisteredstoreId !== null)) {
                              await editOldCustomer(camelCasedData);
                            } else {
                              // await addNewCustomer(camelCasedData);
                              const success = await addNewCustomer(camelCasedData);
                              if (!success) return;
                            }
                            if (cart?.salesRepId === null && posConfig?.requireSalesRepresentative === "Y") {
                              setOpenSalesRep({ flag: true, level: "order" });
                            }
                            setDisplayAddNewCustomer(false); // Close the drawer
                            customerForm.resetFields(); // Reset form fields
                            setIsB2BEnabled(false); // Reset B2B toggle
                            setIsPanUpdateMode(false);
                            setFormDataCache({}); // Clear form cache
                            setPanCustomerInfo(null);
                            setActiveTab(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.id || ""); // Reset to first visible tab
                            setActiveTabName(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.name || "");
                          } else {
                            await addCustomer();
                            setDisplayAddNewCustomer(false); // Close the drawer
                            customerForm.resetFields(); // Reset form fields
                            setIsB2BEnabled(false); // Reset B2B toggle (if applicable)
                            setIsPanUpdateMode(false);
                            setFormDataCache({}); // Clear form cache
                            setPanCustomerInfo(null);
                            setToggleCustomer(false);
                          }
                        } catch (err) {
                          console.error("Error while registering customer:", err);
                        } finally {
                          setIsSubmittingCustomer(false);
                          isLocked.current = false;
                        }
                      } else {
                        addCustomer();
                      }
                    }}
                  >
                    {isSubmittingCustomer ? (
                      <>
                        <span className="loader" />
                        {localStorage.getItem("refundCustomerEdit") === "Y"
                          ? "Registering..."
                          : isPanUpdateMode || cart?.customer?.b2cRegisteredstoreId !== null
                            ? "Updating..."
                            : "Registering..."}
                      </>
                    ) : localStorage.getItem("refundCustomerEdit") === "Y" ? (
                      "Register Customer"
                    ) : isPanUpdateMode || (retailCustomerFields && retailCustomerFields.length > 0 && cart?.customer?.b2cRegisteredstoreId !== null) ? (
                      "Update Customer"
                    ) : (
                      "Register Customer"
                    )}
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Drawer>
      {/* ADD NEW CUSTOMER MODAL END*/}

      {/* EDIT CUSTOMER MODAL BEGIN*/}
      <Modal
        // visible={displayEditOldCustomer}
        onCancel={() => {
          form.resetFields();
          closeCustomerSearch();
          setDisplayEditOldCustomer(false);
          setEditFlag(false);
        }}
        footer={null}
        width="53%"
        closable={false}
        bodyStyle={{ padding: 20, backgroundColor: "#F3F4F9" }}
      >
        {displayEditOldCustomer && editFlag ? (
          <Form key={"editCustomer"} form={form} name="editCustomer" onFinish={editOldCustomer}>
            <Row style={{ paddingBottom: "2vh" }}>
              <Col span={24}>
                <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>Edit Customer</span>
                <Button.Group>
                  <Button
                    style={{
                      backgroundColor: !toggleCustomer ? "#2F3856" : "#fff",
                      color: toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(false)}
                  >
                    Contact
                  </Button>
                  <Button
                    style={{
                      backgroundColor: toggleCustomer ? "#2F3856" : "#fff",
                      color: !toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(true)}
                  >
                    Details
                  </Button>
                </Button.Group>
                <img
                  onClick={() => {
                    form.resetFields();
                    closeCustomerSearch();
                    setDisplayEditOldCustomer(false);
                    setEditFlag(false);
                  }}
                  style={{ float: "right", cursor: "pointer" }}
                  src={closeX}
                  alt=""
                />
              </Col>
            </Row>
            <Scrollbars thumbSize={100} renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: "40vh" }}>
              <div style={{ display: toggleCustomer ? "block" : "none" }}>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>MAILING ADDRESS</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                    <Form.Item name="street" rules={[{ required: true, message: "Please Input Street" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Street" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                    <Form.Item name="city" rules={[{ required: true, message: "Please Input City" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="City" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>State</label>
                    <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input readOnly className="customerDetailsInput" placeholder="Enter State" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Country</label>
                    <Form.Item name="country" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input readOnly className="customerDetailsInput" placeholder="Enter Country" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                    <Form.Item name="pincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>SETTINGS</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                    {enableLoyality && (
                      <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                        <Select disabled={true}>
                          <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                            {loyalityType[0]?.name}
                          </Option>
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                    <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Select>
                        <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                          {loyalityType[0]?.name}
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>ADDITIONAL INFORMATION</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
                    <Form.Item name="AnniversaryDate" style={{ border: "0" }}>
                      <DatePicker placeholder="DD/MM/YYYY" className="cutomerAniversaryDate" format="DD/MM/YYYY" />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                    <Form.Item name="taxID" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Tax ID" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Birthday</label>
                    <Form.Item name="birthday" style={{ border: "0" }}>
                      <DatePicker placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                    <Form.Item name="gender" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Gender" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div style={{ display: toggleCustomer ? "block" : "none" }}>
                <Row>
                  <p style={{ fontSize: "2.5vh", margin: 0, fontWeight: "600" }}>Additional Information</p>
                  <Col span={24}>
                    <Row style={{ padding: "3px 0" }}>
                      <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        Last Visit Date
                      </Col>
                      <Col span={2}>:</Col>
                      <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        {cart?.customer?.lastVisitDate ? cart?.customer?.lastVisitDate || "0" : selectedEditOldCustomer?.lastVisitDate || "0"}
                      </Col>
                    </Row>
                    <Row style={{ padding: "3px 0" }}>
                      <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        No Of Visits
                      </Col>
                      <Col span={2}>:</Col>
                      <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        {cart?.customer?.noOfVisits ? cart?.customer?.noOfVisits || "0" : selectedEditOldCustomer?.noOfVisits || "0"}
                      </Col>
                    </Row>
                    <Row style={{ padding: "3px 0" }}>
                      <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        Last Billing Amount
                      </Col>
                      <Col span={2}>:</Col>
                      <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        {cart?.customer?.lastBillingAmount ? cart?.customer?.lastBillingAmount || "0" : selectedEditOldCustomer?.lastBillingAmount || "0"}
                      </Col>
                    </Row>
                    <Row style={{ padding: "3px 0" }}>
                      <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        Average Basket Value
                      </Col>
                      <Col span={2}>:</Col>
                      <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        {cart?.customer?.averageBasketValue ? cart?.customer?.averageBasketValue || "0" : selectedEditOldCustomer?.averageBasketValue || "0"}
                      </Col>
                    </Row>
                    <Row style={{ padding: "3px 0" }}>
                      <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        Loyalty Balance Points
                      </Col>
                      <Col span={2}>:</Col>
                      <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        {cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}
                      </Col>
                    </Row>
                    <Row style={{ padding: "3px 0" }}>
                      <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        Credit Balance
                      </Col>
                      <Col span={2}>:</Col>
                      <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                        {cart?.customer?.creditBalance ? cart?.customer?.creditBalance || " " : selectedEditOldCustomer?.creditBalance || " "}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div style={{ display: toggleCustomer ? "none" : "block" }}>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                    <Form.Item name="editName" rules={[{ required: true, message: "Please Input Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                    <Form.Item name="editLastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input className="customerDetailsInput" placeholder="Enter Last Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                    <Form.Item
                      name="editEmail"
                      rules={[
                        {
                          required: false,
                          pattern: new RegExp(/\S+@\S+\.\S+/),
                          message: "Please Input Valid Email",
                        },
                      ]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input className="customerDetailsInput" placeholder="Enter Email" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>
                    <Form.Item
                      name="editMobile"
                      rules={[
                        {
                          required: false,
                          pattern: new RegExp(/\d+/g),
                          message: "Please Input Mobile",
                        },
                      ]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input className="customerDetailsInput" placeholder="Enter Contact Number" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                    <Form.Item
                      name="editPincode"
                      rules={[
                        {
                          required: false,
                          pattern: new RegExp(/\d+/g),
                          message: "Please Input Pincode",
                        },
                      ]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Scrollbars>
            <Row>
              <Col xs={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                <Form.Item style={{ paddingTop: "3vh", fontSize: "1vw" }}>
                  <Button className="customerDetailsSubmitBtnBtn" style={data.posScreenStyles.addEditCustomerModal.customerDetailsSubmitBtn} htmlType="submit">
                    Save & Proceed
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        ) : toggleCustomer ? (
          <Form key={"viewCustomer"} name="viewCustomer" form={form}>
            <Row style={{ paddingBottom: "2vh" }}>
              <Col span={24}>
                <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>View Customer</span>
                <Button.Group>
                  <Button
                    style={{
                      backgroundColor: !toggleCustomer ? "#2F3856" : "#fff",
                      color: toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(false)}
                  >
                    Contact
                  </Button>
                  <Button
                    style={{
                      backgroundColor: toggleCustomer ? "#2F3856" : "#fff",
                      color: !toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(true)}
                  >
                    Details
                  </Button>
                </Button.Group>
                <img
                  onClick={() => {
                    form.resetFields();
                    closeCustomerSearch();
                    setDisplayEditOldCustomer(false);
                    setEditFlag(false);
                  }}
                  style={{ float: "right", cursor: "pointer" }}
                  src={closeX}
                  alt=""
                />
              </Col>
            </Row>
            <Scrollbars thumbSize={100} renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: "37vh" }}>
              <div style={{ display: toggleCustomer ? "block" : "none" }}>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>MAILING ADDRESS</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                    <Form.Item
                      disabled={true}
                      name="street"
                      rules={[{ required: true, message: "Please Input Street" }]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input disabled={true} className="customerDetailsInput" placeholder="Street" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                    <Form.Item name="city" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input disabled={true} className="customerDetailsInput" placeholder="City" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>State</label>
                    <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input disabled={true} className="customerDetailsInput" placeholder="Enter State" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Country</label>
                    <Form.Item name="country" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input disabled={true} className="customerDetailsInput" placeholder="Enter Country" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                    <Form.Item name="pincode" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input disabled={true} className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>SETTINGS</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                    <Form.Item name="loyality" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Switch onChange={onSwitchChange} defaultChecked />
                      &nbsp; <span style={{ fontFamily: "Inter", fontSize: "1vw", fontWeight: 500 }}>Enable loyalty for this customer </span>
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ padding: "0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                    {enableLoyality && (
                      <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                        <Select disabled={true}>
                          <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                            {loyalityType[0]?.name}
                          </Option>
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                </Row>
                <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh" }}>
                  <Col span={24}>
                    <label style={{ fontSize: "1.2vh", fontWeight: 600, letterSpacing: "1.5px" }}>ADDITIONAL INFORMATION</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
                    <Form.Item name="anniversaryDate" disabled={true} style={{ border: "0" }}>
                      <DatePicker disabled={true} placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                    <Form.Item name="taxID" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input disabled={true} className="customerDetailsInput" placeholder="Tax ID" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Birthday</label>
                    <Form.Item name="birthday" disabled={true} style={{ border: "0" }}>
                      <DatePicker disabled={true} placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" />
                    </Form.Item>
                  </Col>
                  <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                    <Form.Item name="gender" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input disabled={true} className="customerDetailsInput" placeholder="Enter Gender" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>
                </Row>
                <div style={{ backgroundColor: "#fff", padding: "2vh 2vw" }}>
                  <Row>
                    <p style={{ fontSize: "2.5vh", margin: 0, fontWeight: "600" }}>Additional Information</p>
                    <Col span={24}>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          Last Visit Date
                        </Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          {cart?.customer?.lastVisitDate ? cart?.customer?.lastVisitDate || "0" : selectedEditOldCustomer?.lastVisitDate || "0"}
                        </Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          No Of Visits
                        </Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          {cart?.customer?.noOfVisits ? cart?.customer?.noOfVisits || "0" : selectedEditOldCustomer?.noOfVisits || "0"}
                        </Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          Last Billing Amount
                        </Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          {cart?.customer?.lastBillingAmount ? cart?.customer?.lastBillingAmount || "0" : selectedEditOldCustomer?.lastBillingAmount || "0"}
                        </Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          Average Basket Value
                        </Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          {cart?.customer?.averageBasketValue ? cart?.customer?.averageBasketValue || "0" : selectedEditOldCustomer?.averageBasketValue || "0"}
                        </Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          Loyalty Balance Points
                        </Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          {cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}
                        </Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          Credit Balance
                        </Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} style={{ fontSize: "1.8vh", fontWeight: "500", color: "#0F0718" }}>
                          {cart?.customer?.creditBalance ? cart?.customer?.creditBalance || " " : selectedEditOldCustomer?.creditBalance || " "}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            </Scrollbars>
          </Form>
        ) : (
          <Form key={"editCustomer"} form={form} name="editCustomer" onFinish={editOldCustomer}>
            <Row style={{ paddingBottom: "2vh" }}>
              <Col span={24}>
                <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>Edit Customer</span>
                <Button.Group>
                  <Button
                    style={{
                      backgroundColor: !toggleCustomer ? "#2F3856" : "#fff",
                      color: toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(false)}
                  >
                    Contact
                  </Button>
                  <Button
                    style={{
                      backgroundColor: toggleCustomer ? "#2F3856" : "#fff",
                      color: !toggleCustomer ? "#929098" : "#fff",
                      fontSize: "0.8vw",
                      fontWeight: "400",
                      height: "4vh",
                      borderRadius: "3px",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={() => setToggleCustomer(true)}
                  >
                    Details
                  </Button>
                </Button.Group>
                <img
                  onClick={() => {
                    form.resetFields();
                    closeCustomerSearch();
                    setDisplayEditOldCustomer(false);
                    setEditFlag(false);
                  }}
                  style={{ float: "right", cursor: "pointer" }}
                  src={closeX}
                  alt=""
                />
              </Col>
            </Row>

            <Scrollbars
              thumbSize={100}
              // renderView={renderView}
              renderThumbHorizontal={renderThumbHorizontalScroll}
              renderThumbVertical={renderThumb}
              style={{ height: "37vh" }}
            >
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                  <Form.Item name="editName" rules={[{ required: true, message: "Please Input Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" placeholder="Enter Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                  <Form.Item name="editLastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" placeholder="Enter Last Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                  <Form.Item
                    name="editEmail"
                    rules={[
                      {
                        required: false,
                        pattern: new RegExp(/\S+@\S+\.\S+/),
                        message: "Please Input Valid Email",
                      },
                    ]}
                    style={data.posScreenStyles.addEditCustomerModal.formItem}
                  >
                    <Input className="customerDetailsInput" placeholder="Enter Email" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingLeft: 15 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>
                  <Form.Item
                    name="editMobile"
                    rules={[
                      {
                        required: false,
                        pattern: new RegExp(/\d+/g),
                        message: "Please Input Mobile",
                      },
                    ]}
                    style={data.posScreenStyles.addEditCustomerModal.formItem}
                  >
                    <Input className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ paddingRight: 15 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                  <Form.Item
                    name="editPincode"
                    rules={[
                      {
                        required: false,
                        pattern: new RegExp(/\d+/g),
                        message: "Please Input Pincode",
                      },
                    ]}
                    style={data.posScreenStyles.addEditCustomerModal.formItem}
                  >
                    <Input className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} readOnly />
                  </Form.Item>
                </Col>
              </Row>
            </Scrollbars>
          </Form>
        )}
      </Modal>
      <Drawer
        visible={displayEditOldCustomer}
        placement="right"
        footer={null}
        closable={false}
        onValuesChange={(changedValues, allValues) => {}}
        bodyStyle={{
          paddingTop: 0,
          backgroundColor: "#ffffff",
        }}
        width="62%"
      >
        <Spin spinning={loading}>
          {retailCustomerFields && retailCustomerFields.length > 0 ? (
            <>
              <Form key={"addCustomer"} form={customerForm} name="addCustomer">
                <Row style={{ display: "flex", alignItems: "center", marginTop: "2.5vh", justifyContent: "center" }}>
                  <Col span={22} style={{ display: "flex", alignItems: "center" }}>
                    <UserOutlined style={{ fontSize: "20px", marginRight: "0.3em" }} />
                    <p style={{ marginBottom: 0, fontSize: "1.5em", fontWeight: 500, color: "#0F0718" }}>{isViewMode ? "View Customer" : "Edit Customer"}</p>
                  </Col>
                  <Col span={2} style={{ textAlign: "right", marginTop: "0.7vh" }}>
                    <img
                      src={closeX}
                      style={{ cursor: "pointer", width: "1.5vw" }}
                      onClick={() => {
                        // setDisplayCustomerSearch(true);
                        setDisplayEditOldCustomer(false);
                        setCustomerSearchInput("");
                        setCustomerSearchResults();
                        setIsViewMode(false);
                        customerForm.resetFields();
                        setIsB2BEnabled(false);
                        setIsPanUpdateMode(false);
                        setFormDataCache({});
                        setPanCustomerInfo(null);
                        setActiveTab(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.id || "");
                        setActiveTabName(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.name || "");
                        setExpandedGroups({});
                      }}
                    />
                  </Col>
                </Row>
                <>
                  <Row
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "6px",
                      borderRadius: "8px",
                      marginTop: "2vh",
                      height: "8vh",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {retailCustomerTabs
                      .filter((tab) => tab.visible)
                      .sort((a, b) => a.order - b.order)
                      .map((tab) => {
                        const isActive = tab.id === activeTab;
                        const isDisabled = tab.name.toLowerCase() === "business" && !customerConfigData?.b2bSettings?.enableB2BBilling;

                        return (
                          <Col
                            key={tab.id}
                            onClick={async () => {
                              if (isDisabled) return;
                              const currentValues = await customerForm.getFieldsValue();
                              setFormDataCache((prev) => ({
                                ...prev,
                                [activeTab]: currentValues,
                              }));
                              if (formDataCache[tab.id]) {
                                customerForm.setFieldsValue(formDataCache[tab.id]);
                              }
                              setActiveTab(tab.id);
                              setActiveTabName(tab.name);
                            }}
                            style={{
                              flex: 1,
                              padding: "6px 0",
                              borderRadius: "6px",
                              backgroundColor: isActive ? "#fff" : "transparent",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: isActive ? "#000" : "#8c8c8c",
                              // color: isDisabled ? "red" : isActive ? "#000" : "#8c8c8c",
                              fontWeight: isActive ? 600 : 500,
                              boxShadow: isActive ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                              transition: "all 0.2s ease",
                            }}
                          >
                            <span style={{ marginRight: 6 }}>{iconMap[tab.icon]}</span>
                            {tab.name}
                          </Col>
                        );
                      })}
                  </Row>

                  <Scrollbars style={{ height: "73vh", paddingRight: "12px" }} autoHide>
                    {activeTabName === "Business" && customerConfigData?.b2bSettings?.enableB2BBilling && (
                      <div
                        style={{
                          paddingLeft: "1px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "25px",
                          marginBottom: "16px",
                        }}
                        ref={searchContainerRef}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "1.5vw" }}>
                          <div style={{ fontWeight: 600, fontSize: "16px" }}>Business Customer (B2B)</div>
                          <Switch checked={isB2BEnabled} onChange={(checked) => setIsB2BEnabled(checked)} />
                        </div>
                        {isB2BEnabled && (
                          <div style={{ position: "relative", width: "60%" }}>
                            {/* <div style={{ position: "relative", flex: 1 }}> */}
                            <Input
                              // placeholder="Search B2B Customers..."
                              placeholder={searchByName ? "Search B2B Customers by Name..." : "Search B2B Customers by Tax ID..."}
                              allowClear
                              value={lastSearchedValue}
                              disabled={isViewMode}
                              onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (!searchByName && lastSearchedValue.trim()) {
                                    try {
                                      setLoading(true);
                                      const gstResponse = await validateGSTNumber(lastSearchedValue.trim());
                                      if (gstResponse?.valid) {
                                        const mappedValues = mapGSTToFormValuesDynamic(gstResponse, groupedFields);
                                        customerForm.setFieldsValue(mappedValues);
                                        setFormDataCache((prev) => ({
                                          ...prev,
                                          [activeTab]: {
                                            ...(prev[activeTab] || {}),
                                            ...mappedValues,
                                          },
                                        }));
                                        setB2bSearchResults([]);
                                        setShowB2BDropdown(false);
                                      }
                                    } catch (err) {
                                      console.error("GST validation failed", err);
                                    } finally {
                                      setLoading(false);
                                    }
                                  }
                                }
                              }}
                              onChange={(e) => {
                                const v = e.target.value;
                                setLastSearchedValue(v);
                                setSelectedB2BCustomer(null);

                                if (v.trim() !== "") {
                                  setShowB2BDropdown(true);
                                  searchB2BCustomers(v);
                                } else {
                                  setShowB2BDropdown(false);
                                  setB2bSearchResults([]);
                                  customerForm.resetFields();
                                  setFormDataCache((prev) => ({ ...prev, [activeTab]: {} }));
                                }
                              }}
                              onClear={() => {
                                setLastSearchedValue("");
                                setSelectedB2BCustomer(null);
                                setB2bSearchResults([]);
                                setShowB2BDropdown(false);
                                customerForm.resetFields();
                                setFormDataCache((prev) => ({ ...prev, [activeTab]: {} }));
                              }}
                              loading={b2bLoading}
                              prefix={<SearchOutlined style={{ color: "#a0a0a0" }} />}
                              style={{
                                height: "30px",
                                borderRadius: "6px",
                                fontSize: "14px",
                                width: "65%",
                                backgroundColor: !customerConfigData?.b2bSettings?.enableB2BCustomerRegistration ? "#f5f5f5" : "#fff",
                                cursor: !customerConfigData?.b2bSettings?.enableB2BCustomerRegistration ? "not-allowed" : "text",
                              }}
                            />
                            {/* </div> */}
                            <Checkbox
                              checked={searchByName}
                              style={{ marginLeft: "1vw" }}
                              onChange={(e) => {
                                setSearchByName(e.target.checked);
                                // setLastSearchedValue("");
                                setB2bSearchResults([]);
                                setSelectedB2BCustomer(null);
                                customerForm.resetFields();
                                setFormDataCache((prev) => ({
                                  ...prev,
                                  [activeTab]: {},
                                }));
                              }}
                              disabled={isViewMode}
                            >
                              Search by Name
                            </Checkbox>

                            {showB2BDropdown && lastSearchedValue?.trim() !== "" && !selectedB2BCustomer && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  right: 0,
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                  background: "#fff",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: "6px",
                                  marginTop: "4px",
                                  zIndex: 10,
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  padding: "8px 0",
                                  width: "65%",
                                }}
                              >
                                {b2bLoading && (
                                  <div style={{ textAlign: "center", padding: "12px" }}>
                                    <Spin size="small" /> Searching…
                                  </div>
                                )}

                                {!b2bLoading && b2bSearchResults.length > 0 && (
                                  <>
                                    {b2bSearchResults.map((customer) => (
                                      <div
                                        key={customer.customerId}
                                        style={{
                                          padding: "12px 16px",
                                          borderBottom: "1px solid #f0f0f0",
                                          cursor: "pointer",
                                          transition: "background 0.2s",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f9f9f9")}
                                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                                        onClick={async () => {
                                          setB2bSearchResults([]);
                                          setLastSearchedValue(customer.customerName);
                                          setSelectedB2BCustomer(customer);
                                          const mappedValues = mapB2BDataDynamic(customer, groupedFields);

                                          const currentValues = customerForm.getFieldsValue();
                                          customerForm.setFieldsValue({
                                            ...currentValues,
                                            ...mappedValues,
                                            b2bCustomerId: customer.customerId,
                                            b2bCustomerName: customer.customerName,
                                            b2bCustomerCode: customer.customerCode,
                                          });

                                          setFormDataCache((prev) => ({
                                            ...prev,
                                            [activeTab]: {
                                              ...(prev[activeTab] || {}),
                                              ...mappedValues,
                                              b2bCustomerId: customer.customerId,
                                              b2bCustomerName: customer.customerName,
                                              b2bCustomerCode: customer.customerCode,
                                            },
                                          }));
                                        }}
                                      >
                                        <div style={{ fontWeight: 600, fontSize: "15px", color: "#1a1a1a" }}>{customer.customerName}</div>
                                        <div style={{ fontSize: "13px", color: "#666", marginTop: "2px" }}>
                                          <strong>Code:</strong> {customer.customerCode}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}

                                {!b2bLoading && lastSearchedValue?.trim() !== "" && b2bSearchResults.length === 0 && (
                                  <div style={{ textAlign: "center", padding: "12px", color: "#999" }}>No customers found</div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {activeTabName.toLowerCase() === "contact" && (
                      <div
                        style={{
                          paddingLeft: "1px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "25px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "1.5vw" }}>
                          <div style={{ fontWeight: 600, fontSize: "16px" }}>PAN Customer</div>

                          <Switch
                            checked={isPanCustomer}
                            onChange={(checked) => {
                              setIsPanCustomer(checked);
                              if (!checked) {
                                // customerForm.setFieldsValue({
                                //   contact: {
                                //     panNo: "",
                                //   },
                                // });
                                clearPanFields();
                                setPanCustomerInfo(null);
                                setIsPanUpdateMode(false);
                              }
                            }}
                          />
                          {panCustomerInfo?.realStatus && (
                            <div
                              style={{
                                padding: "4px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: 600,
                                background:
                                  panCustomerInfo.realStatus === "VALID & OPERATIVE" ? "#dcfce7" : panCustomerInfo.realStatus === "VALID & INOPERATIVE" ? "#fef3c7" : "#fee2e2",
                                color:
                                  panCustomerInfo.realStatus === "VALID & OPERATIVE" ? "#166534" : panCustomerInfo.realStatus === "VALID & INOPERATIVE" ? "#92400e" : "#991b1b",
                              }}
                            >
                              {panCustomerInfo.realStatus}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div style={{ overflowX: "hidden" }}>
                      {groupedFields.map((group) => {
                        const isExpanded = group.collapsible ? !expandedGroups[group.groupId] : true;
                        const isToggled = !isExpanded;
                        return (
                          <div key={group.groupId}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "2vh",
                                marginBottom: group.groupName ? "2vh" : "1vh",
                              }}
                            >
                              <div style={{ fontWeight: 600, fontSize: "18px", color: "#0F0718" }}>{group.groupName}</div>
                              {group.collapsible && (
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                  <Switch
                                    checked={expandedGroups[group.groupId] || false}
                                    onChange={(checked) =>
                                      setExpandedGroups((prev) => ({
                                        ...prev,
                                        [group.groupId]: checked,
                                      }))
                                    }
                                  />
                                  <span style={{ fontWeight: 500, fontSize: "14px", color: "#0F0718" }}>{group.description || "Toggle"}</span>
                                </div>
                              )}
                            </div>

                            {isExpanded && (
                              <>
                                {group.groupName?.toLowerCase().includes("address") && (
                                  <div style={{ marginBottom: "16px" }}>
                                    {(() => {
                                      const name = group.groupName?.toLowerCase() || "";
                                      const isInvoice = name.includes("invoice") || name.includes("invoic");

                                      const addressList = isInvoice ? selectedB2BCustomer?.invoiceAddresses || [] : selectedB2BCustomer?.deliveryAddresses || [];

                                      // Get the default value from customerForm for edit mode
                                      const editValue = customerForm?.getFieldValue([group.groupId, isInvoice ? "invoiceAddress" : "deliveryAddress"]);
                                      return (
                                        <>
                                          <label
                                            style={{
                                              fontWeight: 600,
                                              fontSize: "1.05em",
                                              color: "#0F0718",
                                              display: "block",
                                              marginBottom: "8px",
                                            }}
                                          >
                                            Select {group.groupName}
                                          </label>

                                          <Select
                                            placeholder={`Select ${group.groupName}`}
                                            style={{
                                              width: "100%",
                                              height: "44px",
                                              borderRadius: "6px",
                                            }}
                                            disabled={isViewMode}
                                            value={editValue}
                                            onChange={(value) => {
                                              // Merge existing values under this group
                                              const existingGroupValues = customerForm.getFieldValue(group.groupId) || {};

                                              customerForm.setFieldsValue({
                                                [group.groupId]: {
                                                  ...existingGroupValues,
                                                  [isInvoice ? "invoiceAddress" : "deliveryAddress"]: value,
                                                },
                                              });

                                              const selectedAddr = addressList.find((a) => a.s_customer_address_id === value);

                                              fillAddressFields(selectedAddr, group.groupId, isInvoice ? "invoice" : "delivery", selectedB2BCustomer);
                                            }}
                                          >
                                            {addressList.map((addr) => (
                                              <Select.Option key={addr.s_customer_address_id} value={addr.s_customer_address_id}>
                                                {`${addr.line1 || ""}, ${addr.line2 || ""}, ${addr.city || ""} - ${addr.pincode || ""}`}
                                              </Select.Option>
                                            ))}
                                          </Select>
                                        </>
                                      );
                                    })()}
                                  </div>
                                )}
                                <Row gutter={[16, 0]}>
                                  {group.fields
                                    .filter((field) => {
                                      const isCurrentTab = field.tabId === activeTab;
                                      const isVisible = field.visible;
                                      const isBusinessTab = activeTabName.toLocaleLowerCase() === "business";
                                      const isContactTab = activeTabName.toLocaleLowerCase() === "contact";
                                      const allowBusinessFields = !isBusinessTab || (isBusinessTab && isB2BEnabled);
                                      if (isContactTab && field.name.toLowerCase().includes("pan") && !isPanCustomer) {
                                        return false;
                                      }
                                      return isCurrentTab && isVisible && allowBusinessFields;
                                    })
                                    // .sort((a, b) => a.order - b.order)
                                    .sort((a, b) => {
                                      const isContactTab = activeTabName.toLowerCase() === "contact";
                                      const isPanField = (field) => field.name?.toLowerCase().includes("pan");
                                      if (isContactTab && isPanCustomer) {
                                        const aIsPan = isPanField(a);
                                        const bIsPan = isPanField(b);
                                        if (aIsPan && !bIsPan) return -1;
                                        if (!aIsPan && bIsPan) return 1;
                                      }
                                      return a.order - b.order;
                                    })
                                    .map((field) => {
                                      const isBusinessTab = activeTabName.toLowerCase() === "business";
                                      const isB2BRegistrationEnabled = customerConfigData?.b2bSettings?.enableB2BCustomerRegistration;
                                      const isDisabledField = isBusinessTab && !isB2BRegistrationEnabled;
                                      let selectDisplayValue = null;

                                      if (field.type === "select" && field.dataSource?.type === "static" && field.defaultValue) {
                                        try {
                                          const parsed = JSON.parse(field.defaultValue);
                                          const formFieldValue = customerForm?.getFieldValue(
                                            group.groupId ? [String(group.groupId).toLowerCase(), toCamelCase(field.name)] : toCamelCase(field.name)
                                          );
                                          if (formFieldValue && parsed[formFieldValue]) {
                                            selectDisplayValue = parsed[formFieldValue];
                                          }
                                        } catch {}
                                      }
                                      return (
                                        <Col span={12} key={field.id}>
                                          <div style={{ borderRadius: "6px", paddingRight: "0px" }}>
                                            <label style={{ fontWeight: 600, fontSize: "1.1em", color: "#0F0718" }}>{field.name}</label>
                                            <Form.Item
                                              name={group.groupId ? [String(group.groupId).toLowerCase(), toCamelCase(field.name)] : toCamelCase(field.name)}
                                              key={field.id}
                                              rules={[
                                                { required: field.mandatory, message: `${field.name} is required` },
                                                ...(field.validation
                                                  ? [
                                                      {
                                                        pattern: new RegExp(field.validation),
                                                        message: `Please enter a valid ${field.name}`,
                                                      },
                                                    ]
                                                  : []),
                                              ]}
                                            >
                                              {["text", "textarea", "email", "number", "phone"].includes(field.type) ? (
                                                (() => {
                                                  const isGstField = field.name?.toLowerCase().includes("gst");
                                                  // const isMobileField = field.type === "phone";
                                                  const normalizedFieldName = field.name?.toLowerCase().replace(/\s+/g, "");
                                                  const isMobileField = normalizedFieldName.startsWith("mobile") || normalizedFieldName.startsWith("phone");
                                                  const isPanMobileReadonly = isPanCustomer === true && panCustomerInfo?.panHasMobile === true && isMobileField;
                                                  const fieldPath = group.groupId ? [String(group.groupId).toLowerCase(), toCamelCase(field.name)] : toCamelCase(field.name);
                                                  const gstValue = customerForm.getFieldValue(fieldPath);
                                                  const isReadOnly = isGstField || isPanMobileReadonly;
                                                  return (
                                                    <Input
                                                      type={field.type === "phone" ? "tel" : field.type}
                                                      placeholder={field.placeholder}
                                                      value={gstValue}
                                                      readOnly={isReadOnly}
                                                      required={field.mandatory}
                                                      disabled={isReadOnly || isViewMode || isDisabledField}
                                                      pattern={field.validation || undefined}
                                                      onInput={
                                                        field.type === "phone" || field.type === "number"
                                                          ? (e) => {
                                                              e.target.value = e.target.value.replace(/\D/g, "");
                                                            }
                                                          : undefined
                                                      }
                                                      // onChange={(e) => handleChange(e, field, group.groupId)}
                                                      onChange={(e) => {
                                                        if (!isReadOnly) {
                                                          handleChange(e, field, group.groupId);
                                                        }
                                                      }}
                                                      onKeyDown={(e) => handleApiEnterValidation(e, field)}
                                                      style={{
                                                        width: "100%",
                                                        paddingLeft: "8px",
                                                        borderRadius: "4px",
                                                        height: "7vh",
                                                        border: "1px solid #d9d9d9",
                                                        marginTop: "10px",
                                                        backgroundColor: isDisabledField ? "#f5f5f5" : "#fff",
                                                        cursor: isDisabledField ? "not-allowed" : "text",
                                                        color: "#000",
                                                      }}
                                                    />
                                                  );
                                                })()
                                              ) : field.type === "select" ? (
                                                <Select
                                                  showSearch
                                                  optionFilterProp="children"
                                                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                                  className={`custom-select ${isViewMode ? "view-mode-select" : ""}`}
                                                  required={field.mandatory}
                                                  disabled={isViewMode || isDisabledField}
                                                  style={{
                                                    width: "100%",
                                                    paddingLeft: "8px",
                                                    borderRadius: "4px",
                                                    height: "7vh",
                                                    border: "1px solid #d9d9d9",
                                                    marginTop: "10px",
                                                    backgroundColor: isDisabledField ? "#f5f5f5" : "#fff",
                                                    cursor: isDisabledField ? "not-allowed" : "pointer",
                                                  }}
                                                  dropdownStyle={{ background: "#f5f5f5", color: "#929098", fontSize: "1rem" }}
                                                  onClick={() => {
                                                    if (!isDisabledField) fetchOptions(field);
                                                  }}
                                                  onChange={(e) => handleChange(e, field, group.groupId)}
                                                >
                                                  <Select.Option value="">Select</Select.Option>
                                                  {/* {(optionsMap[field.id] || []).map((opt) => (
                                                <Select.Option key={opt.RecordID} value={opt.Name}>
                                                  {opt.Name}
                                                </Select.Option>
                                              ))} */}
                                                  {field.dataSource?.type === "static" && field.defaultValue
                                                    ? (() => {
                                                        try {
                                                          const parsed = JSON.parse(field.defaultValue);
                                                          return Object.entries(parsed).map(([key, label]) => (
                                                            <Select.Option key={key} value={key}>
                                                              {label}
                                                            </Select.Option>
                                                          ));
                                                        } catch {
                                                          return null;
                                                        }
                                                      })()
                                                    : (optionsMap[field.id] || []).map((opt) => (
                                                        <Select.Option key={opt.RecordID} value={opt.RecordID}>
                                                          {opt.Name}
                                                        </Select.Option>
                                                      ))}
                                                </Select>
                                              ) : field.type === "date" ? (
                                                <Input
                                                  type="date"
                                                  required={field.mandatory}
                                                  disabled={isViewMode || isDisabledField}
                                                  onChange={(e) => handleChange(e, field, group.groupId)}
                                                  style={{
                                                    width: "100%",
                                                    paddingLeft: "8px",
                                                    borderRadius: "4px",
                                                    height: "7vh",
                                                    border: "1px solid #d9d9d9",
                                                    marginTop: "10px",
                                                    backgroundColor: isDisabledField ? "#f5f5f5" : "#fff",
                                                    cursor: isDisabledField ? "not-allowed" : "text",
                                                  }}
                                                />
                                              ) : null}
                                            </Form.Item>
                                          </div>
                                        </Col>
                                      );
                                    })}
                                </Row>
                                {group?.groupName && <hr style={{ border: "none", borderTop: "1px solid #d1d5db", marginBottom: "16px" }} />}
                              </>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </Scrollbars>
                </>

                {!isViewMode && (
                  <Row justify="end" style={{ marginTop: "2vh" }}>
                    <Col>
                      <button
                        style={{
                          padding: "6px 16px",
                          border: "1px solid #ccc",
                          height: "6vh",
                          background: "#fff",
                          borderRadius: "6px",
                          marginRight: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setDisplayAddNewCustomer(false);
                        }}
                      >
                        Cancel
                      </button>
                    </Col>
                    <Col>
                      <button
                        style={{
                          padding: "6px 16px",
                          background: "#2F3856",
                          height: "6vh",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        onClick={async () => {
                          const currentTabValues = await customerForm.getFieldsValue();
                          const allFormValues = {
                            ...formDataCache,
                            [activeTab]: currentTabValues,
                          };

                          const allData = await customerForm.getFieldsValue(true);
                          // const mergedData = Object.values(allFormValues).reduce((acc, tabValues) => ({ ...acc, ...tabValues }), {});

                          const normalizeKeys = (obj) => {
                            if (!obj || typeof obj !== "object" || Array.isArray(obj)) return obj;

                            for (const key of Object.keys(obj)) {
                              const value = obj[key];
                              if (value && typeof value === "object" && !Array.isArray(value)) {
                                normalizeKeys(value);
                              }
                            }
                            return obj;
                          };

                          const toCamelCase = (str) => {
                            if (/^group_\d+$/i.test(str)) {
                              return str; // preserve original group key
                            }

                            return str
                              .replace(/[^a-zA-Z0-9_ ]/g, "")
                              .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
                                if (+match === 0) return "";
                                return index === 0 ? match.toLowerCase() : match.toUpperCase();
                              })
                              .replace(/_/g, "");
                          };
                          const mergedData = normalizeKeys({ ...allData });

                          const camelCasedData = Object.keys(mergedData).reduce((acc, key) => {
                            acc[toCamelCase(key)] = mergedData[key];
                            return acc;
                          }, {});

                          groupedFields.forEach((group) => {
                            group.fields.forEach((field) => {
                              if (field.type === "select" && field.dataSource?.type === "static" && field.defaultValue) {
                                const fieldKey = toCamelCase(field.name);

                                // Root level
                                if (camelCasedData[fieldKey]) {
                                  camelCasedData[fieldKey] = normalizeStaticSelectValue(camelCasedData[fieldKey], field.defaultValue);
                                }

                                // Group level
                                if (group.groupId && camelCasedData[group.groupId]?.[fieldKey]) {
                                  camelCasedData[group.groupId][fieldKey] = normalizeStaticSelectValue(camelCasedData[group.groupId][fieldKey], field.defaultValue);
                                }
                              }
                            });
                          });

                          const formatGroupKeysToCamelCase = (data) => {
                            const formatted = { ...data };
                            const hardcodedMap = {
                              streetaddress: "streetAddress",
                              companytype: "companyType",
                              gsttype: "gstType",
                            };

                            for (const key in formatted) {
                              if (key.startsWith("group_")) {
                                let value = formatted[key];

                                try {
                                  if (typeof value === "string") {
                                    try {
                                      value = JSON.parse(value);
                                    } catch (err) {
                                      console.warn(`Invalid JSON in ${key}, skipping parse.`);
                                      continue;
                                    }
                                  }

                                  if (value && typeof value === "object") {
                                    const converted = {};
                                    for (const subKey in value) {
                                      const lower = subKey.toLowerCase();
                                      const newKey = hardcodedMap[lower] || lower;
                                      converted[newKey] = value[subKey];
                                    }
                                    formatted[key] = JSON.stringify(converted);
                                  }
                                } catch (err) {
                                  console.warn(`Error processing ${key}`, err);
                                }
                              }
                            }

                            return formatted;
                          };

                          const formattedData = formatGroupKeysToCamelCase(camelCasedData);
                          editOldCustomer(formattedData);
                          setDisplayEditOldCustomer(false);
                          customerForm.resetFields();
                          setIsB2BEnabled(false);
                          setIsPanUpdateMode(false);
                          setFormDataCache({});
                          setPanCustomerInfo(null);
                          setActiveTab(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.id || "");
                          setActiveTabName(retailCustomerTabs.filter((tab) => tab.visible).sort((a, b) => a.order - b.order)[0]?.name || "");
                          setExpandedGroups({});
                          setIsViewMode(false);
                        }}
                      >
                        Update Customer
                      </button>
                    </Col>
                  </Row>
                )}
              </Form>
            </>
          ) : (
            <>
              <Row style={{ fontSize: "1vw", marginTop: "1.5vh" }}>
                <Col span={24}>
                  {displayEditOldCustomer && editFlag ? (
                    <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>Edit Customer</span>
                  ) : (
                    <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>View Customer</span>
                  )}
                  <img
                    onClick={() => {
                      form.resetFields();
                      closeCustomerSearch();
                      setDisplayEditOldCustomer(false);
                      setEditFlag(false);
                      setToggleCustomer(false);
                    }}
                    style={{ float: "right", cursor: "pointer", width: "1.5vw", marginLeft: "1vw" }}
                    src={closeX}
                    alt=""
                  />
                </Col>
              </Row>
              <Row
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "6px",
                  borderRadius: "8px",
                  marginTop: "2vh",
                  height: "7vh",
                  display: "flex",
                }}
              >
                <Col
                  onClick={() => setToggleCustomer(false)}
                  style={{
                    flex: 1,
                    padding: "6px 0",
                    borderRadius: "6px",
                    backgroundColor: !toggleCustomer ? "#fff" : "transparent",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: !toggleCustomer ? "#000" : "#8c8c8c",
                    fontWeight: !toggleCustomer ? 600 : 500,
                    boxShadow: !toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                    transition: "all 0.2s ease",
                  }}
                >
                  {getMultilingualText("Contact")}
                </Col>

                <Col
                  onClick={() => setToggleCustomer(true)}
                  style={{
                    flex: 1,
                    padding: "6px 0",
                    borderRadius: "6px",
                    backgroundColor: toggleCustomer ? "#fff" : "transparent",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: toggleCustomer ? "#000" : "#8c8c8c",
                    fontWeight: toggleCustomer ? 600 : 500,
                    boxShadow: toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
                    transition: "all 0.2s ease",
                  }}
                >
                  {getMultilingualText("Details")}
                </Col>
              </Row>

              {displayEditOldCustomer && editFlag ? (
                <Form key={"editCustomer"} form={form} name="editCustomer">
                  <Scrollbars
                    thumbSize={100}
                    renderThumbHorizontal={renderThumbHorizontalScroll}
                    renderThumbVertical={renderThumb}
                    style={{ height: open && showVirtualKeyboard ? "20vh" : "72vh" }}
                  >
                    <div style={{ display: toggleCustomer ? "block" : "none", overflowX: "hidden" }}>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginTop: "2.5vh", width: "80.5vw", fontSize: "1vw" }}>
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>MAILING ADDRESS</label>
                        </Col>
                      </Row>
                      <Row style={{ fontSize: "1vw" }}>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                          <Form.Item
                            name="street"
                            onFocus={() => {
                              onFocusInput("street");
                            }}
                            id="sm-product-search"
                            value={getInputValue("street")}
                            onChange={onChangeInput}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input className="customerDetailsInput" placeholder="Street" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                          <Form.Item
                            name="city"
                            onFocus={() => {
                              onFocusInput("city");
                            }}
                            id="sm-product-search"
                            value={getInputValue("city")}
                            onChange={onChangeInput}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input className="customerDetailsInput" placeholder="City" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>State</label>
                          <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              readOnly
                              onFocus={() => {
                                onFocusInput("state");
                              }}
                              id="sm-product-search"
                              value={getInputValue("state")}
                              onChange={onChangeInput}
                              className="customerDetailsInput"
                              placeholder="Enter State"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Country</label>
                          <Form.Item name="country" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              readOnly
                              onFocus={() => {
                                onFocusInput("country");
                              }}
                              id="sm-product-search"
                              value={getInputValue("country")}
                              onChange={onChangeInput}
                              className="customerDetailsInput"
                              placeholder="Enter Country"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                          <Form.Item name="pincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              onFocus={() => {
                                onFocusInput("pincode");
                              }}
                              id="sm-product-search"
                              value={getInputValue("pincode")}
                              onChange={onChangeInput}
                              className="customerDetailsInput"
                              placeholder="Enter Pincode"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row
                        style={{
                          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "1vh",
                          marginTop: "3vh",
                          width: "80.5vw",
                          fontSize: "1vw",
                        }}
                      >
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>LOYALTY</label>
                        </Col>
                      </Row>
                      <Row style={{ fontSize: "1vw" }}>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                          <Form.Item name="loyality" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Switch onChange={onSwitchChange} defaultChecked />
                            &nbsp; <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>Enable loyalty for this customer</span>
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                          {enableLoyality && (
                            <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                              <Select disabled={true} style={{ width: "27.5vw", height: "7vh" }}>
                                <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                                  {loyalityType[0]?.name}
                                </Option>
                              </Select>
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", marginBottom: "1vh", width: "80.5vw", fontSize: "1vw" }}>
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>GENERAL INFORMATION</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: "500" }}>Anniversary Date</label>
                          <Form.Item name="anniversaryDate" style={{ border: "0", margin: "7px 0" }}>
                            <DatePicker
                              placeholder="DD/MM/YYYY"
                              className="cutomerDobInput"
                              format="DD/MM/YYYY"
                              style={{ height: "7.5vh", border: "1px solid #d9d9d9", width: "95%" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                          <Form.Item name="taxID" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              onFocus={() => {
                                onFocusInput("taxID");
                              }}
                              id="sm-product-search"
                              value={getInputValue("taxID")}
                              onChange={onChangeInput}
                              className="customerDetailsInput"
                              placeholder="Tax ID"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Date of Birth</label>
                          <Form.Item name="birthday" style={{ border: "0", margin: "7px 0" }}>
                            <DatePicker
                              placeholder="DD/MM/YYYY"
                              className="cutomerDobInput"
                              format="DD/MM/YYYY"
                              style={{ height: "7.5vh", border: "1px solid #d9d9d9", width: "96.5%" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                          <Form.Item name="gender" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Select size="large" style={{ border: "1px solid #d9d9d9", width: "28vw" }} className="genderSelect">
                              <Option key={"MAL"} value="MAL">
                                Male
                              </Option>
                              <Option key={"FEM"} value="FEM">
                                Female
                              </Option>
                              <Option key={"TRA"} value="TRA">
                                Transgender
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <div style={{ overflowX: "hidden" }}>
                        <Row>
                          <p style={{ fontSize: "1.1em", margin: 0, fontWeight: "600", color: "#0F0718", paddingBottom: "1vh" }}>Additional Information</p>
                          <div style={{ backgroundColor: "#fff", width: "80.7vw", fontSize: "1vw" }}>
                            <Col span={24}>
                              <Row style={{ padding: "3px 0" }}>
                                <Col span={12} className="addtInfo">
                                  Last Visit Date
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.lastVisitDate ? cart?.customer?.lastVisitDate || "0" : selectedEditOldCustomer?.lastVisitDate || "0"}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0" }}>
                                <Col span={12} className="addtInfo">
                                  No Of Visits
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.noOfVisits ? cart?.customer?.noOfVisits || "0" : selectedEditOldCustomer?.noOfVisits || "0"}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0" }}>
                                <Col span={12} className="addtInfo">
                                  Last Billing Amount
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.lastBillingAmount ? cart?.customer?.lastBillingAmount || "0" : selectedEditOldCustomer?.lastBillingAmount || "0"}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0" }}>
                                <Col span={12} className="addtInfo">
                                  Average Basket Value
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.averageBasketValue ? cart?.customer?.averageBasketValue || "0" : selectedEditOldCustomer?.averageBasketValue || "0"}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0" }}>
                                <Col span={12} className="addtInfo">
                                  Loyalty Balance Points
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance.toFixed(2) || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0" }}>
                                <Col span={12} className="addtInfo">
                                  Credit Balance
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.creditLimit ? cart?.customer?.creditLimit || " " : selectedEditOldCustomer?.creditLimit || " "}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </Row>
                      </div>
                    </div>
                    <div style={{ display: toggleCustomer ? "none" : "block", fontSize: "1vw", marginTop: "2vh", overflow: "hidden" }}>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                          <Form.Item name="editName" rules={[{ required: true, message: "Please Input Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              className="customerDetailsInput"
                              onFocus={() => {
                                onFocusInput("editName");
                              }}
                              id="sm-product-search"
                              value={getInputValue("editName")}
                              onChange={onChangeInput}
                              placeholder="Enter Name"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                          <Form.Item name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              className="customerDetailsInput"
                              onFocus={() => {
                                onFocusInput("lastName");
                              }}
                              id="sm-product-search"
                              value={getInputValue("lastName")}
                              onChange={onChangeInput}
                              placeholder="Enter Last Name"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                          <Form.Item name="editEmail" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              className="customerDetailsInput"
                              onFocus={() => {
                                onFocusInput("editEmail");
                              }}
                              id="sm-product-search"
                              value={getInputValue("editEmail")}
                              onChange={onChangeInput}
                              placeholder="Enter Email"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>

                          <Form.Item
                            name="editMobile"
                            rules={[
                              {
                                required: true,
                                message: "Mobile number is required",
                              },
                              {
                                pattern: new RegExp(/^[0-9]+$/),
                                message: "Only digits are allowed",
                              },
                              {
                                validator: (_, value) => {
                                  const lengthRaw = posConfig?.customerMobileNumberLength;
                                  const lengthRequired = Number(lengthRaw);
                                  const isLengthValidNumber = !isNaN(lengthRequired) && Number.isInteger(lengthRequired) && lengthRequired > 0;

                                  if (!value) {
                                    return Promise.reject("Mobile number is required");
                                  }

                                  if (!/^[0-9]+$/.test(value)) {
                                    return Promise.reject("Only digits are allowed");
                                  }

                                  if (isLengthValidNumber && value.length !== lengthRequired) {
                                    return Promise.reject(`Mobile number must be exactly ${lengthRequired} digits`);
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              type="text"
                              value={getInputValue("editMobile")}
                              onChange={(event) => {
                                const inputVal = event.target.value.replace(/\D/g, "");
                                const lengthRaw = posConfig?.customerMobileNumberLength;
                                const maxLen = Number(lengthRaw);
                                const isLengthValidNumber = !isNaN(maxLen) && Number.isInteger(maxLen) && maxLen > 0;

                                if (!isLengthValidNumber || inputVal.length <= maxLen) {
                                  setKeyboardInputFields({
                                    ...keyboardInputFields,
                                    editMobile: inputVal,
                                  });
                                  keyboard?.current?.setInput(inputVal);
                                  form.setFieldsValue({ editMobile: inputVal });
                                }
                              }}
                              onFocus={() => {
                                onFocusInput("editMobile");
                              }}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              id="sm-product-search"
                              className="customerDetailsInput"
                              placeholder="Enter Contact Number"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              maxLength={posConfig?.customerMobileNumberLength}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                          <Form.Item name="editPincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              className="customerDetailsInput"
                              onFocus={() => {
                                onFocusInput("editPincode");
                              }}
                              id="sm-product-search"
                              value={getInputValue("editPincode")}
                              onChange={onChangeInput}
                              placeholder="Enter Pincode"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </Scrollbars>
                  <Row>
                    <Col xs={{ span: 9 }} lg={{ span: 19 }} xl={{ span: 19 }} xxl={{ span: 19 }} />
                    <Col xs={{ span: 14 }} lg={{ span: 4 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
                      <Form.Item style={{ paddingTop: "3vh", fontSize: "1vw" }}>
                        <Button className="customerDetailsSubmitBtnBtn" style={data.posScreenStyles.addEditCustomerModal.customerDetailsSubmitBtn} onClick={editCustomer}>
                          Save & Proceed
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              ) : toggleCustomer ? (
                <Form key={"editCustomer"} form={form} name="editCustomer">
                  <Scrollbars
                    thumbSize={100}
                    // renderView={renderView}
                    renderThumbHorizontal={renderThumbHorizontalScroll}
                    renderThumbVertical={renderThumb}
                    style={{ height: open && showVirtualKeyboard ? "20vh" : "71vh" }}
                  >
                    <div style={{ display: toggleCustomer ? "block" : "none", fontSize: "1vw", overflowX: "hidden" }}>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginTop: "1.5vh", fontSize: "1vw" }}>
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>MAILING ADDRESS</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                          <Form.Item
                            name="street"
                            disabled={true}
                            rules={[{ required: true, message: "Please Input Street" }]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Street"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.line1 : cart?.customer?.customerAddress?.line1}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                          <Form.Item name="city" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="City"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.city : cart?.customer?.customerAddress?.city}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>State</label>
                          <Form.Item name="state" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter State"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.line2 : cart?.customer?.customerAddress?.region}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Country</label>
                          <Form.Item name="country" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Country"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.country : cart?.customer?.customerAddress?.country}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                          <Form.Item name="pincode" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Pincode"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.pincode : cart?.customer?.pincode}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", marginBottom: "1vh", marginTop: "1vh", width: "80.5vw" }}>
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>LOYALTY</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                          <Form.Item name="loyality" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Switch onChange={onSwitchChange} defaultChecked />
                            &nbsp; <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>Enable loyalty for this customer</span>
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                          {enableLoyality && (
                            <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                              <Select disabled={true} style={{ width: "27.5vw", height: "7vh" }}>
                                <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                                  {loyalityType[0]?.name}
                                </Option>
                              </Select>
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", marginBottom: "1vh", width: "80.5vw" }}>
                        <Col span={24}>
                          <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>GENERAL INFORMATION</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
                          <Form.Item name="anniversaryDate" disabled={true} style={{ border: "0" }}>
                            <DatePicker
                              disabled={true}
                              placeholder="DD/MM/YYYY"
                              className="cutomerDobInput"
                              format="DD/MM/YYYY"
                              style={{ height: "7.3vh", border: "none", marginTop: 10, width: "95%" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                          <Form.Item disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Tax ID"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.taxId : cart?.customer?.taxId}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Birthday</label>
                          <Form.Item name="birthday" disabled={true} style={{ border: "0", margin: "7px 0" }}>
                            <DatePicker disabled={true} placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                          <Form.Item name="gender" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Select size="large" className="genderSelect">
                              <Option key={"MAL"} value="MAL">
                                Male
                              </Option>
                              <Option key={"FEM"} value="FEM">
                                Female
                              </Option>
                              <Option key={"TRA"} value="TRA">
                                Transgender
                              </Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <div>
                        <Row>
                          <p style={{ fontSize: "1.1em", margin: 0, fontWeight: "600", color: "#0F0718" }}>Additional Information</p>
                          <div style={{ backgroundColor: "#fff", width: "80.6vw", fontSize: "1vw", marginTop: "1vh" }}>
                            <Col span={24}>
                              <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                                <Col span={12} className="addtInfo">
                                  Last Visit Date
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {selectedEditOldCustomer ? selectedEditOldCustomer.lastVisitDate : cart?.customer?.lastVisitDate}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                                <Col span={12} className="addtInfo">
                                  No Of Visits
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {selectedEditOldCustomer ? selectedEditOldCustomer.noOfVisits : cart?.customer?.noOfVisits}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                                <Col span={12} className="addtInfo">
                                  Last Billing Amount
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {selectedEditOldCustomer ? selectedEditOldCustomer.lastBillingAmount : cart?.customer.lastBillingAmount}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                                <Col span={12} className="addtInfo">
                                  Average Basket Value
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {selectedEditOldCustomer ? selectedEditOldCustomer.averageBasketValue : cart?.customer?.averageBasketValue}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                                <Col span={12} className="addtInfo">
                                  Loyalty Balance Points
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}
                                </Col>
                              </Row>
                              <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                                <Col span={12} className="addtInfo">
                                  Credit Balance
                                </Col>
                                <Col span={2}>:</Col>
                                <Col span={9} offset={1} className="addtInfo">
                                  {cart?.customer?.creditLimit ? cart?.customer?.creditLimit || " " : cart?.customer?.creditLimit || " "}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </Row>
                      </div>
                    </div>
                  </Scrollbars>
                </Form>
              ) : (
                <Form key={"viewCustomer"} form={form} name="viewForm">
                  <Scrollbars
                    thumbSize={100}
                    // renderView={renderView}
                    renderThumbHorizontal={renderThumbHorizontalScroll}
                    renderThumbVertical={renderThumb}
                    style={{ height: open && showVirtualKeyboard ? "20vh" : "61vh" }}
                  >
                    <div style={{ overflow: "hidden" }}>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                          <Form.Item disabled={true} name="editName" rules={[{ message: "Please Input Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Name"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.name : cart?.customer?.name}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                          <Form.Item disabled={true} name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Last Name"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={cart?.customer?.lastName ? cart?.customer?.lastName : selectedEditOldCustomer?.lastName}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                          <Form.Item
                            disabled={true}
                            name="editEmail"
                            rules={[
                              {
                                required: false,
                                pattern: new RegExp(/\S+@\S+\.\S+/),
                                message: "Please Input Valid Email",
                              },
                            ]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Email"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={""}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>
                          <Form.Item
                            disabled={true}
                            name="editMobile"
                            rules={[
                              {
                                required: false,
                                pattern: new RegExp(/^[6-9][0-9]{9}$/),
                                message: "Please Input Mobile",
                              },
                            ]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Contact Number"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.mobileNo : cart?.customer?.mobileNo}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                          <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                          <Form.Item
                            disabled={true}
                            name="editPincode"
                            rules={[
                              {
                                required: false,
                                pattern: new RegExp(/\d+/g),
                                message: "Please Input Pincode",
                              },
                            ]}
                            style={data.posScreenStyles.addEditCustomerModal.formItem}
                          >
                            <Input
                              disabled={true}
                              className="customerDetailsInput"
                              placeholder="Enter Pincode"
                              style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                              value={selectedEditOldCustomer ? selectedEditOldCustomer?.pincode : cart?.customer?.pincode}
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </Scrollbars>
                </Form>
              )}
            </>
          )}
        </Spin>
      </Drawer>
      {/* EDIT CUSTOMER MODAL END*/}

      {/* search for UAE customer start */}

      <Drawer
        placement="bottom"
        title={
          <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.5em", marginTop: "3.6vh", fontWeight: "500", color: "#0F0718", flex: 1, marginLeft: "36vw" }}>Search for UAE customer</p>
            <img src={closeX} onClick={closeCustomerSearch} style={{ marginLeft: "auto", paddingBottom: "4vh", paddingTop: "2vh", cursor: "pointer", width: "1.5vw" }} />
          </div>
        }
        visible={displayUAECustomerSearch}
        className="addCustomer"
        bodyStyle={{ paddingBottom: 0, paddingTop: 0 }}
        height="78vh"
      >
        <Row style={{ marginTop: "0.1%", height: "6.5vh", overflow: "hidden" }}>
          <Col span={24} style={{ padding: "0 5vw", fontSize: "1vw" }}>
            <Input
              ref={customerSearchInputRef}
              placeholder="Search"
              id="sm-product-search"
              size="large"
              style={data.posScreenStyles.customerModal.customerSearchInput}
              className="customerSearchInput"
              prefix={<img src={UserSearch} style={data.posScreenStyles.customerModal.searchIcon} />}
              suffix={<img src={CircleCloseIcon} alt="" style={data.posScreenStyles.customerModal.searchIcon} onClick={closeCustomerSearch} className="remove_btn" />}
              value={customerSearchInput === "" ? getInputValue("search") : customerSearchInput}
              onFocus={() => {
                customerSearchInputRef.current?.focus();
                onFocusInput("search");
              }}
              onChange={(e) => {
                onChangeInput(e);
                e.target.value === ""
                  ? (() => {
                      setCustomerSearchResults();
                      setCustomerSearchInput(e.target.value);
                    })()
                  : setCustomerSearchInput(e.target.value);
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: "1%" }}>
          <Col span={20} style={{ marginLeft: "5vw", fontSize: "1vw" }}>
            {customerSearchResults === undefined ? (
              <div style={data.posScreenStyles.header.left}>
                <div bordered style={data.posScreenStyles.customerModal.customerSearchListEmpty} />
              </div>
            ) : customerSearchResults !== undefined && customerSearchResults.length > 0 ? (
              <div style={data.posScreenStyles.header.left}>
                <div style={data.posScreenStyles.customerModal.customerSearchList}>
                  <p
                    style={{
                      textAlign: "left",
                      fontSize: "0.9em",
                      padding: "1vh 0 1vh 1vw",
                      fontWeight: "500",
                      color: "#0F0718",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                      margin: "0 2vw",
                    }}
                  >
                    Customers
                  </p>
                  <Scrollbars className="customerCardScroll">
                    {customerSearchResults.map((customerSearchResult, index) => (
                      <div
                        tabIndex={0}
                        onKeyPress={(e) => (e.charCode === 13 ? selectCustomer(index) : null)}
                        key={`${index}`}
                        style={data.posScreenStyles.customerModal.customerDropDownDetailsCard}
                      >
                        <Row
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderBottom: "1px solid #0000001F",
                            paddingBottom: "0.1%",
                            margin: "0 1.35vw",
                          }}
                        >
                          <Col span={1} style={{ paddingBottom: "1vh" }}>
                            <span
                              style={{
                                padding: "0.8vw 1.2vw",
                                backgroundColor: "rgba(146, 144, 152, 0.5)",
                                color: "rgba(15, 7, 24, 1)",
                                textAlign: "center",
                                borderRadius: "4px",
                                fontWeight: "500",
                                fontSize: "1.2em",
                              }}
                            >
                              {customerSearchResult.name.substring(0, 1)}
                            </span>
                          </Col>
                          <Col span={18} onClick={() => selectCustomer(index)} style={{ paddingLeft: "1.2vw" }}>
                            <p style={data.posScreenStyles.customerModal.customerName}>
                              {customerSearchResult.name} - {customerSearchResult.b2cCustomerSegment.name}
                            </p>
                            <p style={data.posScreenStyles.customerModal.customerStatus}>{customerSearchResult.mobileNo}</p>
                          </Col>
                          <Col
                            span={4}
                            style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "10px", paddingTop: "1vh", paddingBottom: "2.5vh" }}
                          >
                            <img onClick={() => showEditOldCustomerFields(customerSearchResult)} src={View} style={{ height: "3vh", marginRight: "5px" }} />
                            <img
                              onClick={() => {
                                showEditOldCustomerFields(customerSearchResult);
                                setEditFlag(true);
                              }}
                              src={EditIcon}
                              style={{ height: "3vh", marginRight: "5px", marginLeft: "0.5vw" }}
                            />
                            {/* <EditOutlined style={data.posScreenStyles.customerModal.dropdownCircleIcon} onClick={() => { showEditOldCustomerFields(customerSearchResult); setEditFlag(true); }} /> */}
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </Scrollbars>
                  <Row justify="center" align="center" style={{ position: "relative", bottom: "-4vh", fontSize: "1vw" }}>
                    <img src={CustomerIcon} alt="CustomerIcon" style={{ height: "1.7vh", alignSelf: "center", paddingRight: "0.5vw" }} />
                    <span style={data.posScreenStyles.customerModal.addNewCustomer} onClick={showAddNewUAECustomerFields}>
                      {getMultilingualText("Add Customer")}
                    </span>
                  </Row>
                </div>
              </div>
            ) : (
              <div style={data.posScreenStyles.header.left}>
                <div bordered style={data.posScreenStyles.customerModal.customerSearchListEmpty}>
                  <Row style={{ fontSize: "1vw" }}>
                    <p style={data.posScreenStyles.customerModal.noResultsText}>No results found</p>
                  </Row>
                  <Row justify="center" align="center">
                    <img src={CustomerIcon} alt="CustomerIcon" style={{ height: "1.7vh", alignSelf: "center", paddingRight: "0.5vw", paddingLeft: "5vw" }} />
                    <span style={data.posScreenStyles.customerModal.addNewCustomer} onClick={showAddNewUAECustomerFields}>
                      {getMultilingualText("Add Customer")}
                    </span>
                  </Row>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Drawer>

      {/* search for UAE customer end */}

      {/* Create UAE Customer Start */}

      <Drawer
        bodyStyle={{ padding: "0 24px" }}
        closable={false}
        placement="bottom"
        title={
          <div style={data.posScreenStyles.customerModal.customerDetailsCard}>
            <p
              style={{
                marginBottom: "0px",
                fontSize: "1.5em",
                marginTop: "1%",
                fontWeight: "500",
                color: "#0F0718",
                textAlign: "center",
              }}
            >
              UAE Customer
            </p>
            <img
              onClick={() => {
                setDisplayUAECustomer(false);
                UAECustomerForm.resetFields();
                setInputValues({
                  name: "",
                  lastName: "",
                  email: "",
                  mobile: "",
                  pincode: "",
                  street: "",
                  city: "",
                  pincode1: "",
                  taxID: "",
                  cardNumber: "",
                });
              }}
              style={{ cursor: "pointer", width: "1.5vw", position: "absolute", right: "0.5vw", top: "2vh" }}
              src={closeX}
              alt=""
            />
          </div>
        }
        visible={displayUAECustomer}
        className="addCustomer"
        onClose={() => {
          setDisplayUAECustomer(false);
          UAECustomerForm.resetFields();
        }}
        height="87vh"
      >
        <div>
          <Form key={"addCustomer"} form={UAECustomerForm} name="addCustomer" style={{ padding: "0 5%" }}>
            <Scrollbars renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: "58vh" }}>
              <div style={{ fontSize: "1vw" }}>
                <Row>
                  <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Type</label>
                    <Form.Item name="type" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Select size="large" className="genderSelect">
                        {registrationTypes?.map((type) => (
                          <Option key={type.value} value={type.value}>
                            {type.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0 2vw 0 4vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Card Number</label>
                    <Form.Item form={UAECustomerForm} name="cardNumber" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input
                        ref={refs.cardNumber}
                        value={getInputValue("cardNumber")}
                        onChange={onChangeInput}
                        onFocus={() => {
                          onFocusInput("cardNumber");
                        }}
                        id="sm-product-search"
                        className="customerDetailsInput"
                        placeholder="Card Number"
                        style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Validaity</label>
                    <Form.Item name="validaity" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <DatePicker style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                    </Form.Item>
                  </Col>

                  <Col span={12} style={{ padding: "0 2vw 0 4vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                    <Form.Item name="name" rules={[{ required: true, message: "Please Input First Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input
                        ref={refs.name}
                        value={getInputValue("name")}
                        onChange={onChangeInput}
                        onFocus={() => {
                          onFocusInput("name");
                        }}
                        id="sm-product-search"
                        className="customerDetailsInput"
                        placeholder="First Name"
                        style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "2.5vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                    <Form.Item form={UAECustomerForm} name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input
                        ref={refs.lastName}
                        value={getInputValue("lastName")}
                        onChange={onChangeInput}
                        onFocus={() => {
                          onFocusInput("lastName");
                        }}
                        id="sm-product-search"
                        className="customerDetailsInput"
                        placeholder="Last Name"
                        style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} style={{ padding: "0 2vw 0 4vw", marginTop: "4vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Phone Number (optional)</label>
                    <Form.Item
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          pattern: new RegExp(/^[0-9]\d*$/),
                          message: "Please Input Valid Phone Number",
                        },
                      ]}
                      style={data.posScreenStyles.addEditCustomerModal.formItem}
                    >
                      <Input
                        ref={refs.mobile}
                        value={getInputValue("mobile")}
                        onChange={onChangeInput}
                        onFocus={() => {
                          onFocusInput("mobile");
                        }}
                        id="sm-product-search"
                        className="customerDetailsInput"
                        placeholder="Enter Phone Number"
                        style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} style={{ padding: "0 2vw 0 2vw", marginTop: "4vh" }}>
                    <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email (optional)</label>
                    <Form.Item form={UAECustomerForm} name="email" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Input
                        ref={refs.email}
                        value={getInputValue("email")}
                        onChange={onChangeInput}
                        onFocus={() => {
                          onFocusInput("email");
                        }}
                        id="sm-product-search"
                        className="customerDetailsInput"
                        placeholder="Enter Email"
                        style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Scrollbars>
            <Row>
              <Col span={18} />
              <Col span={6} style={{ display: "flex", justifyContent: "space-evenly" }}>
                <Button
                  className="customerDetailsSubmitBtnBtn"
                  style={{ color: "#0F0718", width: "9vw", fontWeight: "500", borderRadius: "3px", background: "#ffffff", fontSize: "1em", height: "5.5vh" }}
                  onClick={() => setDisplayUAECustomer(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="customerDetailsSubmitBtnBtn"
                  style={{ color: "#ffffff", width: "9vw", fontWeight: "500", borderRadius: "3px", background: "#2F3856", fontSize: "1em", height: "5.5vh", paddingLeft: "1vw" }}
                  loading={customerLoading}
                  onClick={() => {
                    const value = UAECustomerForm.getFieldsValue();
                    addNewCustomer(value);
                    // setDisplayUAECustomer(false);
                    setCustomerSearchInput("");
                  }}
                >
                  Create
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>

      {/* Create UAE Customer End */}

      {/* PAYMENT MODAL BEGIN*/}
      <Modal visible={paymentModal} keyboard={false} closable={false} footer={null} width="60%" centered bodyStyle={{ padding: 0 }}>
        <Card bodyStyle={{ padding: 15 }}>
          <Row gutter={[10, 0]}>
            <Col span={12}>
              <Card style={data.posScreenStyles.restaurantPaymentModal.noBorderCard} bodyStyle={{ padding: "10px" }}>
                <div style={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                  {/*  <p className="para-margin" /> */}
                  <Row>
                    <Col span={24}>
                      <Scrollbars style={data.posScreenStyles.restaurantPaymentModal.scrollValue}>
                        {_.sortBy(tillDataPaymentMethods, "sequenceNo").map((pm, ind) => {
                          return posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty" ? null : (
                            <Card
                              key={pm?.finPaymentmethodId}
                              onClick={() => {
                                if (cart.items.length > 0) {
                                  setSelectedPaymentMethod(pm);
                                  openPaymentModalByCustomer();
                                }
                              }}
                              ref={ind === 0 ? paymentCardRef : null}
                              style={data.posScreenStyles.restaurantPaymentModal.noBorderCard}
                              tabIndex={0}
                              onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                              bodyStyle={{ padding: "0px", marginTop: "15px" }}
                            >
                              <Row>
                                <Col span={24}>
                                  <Card
                                    style={
                                      pm?.finPaymentmethodId === selectedPaymentMethod?.finPaymentmethodId
                                        ? data.posScreenStyles.restaurantPaymentModal.selectedPaymentType
                                        : data.posScreenStyles.restaurantPaymentModal.paymtCard
                                    }
                                    // className={
                                    //   pm.finPaymentmethodId ===
                                    //   selectedPaymentMethod.finPaymentmethodId
                                    //     ? "selectedPaymentType"
                                    //     : "paymt-card"
                                    // }
                                    bodyStyle={{ padding: "8px 0px" }}
                                  >
                                    <Row>
                                      <Col span={14}>
                                        <div style={{ display: "flex" }}>
                                          <img
                                            src={pm?.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? CashLogoWhite : CashLogo}
                                            style={data.posScreenStyles.restaurantPaymentModal.wfifty}
                                            alt=""
                                          />{" "}
                                          <p
                                            style={
                                              pm?.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId
                                                ? data.posScreenStyles.restaurantPaymentModal.selectedPaymentTypeName
                                                : data.posScreenStyles.restaurantPaymentModal.paymtName
                                            }
                                          >
                                            {pm.name}
                                          </p>
                                        </div>
                                        {cart.printedName && pm?.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? (
                                          <p style={{ color: "white", margin: 0 }}>
                                            {cart.printedName} -{" "}
                                            {currenciesList[0].symbolRightSide === "N" && pm?.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId
                                              ? currenciesList[0].currSymbol
                                              : ""}{" "}
                                            {cart.fee}
                                          </p>
                                        ) : null}
                                      </Col>

                                      <Col span={10} style={{ alignSelf: "center" }}>
                                        {(() => {
                                          const iN = cart?.payments?.findIndex((paymentMade) => paymentMade?.name === pm.name);
                                          if (iN >= 0) {
                                            return (
                                              <Row>
                                                <Col span={20}>
                                                  <span
                                                    style={
                                                      pm?.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId
                                                        ? data.posScreenStyles.restaurantPaymentModal.selectedPaymentTypeName
                                                        : data.posScreenStyles.restaurantPaymentModal.paymtName
                                                    }
                                                  >
                                                    {currenciesList[0]?.symbolRightSide === "N" ? pm.currSymbol : ""} {parseFloat(cart.payments[iN].amount).toFixed(2)}{" "}
                                                    {currenciesList[0].symbolRightSide === "Y" ? pm.currSymbol : ""}
                                                  </span>
                                                </Col>
                                                <Col span={4}>
                                                  <span style={data.posScreenStyles.restaurantPaymentModal.deleteIconSpan}>
                                                    <img
                                                      src={Delete}
                                                      onClick={() => requestPayment(cart.payments[iN], -cart.payments[iN].amount, "allow")}
                                                      style={data.posScreenStyles.restaurantPaymentModal.deleteIcon}
                                                      alt=""
                                                    />
                                                  </span>
                                                </Col>
                                              </Row>
                                            );
                                          }
                                        })()}
                                      </Col>
                                    </Row>
                                  </Card>
                                </Col>
                              </Row>
                            </Card>
                          );
                        })}
                      </Scrollbars>
                    </Col>
                  </Row>
                  <Row style={{ paddingTop: 10 }}>
                    <Button
                      type="dashed"
                      size="large"
                      disabled={cart.mPricingCouponId ? true : false}
                      onClick={() => setCouponModalVisible(true)}
                      className="add-payment-btn-white"
                      style={data.posScreenStyles.restaurantPaymentModal.addpaymentbtnWhite}
                    >
                      <TagsOutlined /> Apply Coupon
                    </Button>
                  </Row>
                </div>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                style={data.posScreenStyles.restaurantPaymentModal.noBorderCard}
                bodyStyle={{
                  padding: "10px",
                  /*  backgroundColor: "#F5F5F5",
                    borderRadius: "0px 0px 6px 6px", */
                }}
              >
                <Row style={{ marginBottom: 10 }}>
                  <Col span={12}>
                    {posConfig?.loyaltyApplicable === "Y" && (
                      <span style={data.posScreenStyles.restaurantPaymentModal.topayEntrAmt}>
                        Loyalty Bal:&nbsp;
                        <span
                          style={{
                            marginBottom: "0px",
                            color: "#030d1c",
                            fontSize: "1.5vw",
                          }}
                        >
                          {cart?.customer?.retlLoyaltyBalance || 0}
                        </span>
                      </span>
                    )}
                  </Col>
                  <Col span={12}>
                    <span style={data.posScreenStyles.restaurantPaymentModal.deleteIconSpan}>
                      <img src={closeIcon} alt="close" onClick={closePaymentModal} />
                    </span>
                  </Col>
                </Row>
                {/* <Row>
                  <Col offset={12} span={12}>
                    <br />
                  </Col>
                </Row> */}
                <Row>
                  <Col span={12}>
                    <span style={data.posScreenStyles.restaurantPaymentModal.cartTotalMethod}>{parseFloat(cart.total) >= parseFloat(cart.paid) ? "To Pay" : "Change"}</span>
                  </Col>
                  <Col span={12}>
                    <span style={data.posScreenStyles.restaurantPaymentModal.cartTotalValue}>
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      &nbsp;
                      {parseFloat(cart.total) >= parseFloat(cart.paid)
                        ? cart.convertionTotal !== undefined
                          ? cart.convertionTotal
                          : cart.total
                        : parseFloat(cart.changedValue).toFixed(2)}{" "}
                      {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </span>
                  </Col>
                </Row>
              </Card>
              <Card style={data.posScreenStyles.restaurantPaymentModal.noBorderCard} bodyStyle={{ padding: "10px" }}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <h3 style={data.posScreenStyles.restaurantPaymentModal.topayEntrAmt}>{paymentModalLoyalityMessages.inputMessage}</h3>
                  </Col>
                  {/* <p className="para-margin" /> */}
                  {/* <Row> */}
                  <Col span={24}>
                    <Input
                      ref={paymentModalInputRef}
                      value={amount}
                      onChange={onChangeAmount}
                      disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : cart.total < cart.paid ? true : false}
                      onPressEnter={parseFloat(cart.total) >= parseFloat(cart.paid) ? () => requestPayment(selectedPaymentMethod, amount) : () => processOrder()}
                      style={data.posScreenStyles.restaurantPaymentModal.topayInput}
                      size="large"
                    />
                  </Col>
                  {/* </Row> */}
                  {/* <p className="para-margin" /> */}
                  {/* <Row style={{ paddingTop: 10 }}> */}
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("1")}>
                        1
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("2")}>
                        2
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("3")}>
                        3
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("x")}>
                        <img src={Backspace} alt="back space" width={width <= 1024 ? 20 : 30} height={width <= 1024 ? 15 : 20} />
                      </button>
                    </AspectRatio>
                  </Col>
                  {/* </Row> */}
                  {/* <Row style={{ paddingTop: 15 }}> */}
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("4")}>
                        4
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("5")}>
                        5
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("6")}>
                        6
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount(".")}>
                        .
                      </button>
                    </AspectRatio>
                  </Col>
                  {/* </Row> */}
                  {/* <Row style={{ paddingTop: 15 }}> */}
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("7")}>
                        7
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("8")}>
                        8
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("9")}>
                        9
                      </button>
                    </AspectRatio>
                  </Col>
                  <Col span={6}>
                    <AspectRatio ratio="1">
                      <button className="amt-dial-btn" onClick={() => handleAmount("0")}>
                        0
                      </button>
                    </AspectRatio>
                  </Col>
                  {/* </Row> */}
                  {/* <p className="para-margin" /> */}
                  {/* <Row style={{ paddingTop: 18 }}> */}
                  {tillData.tillAccess.cwrTill.payNow === "Y" ? (
                    <Button
                      size="large"
                      onClick={parseFloat(cart.total) >= parseFloat(cart.paid) ? () => requestPayment(selectedPaymentMethod, amount) : () => processOrder()}
                      style={data.posScreenStyles.restaurantPaymentModal.addPaymentBtn}
                    >
                      {cart.items.length !== 0
                        ? parseFloat(cart.total) > parseFloat(cart.paid)
                          ? paymentModalLoyalityMessages.buttonText
                          : cart.payments.length > 0
                            ? "Order"
                            : paymentModalLoyalityMessages.buttonText
                        : "Payment Not Allowed !"}
                    </Button>
                  ) : null}
                  {tillData.tillAccess.cwrTill.layAway === "Y" ? (
                    <Button
                      size="large"
                      onClick={() => processOrder("layaway")}
                      style={{ ...data.posScreenStyles.restaurantPaymentModal.addPaymentBtn, backgroundColor: "#708090", border: "1px solid #708090" }}
                    >
                      {cart.items.length !== 0 ? "Layaway" : "Operation Not Allowed !"}
                    </Button>
                  ) : null}
                </Row>
              </Card>
            </Col>
          </Row>
        </Card>
      </Modal>
      {/* PAYMENT MODAL END*/}

      {/* ORDER HISTORY MODAL BEGIN*/}
      <Modal
        // visible={displayOrderHistory}
        closable={false}
        onCancel={() => setDisplayOrderHistory(false)}
        footer={null}
        // width="52%"
        bodyStyle={{ padding: "20px 15px 15px" }}
      >
        <Row gutter={[0, 8]}>
          <Col span={8}>
            <ArrowLeftOutlined style={data.posScreenStyles.orderHistoryModal.backArrowIcon} onClick={() => setDisplayOrderHistory(false)} />
          </Col>
          <Col span={16}>
            <p style={data.posScreenStyles.orderHistoryModal.orderHistoryModalTitle}>Order History</p>
          </Col>
        </Row>
        <Row gutter={[8, 0]}>
          <Col span={10}>
            <Select
              defaultValue="orderDocumentNo"
              suffixIcon={<CaretDownOutlined />}
              placeholder="Document"
              style={data.posScreenStyles.orderHistoryModal.orderHistoryAttribute}
              size="large"
              onChange={changeOrderHistorySearchType}
            >
              <Option value="orderDocumentNo">Document</Option>
              <Option value="orderCustomerSearchKey">Customer SearchKey</Option>
            </Select>
          </Col>
          <Col span={14}>
            <Input
              ref={orderHistorySearchInputRef}
              placeholder="Search"
              size="large"
              allowClear={false}
              style={data.posScreenStyles.orderHistoryModal.orderHistorySearchInput}
              onPressEnter={searchOrderHistory}
              value={orderHistoryInput}
              onChange={(e) => {
                e.target.value === "" ? showOrderHistory() : setOrderHistoryInput(e.target.value);
              }}
              suffix={<SearchOutlined onClick={searchOrderHistory} style={data.posScreenStyles.customerModal.searchIcon} />}
            />
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Tabs defaultActiveKey="1" centered style={data.posScreenStyles.orderHistoryModal.orderHistoryTabs}>
            <TabPane tab="All" key="1">
              <Row gutter={[8, 8]} style={{ margin: "0px" }}>
                <Card className="orderHistoryCard" style={data.posScreenStyles.cardDetails} bodyStyle={{ padding: 10 }}>
                  <Scrollbars className="orderHistoryScroll">
                    {orderHistoryDetails.map((item) => (
                      <Card
                        tabIndex={0}
                        onKeyDown={(e) => (e.keyCode === 13 ? showOrderHistoryLine(item.sOrderID) : null)}
                        key={item.documentno}
                        style={data.posScreenStyles.orderHistoryModal.oderHistoryDetailsCard}
                        bodyStyle={{ padding: 10 }}
                      >
                        <Row>
                          <Col span={11}>
                            <p style={data.posScreenStyles.orderHistoryModal.orderDate}>{item.orderTime}</p>
                          </Col>
                          <Col span={11}>
                            <p style={data.posScreenStyles.orderHistoryModal.orderCustomerName}>{item.cwrB2cCustomer?.name}</p>
                          </Col>
                          <Col span={2}>
                            <img
                              style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}
                              src={DropdownCircle}
                              alt=""
                              width={15}
                              height={15}
                              onClick={() => showOrderHistoryLine(item.sOrderID)}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <p style={data.posScreenStyles.orderHistoryModal.orderNum}>{item.documentno}</p>
                          </Col>
                          <Col span={10}>
                            <p style={data.posScreenStyles.orderHistoryModal.orderStatus}>{item.isSynced === 1 ? "Success" : "Pending"}</p>
                          </Col>
                          <Col span={2}></Col>
                        </Row>
                        {item.sOrderID === selectedOrderHistoryLine ? (
                          <Row>
                            <table style={data.posScreenStyles.orderHistoryModal.orderDetailsTable}>
                              <tr style={data.posScreenStyles.orderHistoryModal.orderDetailsTableHeader}>
                                <th>Description</th>
                                <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Qty</th>
                                <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Unit Price</th>
                                <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Net Total</th>
                              </tr>
                              {item.items.map((subItem, index) => (
                                <tr key={`${subItem.name}-${index}`} style={data.posScreenStyles.orderHistoryModal.orderDetailsData}>
                                  <td style={data.posScreenStyles.orderHistoryModal.orderDetailsDesc}>{subItem.name}</td>
                                  <td>{subItem.weight}</td>
                                  <td>{parseFloat(subItem.salePrice).toFixed(2)}</td>
                                  <td>{parseFloat(subItem.nettotal).toFixed(2)}</td>
                                </tr>
                              ))}
                            </table>
                            <Divider />
                            <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsTotalTaxes}>
                              <Col span={12}>
                                <p>Taxes</p>
                              </Col>
                              <Col span={12}>
                                <p style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}>{parseFloat(item.tax).toFixed(2)}</p>
                              </Col>
                            </Row>
                            <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsTotalTaxes}>
                              <Col span={12}>
                                <p>Total</p>
                              </Col>
                              <Col span={12}>
                                <p style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}>{parseFloat(item.total).toFixed(2)}</p>
                              </Col>
                            </Row>
                            <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsButtons}>
                              <Col span={24}>
                                <Button
                                  size="large"
                                  style={data.posScreenStyles.orderHistoryModal.rePrintBtn}
                                  onClick={() => (isPrintModeXML ? xmlPrint(item, "Duplicate Copy") : htmlPrint(item, "Duplicate Copy"))}
                                >
                                  Print
                                </Button>
                              </Col>
                              {/* <Col span={12}>
                                <Button size="large" style={data.posScreenStyles.orderHistoryModal.returnBtn}>
                                  Return
                                </Button>
                              </Col> */}
                            </Row>
                          </Row>
                        ) : (
                          ""
                        )}
                      </Card>
                    ))}
                  </Scrollbars>
                </Card>
              </Row>
            </TabPane>
            <TabPane tab="Success" key="2">
              <Row gutter={[8, 8]} style={{ margin: "0px" }}>
                <Card className="orderHistoryCard" style={data.posScreenStyles.cardDetails} bodyStyle={{ padding: 10 }}>
                  <Scrollbars className="orderHistoryScroll">
                    {orderHistoryDetails.map((item) =>
                      item.isSynced === 1 ? (
                        <Card key={item.documentno} style={data.posScreenStyles.orderHistoryModal.oderHistoryDetailsCard} bodyStyle={{ padding: 10 }}>
                          <Row>
                            <Col span={11}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderDate}>{item.orderTime}</p>
                            </Col>
                            <Col span={11}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderCustomerName}>{item.customer.name}</p>
                            </Col>
                            <Col span={2}>
                              <img
                                style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}
                                src={DropdownCircle}
                                alt=""
                                width={15}
                                height={15}
                                onClick={() => showOrderHistoryLine(item.sOrderID)}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderNum}>{item.documentno}</p>
                            </Col>
                            <Col span={10}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderStatus}>{item.isSynced === 1 ? "Success" : "Pending"}</p>
                            </Col>
                            <Col span={2}></Col>
                          </Row>
                          {item.sOrderID === selectedOrderHistoryLine ? (
                            <Row>
                              <table style={data.posScreenStyles.orderHistoryModal.orderDetailsTable}>
                                <tr style={data.posScreenStyles.orderHistoryModal.orderDetailsTableHeader}>
                                  <th>Description</th>
                                  <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Qty</th>
                                  <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Unit Price</th>
                                  <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Net Total</th>
                                </tr>
                                {item.items.map((subItem, index) => (
                                  <tr key={`${subItem.name}-${index}`} style={data.posScreenStyles.orderHistoryModal.orderDetailsData}>
                                    <td style={data.posScreenStyles.orderHistoryModal.orderDetailsDesc}>{subItem.name}</td>
                                    <td>{subItem.weight}</td>
                                    <td>{subItem.salePrice}</td>
                                    <td>{subItem.nettotal}</td>
                                  </tr>
                                ))}
                              </table>
                              <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsTotalTaxes}>
                                <Col span={12}>
                                  <p>Taxes</p>
                                </Col>
                                <Col span={12}>
                                  <p style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}>{parseFloat(item.tax).toFixed(2)}</p>
                                </Col>
                              </Row>
                              <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsTotalTaxes}>
                                <Col span={12}>
                                  <p>Total</p>
                                </Col>
                                <Col span={12}>
                                  <p style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}>{parseFloat(item.total).toFixed(2)}</p>
                                </Col>
                              </Row>
                              <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsButtons}>
                                <Col span={24}>
                                  <Button size="large" style={data.posScreenStyles.orderHistoryModal.rePrintBtn}>
                                    Print
                                  </Button>
                                </Col>
                                {/*  <Col span={12}>
                                  <Button size="large" style={data.posScreenStyles.orderHistoryModal.returnBtn}>
                                    Return
                                  </Button>
                                </Col> */}
                              </Row>
                            </Row>
                          ) : (
                            ""
                          )}
                        </Card>
                      ) : (
                        ""
                      )
                    )}
                  </Scrollbars>
                </Card>
              </Row>
            </TabPane>
            <TabPane tab="Pending" key="3">
              <Row gutter={[8, 8]} style={{ margin: "0px" }}>
                <Card className="orderHistoryCard" style={data.posScreenStyles.cardDetails} bodyStyle={{ padding: 10 }}>
                  <Scrollbars className="orderHistoryScroll">
                    <Button
                      style={data.posScreenStyles.orderHistoryModal.syncOrderBtn}
                      onClick={() => {
                        syncOrders("orderHistory");
                      }}
                    >
                      Sync Now
                    </Button>
                    {orderHistoryDetails.map((item) =>
                      parseInt(item.isSynced) === 0 || parseInt(item.isSynced) === 2 ? (
                        <Card key={item.documentno} style={data.posScreenStyles.orderHistoryModal.oderHistoryDetailsCard} bodyStyle={{ padding: 10 }}>
                          <Row>
                            <Col span={11}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderDate}>{item.orderTime}</p>
                            </Col>
                            <Col span={11}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderCustomerName}>{item.customer.name}</p>
                            </Col>
                            <Col span={2}>
                              <img
                                style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}
                                src={DropdownCircle}
                                alt=""
                                width={15}
                                height={15}
                                onClick={() => showOrderHistoryLine(item.sOrderID)}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderNum}>{item.documentno}</p>
                            </Col>
                            <Col span={10}>
                              <p style={data.posScreenStyles.orderHistoryModal.orderStatus}>{item.isSynced === 1 ? "Success" : "Pending"}</p>
                            </Col>
                            <Col span={2}></Col>
                          </Row>
                          {item.sOrderID === selectedOrderHistoryLine ? (
                            <Row>
                              <table style={data.posScreenStyles.orderHistoryModal.orderDetailsTable}>
                                <tr style={data.posScreenStyles.orderHistoryModal.orderDetailsTableHeader}>
                                  <th>Description</th>
                                  <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Qty</th>
                                  <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Unit Price</th>
                                  <th style={data.posScreenStyles.orderHistoryModal.orderDetailsTableTh}>Net Total</th>
                                </tr>
                                {item.items.map((subItem, index) => (
                                  <tr key={`${subItem.name}-${index}`} style={data.posScreenStyles.orderHistoryModal.orderDetailsData}>
                                    <td style={data.posScreenStyles.orderHistoryModal.orderDetailsDesc}>{subItem.name}</td>
                                    <td>{subItem.weight}</td>
                                    <td>{subItem.salePrice}</td>
                                    <td>{subItem.nettotal}</td>
                                  </tr>
                                ))}
                              </table>
                              <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsTotalTaxes}>
                                <Col span={12}>
                                  <p>Taxes</p>
                                </Col>
                                <Col span={12}>
                                  <p style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}>{parseFloat(item.tax).toFixed(2)}</p>
                                </Col>
                              </Row>
                              <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsTotalTaxes}>
                                <Col span={12}>
                                  <p>Total</p>
                                </Col>
                                <Col span={12}>
                                  <p style={data.posScreenStyles.orderHistoryModal.dropdownCircleIcon}>{parseFloat(item.total).toFixed(2)}</p>
                                </Col>
                              </Row>
                              <Row style={data.posScreenStyles.orderHistoryModal.orderDetailsButtons}>
                                <Col span={24}>
                                  <Button size="large" style={data.posScreenStyles.orderHistoryModal.rePrintBtn}>
                                    Print
                                  </Button>
                                </Col>
                                {/* <Col span={12}>
                                  <Button size="large" style={data.posScreenStyles.orderHistoryModal.returnBtn}>
                                    Return
                                  </Button>
                                </Col> */}
                              </Row>
                            </Row>
                          ) : (
                            ""
                          )}
                        </Card>
                      ) : (
                        ""
                      )
                    )}
                  </Scrollbars>
                </Card>
              </Row>
            </TabPane>
          </Tabs>
        </Row>
      </Modal>
      {/* ORDER HISTORY MODAL END*/}

      {/* PARKED BILLS MODAL BEGIN*/}
      <Modal
        // visible={displayParkedBillModal}
        closable={false}
        footer={null}
        bodyStyle={{ padding: "20px 15px 15px" }}
      >
        <div>
          <Row>
            <Col span={9}>
              <ArrowLeftOutlined style={data.posScreenStyles.orderHistoryModal.backArrowIcon} onClick={closeParkedBillModal} />
            </Col>
            <Col span={15}>
              <p style={data.posScreenStyles.parkedBillModal.parkedBillsHistoryModalTitle}>Parked Orders</p>
            </Col>
          </Row>
          <Row style={{ paddingBottom: "12px" }}>
            <Col span={24}>
              <Input
                placeholder={`Customer Search Key`}
                size="large"
                allowClear={false}
                style={data.posScreenStyles.orderHistoryModal.orderHistorySearchInput}
                onPressEnter={searchParkedBill}
                onChange={handleParkedBillSearchInput}
                value={parkedBillSearchInput}
                suffix={<SearchOutlined onClick={searchParkedBill} style={data.posScreenStyles.customerModal.searchIcon} />}
              />
            </Col>
          </Row>
          <Row>
            <Card className="orderHistoryCard" style={data.posScreenStyles.cardDetails} bodyStyle={{ padding: 10 }}>
              <Scrollbars className="orderHistoryScroll">
                {filterdParkedList?.map((item, index) => (
                  <Card
                    tabIndex={0}
                    onKeyDown={(e) => (e.keyCode === 13 ? selectParkedBill(item) : null)}
                    key={`${index + 1}`}
                    style={data.posScreenStyles.orderHistoryModal.oderHistoryDetailsCard}
                    bodyStyle={{ padding: 10 }}
                    onClick={() => selectParkedBill(item, "management")}
                  >
                    <Row>
                      <Col span={12}>
                        <p style={data.posScreenStyles.orderHistoryModal.orderDate}>{item.parkedTime}</p>
                      </Col>
                      <Col span={12}>
                        <p style={data.posScreenStyles.orderHistoryModal.orderCustomerName}>{index + 1}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12}>
                        <p style={data.posScreenStyles.orderHistoryModal.orderNum}>{item.parkedCart.customer.name}</p>
                      </Col>
                      <Col span={12}>
                        <p style={data.posScreenStyles.orderHistoryModal.orderStatus}>Parked</p>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </Scrollbars>
            </Card>
          </Row>
        </div>
      </Modal>
      {/* PARKED BILLS MODAL END*/}

      {/* modal for add on's starts */}

      <Drawer
        placement="bottom"
        height="75vh"
        closable={true}
        maskClosable={true}
        maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
        mask={true}
        onClose={handleAddOnModalClose}
        visible={layout !== "2" && displayAddOnSelection}
        headerStyle={{ display: "none" }}
        bodyStyle={{ padding: 0, background: "#fff" }}
        style={{ borderRadius: "12px 12px 0 0" }}
      >
        {/* PRODUCT HEADER */}
        <div style={{ padding: "15px" }}>
          <span style={{ fontSize: "1.3em", fontWeight: 500 }}>{selectedProduct?.name}</span>

          <span style={{ fontSize: "1.3em", fontWeight: 500, float: "right" }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            {selectedProduct?.sunitprice}
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </span>

          <p style={{ color: "#8f8f8f", marginTop: 5 }}>{selectedProduct?.description}</p>
        </div>

        {/* ADD-ON GROUPS */}
        <div style={{ height: "60vh", overflow: "auto", padding: "0 15px" }}>
          {addOnsList?.optionsList?.length > 0 &&
            Object.entries(_.groupBy(addOnsList.optionsList, (a) => a?.mAddonGroup?.name || "Others")).map(([groupName, items]) => {
              const min = Number(items[0]?.mAddonGroup?.minqty || 0);
              const max = Number(items[0]?.mAddonGroup?.maxqty || Infinity);

              return (
                <div key={groupName} style={{ marginBottom: 18 }}>
                  <div style={{ fontWeight: 500, marginBottom: 8 }}>
                    {groupName}
                    {min > 0 && <span style={{ color: "red" }}> *</span>}

                    <span style={{ float: "right", fontSize: "0.9em" }}>
                      {getGroupTotalQty(groupName)} / {max === Infinity ? "No Max Limit" : max}
                    </span>
                  </div>

                  {items.map((item) => {
                    const allowQty = item.mAddonGroup?.allowQtySelection === "Y";

                    return (
                      <Card
                        key={item.mProductAddOnId}
                        style={{
                          marginBottom: 10,
                          borderRadius: 5,
                          border: "1px solid #eee",
                        }}
                        bodyStyle={{ padding: 12 }}
                      >
                        <Row justify="space-between" align="middle">
                          {/* LEFT SIDE — checkbox + name */}
                          <Col span={12} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            {/* Checkbox ALWAYS shown */}
                            <Checkbox
                              checked={addonQty[item.mProductAddOnId] > 0}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const groupName = item.mAddonGroup?.name;
                                const groupItems = getGroupItems(groupName);
                                const max = Number(item.mAddonGroup?.maxqty || Infinity);
                                const allowQty = item.mAddonGroup?.allowQtySelection === "Y";

                                const currentTotalQty = groupItems.reduce((t, g) => t + (Number(addonQty[g.mProductAddOnId]) || 0), 0);

                                if (allowQty) {
                                  if (checked && currentTotalQty + 1 > max) {
                                    message.error(`You can select only ${max} items in ${groupName}`);
                                    return;
                                  }

                                  setAddonQty((prev) => ({
                                    ...prev,
                                    [item.mProductAddOnId]: checked ? 1 : 0,
                                  }));
                                  return;
                                }

                                const selectedCount = groupItems.reduce((t, g) => t + (addonQty[g.mProductAddOnId] > 0 ? 1 : 0), 0);

                                if (checked && selectedCount >= max) {
                                  message.error(`You can select only ${max} items in ${groupName}`);
                                  return;
                                }

                                setAddonQty((prev) => ({
                                  ...prev,
                                  [item.mProductAddOnId]: checked ? 1 : 0,
                                }));
                              }}
                            />

                            <span style={{ fontWeight: 500 }}>{item.name}</span>
                          </Col>

                          {/* RIGHT SIDE — qty controls ONLY when allowQtySelection = Y */}
                          <Col
                            span={12}
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            {allowQty ? (
                              <>
                                <Button size="small" onClick={() => decreaseAddonQty(item.mProductAddOnId)}>
                                  -
                                </Button>

                                <span>{addonQty[item.mProductAddOnId] || 0}</span>

                                <Button size="small" onClick={() => increaseAddonQty(item.mProductAddOnId, item.mAddonGroup?.name)}>
                                  +
                                </Button>
                              </>
                            ) : null}

                            {item.price > 0 && (
                              <span style={{ fontWeight: 500, marginLeft: 10 }}>
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {item.price}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                              </span>
                            )}
                          </Col>
                        </Row>
                      </Card>
                    );
                  })}
                </div>
              );
            })}
        </div>

        {/* ADD TO CART BUTTON */}
        <div
          style={{
            padding: 15,
            borderTop: "1px solid #ddd",
            background: "#fff",
            position: "sticky",
            bottom: 0,
          }}
        >
          <Button block size="large" type="primary" style={{ fontSize: "1.2em", height: 45, backgroundColor: "#2f3856" }} onClick={validateAddonSelection}>
            Add to Cart
          </Button>
        </div>
      </Drawer>

      {/* modal for add on's confirmation */}
      <Modal visible={isUpdatingAddon} centered onCancel={() => setIsUpdatingAddon(false)} footer={null}>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
          <Button
            style={{ backgroundColor: "#FFA500", color: "white", border: "none", width: "16vw", height: "" }}
            onClick={() => {
              setDisplayAddOnSelection(true);
              setIsUpdatingAddon(false);
              handleAddOnModal(selectedProduct, 1);
            }}
          >
            I'll choose
          </Button>
          <Button
            type="default"
            style={{ width: "16vw" }}
            onClick={() => {
              selectedProductInCart.qty = 1;
              setIsUpdatingAddon(false);
              addDefinedProductWithAddons(selectedProductInCart, 1);
            }}
          >
            Repeat The Same
          </Button>
        </div>
      </Modal>

      {/* Custom attributes modal form start */}

      <Modal visible={dynamicForm} onCancel={cancelDynamicModal} centered onOk={handleSubmit} title="Custom Attributes Form" style={{ backgroundColor: "#F3F4F9" }}>
        <Form form={dynamicModalForm} layout="vertical">
          <Scrollbars style={{ height: "40vh" }}>
            {Array.isArray(selectedProductInCart?.customAttributes)
              ? selectedProductInCart?.customAttributes?.map((field) => (
                  <Form.Item
                    key={field.name}
                    label={field.name}
                    name={field.name}
                    rules={[
                      {
                        required: field.mandatory === "Y",
                        message: `${field.name} is required!`,
                      },
                    ]}
                  >
                    {renderFormItem(field)}
                  </Form.Item>
                ))
              : null}
          </Scrollbars>
        </Form>
      </Modal>
      <PointOfSuperMarketModals
        customerSearchInputRef={customerSearchInputRef}
        customerSearchInput={customerSearchInput}
        setCustomerSearchInput={setCustomerSearchInput}
        customersData={customersData}
        setCustomersData={setCustomersData}
        showPayments={showPayments}
        setShowPayments={setShowPayments}
        currenciesData={currenciesData}
        setCurrenciesData={setCurrenciesData}
        setDenaminationsKeyboard={setDenaminationsKeyboard}
        denaminationsKeyboard={denaminationsKeyboard}
        handleCashPayment={handleCashPayment}
        requestPayment={requestPayment}
        handleAmount={handleAmount}
        amount={amount}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        isWalletFlag={isWalletFlag}
        setIswalletFlag={setIswalletFlag}
        setIsRefundWalletOpen={setIsRefundWalletOpen}
        isRefundWalletOpen={isRefundWalletOpen}
        realPrice={realPrice}
        setRealPrice={setRealPrice}
        setDisplayCustomerSearch={setDisplayCustomerSearch}
      />
    </Fragment>
  );
};

export default PointOfSaleCoreModals;
